{
 "updated": "2026-11-03T13:04:05.817Z",
 "labs": {
  "meta-llama": {
   "name": "Meta",
   "country": "US",
   "source": "registry"
  },
  "nanbeige": {
   "name": "Nanbeige LLM Lab (BOSS Zhipin)",
   "country": "CN",
   "source": "registry"
  },
  "ibm-granite": {
   "name": "IBM",
   "country": "US",
   "source": "registry"
  },
  "openbmb": {
   "name": "OpenBMB",
   "country": "CN",
   "source": "registry"
  },
  "mistralai": {
   "name": "Mistral AI",
   "country": "FR",
   "source": "registry"
  },
  "nvidia": {
   "name": "NVIDIA",
   "country": "US",
   "source": "registry"
  },
  "google": {
   "name": "Google",
   "country": "US",
   "source": "registry"
  },
  "llava-hf": {
   "name": "LLaVA (UW–Madison)",
   "country": "US",
   "source": "registry"
  },
  "qwen": {
   "name": "Alibaba",
   "country": "CN",
   "source": "registry"
  },
  "tencent": {
   "name": "Tencent",
   "country": "CN",
   "source": "registry"
  },
  "moonshotai": {
   "name": "Moonshot AI",
   "country": "CN",
   "source": "registry"
  },
  "baidu": {
   "name": "Baidu",
   "country": "CN",
   "source": "registry"
  },
  "xingchen-agi": {
   "name": "China Telecom",
   "country": "CN",
   "source": "registry"
  },
  "krafton": {
   "name": "KRAFTON",
   "country": "KR",
   "source": "registry"
  },
  "diffuspace": {
   "name": "DiffuSpace",
   "country": "CN",
   "source": "registry"
  },
  "liquidai": {
   "name": "Liquid AI",
   "country": "US",
   "source": "registry"
  },
  "openai": {
   "name": "OpenAI",
   "country": "US",
   "source": "registry"
  },
  "aleph-alpha": {
   "name": "Aleph Alpha",
   "country": "DE",
   "source": "registry"
  },
  "recursivesi": {
   "name": "Recursive",
   "country": "US",
   "source": "registry"
  },
  "stepfun-ai": {
   "name": "StepFun",
   "country": "CN",
   "source": "registry"
  },
  "poolside": {
   "name": "poolside",
   "country": "US",
   "source": "registry"
  },
  "coherelabs": {
   "name": "Cohere",
   "country": "CA",
   "source": "registry"
  },
  "thinkingmachines": {
   "name": "Thinking Machines Lab",
   "country": "US",
   "source": "registry"
  },
  "meta-models": {
   "name": "Meta",
   "country": "US",
   "source": "registry"
  },
  "minimaxai": {
   "name": "MiniMax",
   "country": "CN",
   "source": "registry"
  },
  "deepseek-ai": {
   "name": "DeepSeek",
   "country": "CN",
   "source": "registry"
  },
  "zai-org": {
   "name": "Z.ai",
   "country": "CN",
   "source": "registry"
  },
  "lgai-exaone": {
   "name": "LG AI Research",
   "country": "KR",
   "source": "registry"
  },
  "xiaomimimo": {
   "name": "Xiaomi",
   "country": "CN",
   "source": "registry"
  },
  "reflection": {
   "name": "Reflection AI",
   "country": "US",
   "source": "registry"
  },
  "ornith-ai": {
   "name": "DeepReinforce",
   "country": "US",
   "source": "registry"
  },
  "internlm": {
   "name": "Shanghai AI Lab",
   "country": "CN",
   "source": "registry"
  },
  "cloudflare": {
   "name": "Cloudflare",
   "country": "US",
   "source": "registry"
  },
  "jialinyyzz": {
   "name": "Stephen Yu (independent)",
   "source": "registry"
  },
  "autotrust": {
   "name": "AutoTrust AI",
   "country": "SG",
   "source": "registry"
  },
  "jetbrains": {
   "name": "JetBrains",
   "country": "CZ",
   "source": "registry"
  },
  "lightonai": {
   "name": "LightOn",
   "country": "FR",
   "source": "registry"
  },
  "xhtoken": {
   "name": "iFlytek",
   "country": "CN",
   "source": "registry"
  },
  "agnes-ai": {
   "name": "Agnes AI",
   "country": "SG",
   "source": "registry"
  },
  "microsoft": {
   "name": "Microsoft",
   "country": "US",
   "source": "registry"
  },
  "inclusionai": {
   "name": "Ant Group",
   "country": "CN",
   "source": "registry"
  },
  "internscience": {
   "name": "Shanghai AI Lab",
   "country": "CN",
   "source": "registry"
  },
  "sensenova": {
   "name": "SenseNova",
   "source": "unknown"
  },
  "xiaomi-research": {
   "name": "Xiaomi Research",
   "country": "CN",
   "source": "epoch"
  },
  "divagr1925": {
   "name": "Divyansh Agrawal",
   "source": "unknown"
  }
 },
 "models": {
  "llama-3.1-8b": {
   "name": "Llama 3.1 8B",
   "repo": "meta-llama/Llama-3.1-8B-Instruct",
   "lab": "meta-llama",
   "params": 8,
   "released": "2024-07-18",
   "license": "llama3.1",
   "gated": true,
   "hf": {
    "likes": 8756,
    "downloads": 4463539
   },
   "ollama": {
    "name": "llama3.1",
    "tag": "8b",
    "pulls": 120791266,
    "sizes": [
     "8b",
     "70b",
     "405b"
    ],
    "bytes": 4920738944,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "LlamaForCausalLM",
    "recipe": "https://recipes.vllm.ai/meta-llama/Llama-3.1-8B-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Llama-3.1-8B-Instruct-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Meta-Llama-3.1-8B-Instruct-GGUF",
    "files": {
     "IQ2_M": 2948285856,
     "IQ3_M": 3784828320,
     "IQ3_XS": 3518752160,
     "IQ4_NL": 4677993888,
     "IQ4_XS": 4447667616,
     "Q2_K": 3179136416,
     "Q2_K_L": 3692160416,
     "Q3_K_L": 4321961376,
     "Q3_K_M": 4018922912,
     "Q3_K_S": 3664504224,
     "Q3_K_XL": 4781630880,
     "Q4_0_4_4": 4661216672,
     "Q4_0_4_8": 4661216672,
     "Q4_0_8_8": 4661216672,
     "Q4_K_L": 5310637472,
     "Q4_K_M": 4920739232,
     "Q4_K_S": 4692673952,
     "Q5_K_L": 6057223584,
     "Q5_K_M": 5732992416,
     "Q5_K_S": 5599298976,
     "Q6_K": 6596011424,
     "Q6_K_L": 6850471328,
     "Q8_0": 8540775840,
     "F32": 32128885888
    }
   },
   "eci": {
    "score": 116,
    "name": "Llama 3.1-8B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.02,
      "output": 0.05,
      "tps": 169,
      "ttftMs": 524,
      "context": 16384
     },
     {
      "name": "DeepInfra",
      "input": 0.02,
      "output": 0.05,
      "tps": 35,
      "ttftMs": 312,
      "context": 131072
     },
     {
      "name": "Nscale",
      "input": 0.06,
      "output": 0.06,
      "tps": 119,
      "ttftMs": 421,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/Meta-Llama-3.1-8B-Instruct-GGUF",
     "kv": "match",
     "ours": 131072,
     "theirs": 131072
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.9
    },
    "languages": [
     "en",
     "de",
     "fr",
     "it",
     "pt",
     "hi",
     "es",
     "th"
    ],
    "cutoff": "2023-12-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Llama 3.1-8B",
     "flop": 1.224e+24,
     "confidence": "Likely"
    }
   }
  },
  "llama-3-8b": {
   "name": "Llama 3 8B",
   "repo": "meta-llama/Meta-Llama-3-8B-Instruct",
   "lab": "meta-llama",
   "params": 8,
   "released": "2024-04-18",
   "license": "llama3",
   "gated": true,
   "hf": {
    "likes": 5683,
    "downloads": 317893
   },
   "ollama": {
    "name": "llama3",
    "tag": "8b",
    "pulls": 25884518,
    "sizes": [
     "8b",
     "70b"
    ],
    "bytes": 4661211424,
    "quant": "Q4_0"
   },
   "engines": {
    "arch": "LlamaForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "weber50432/lora-Meta-Llama-3-8B-Instruct"
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/Meta-Llama-3-8B-Instruct-GGUF",
    "files": {
     "IQ1_M": 2162484448,
     "IQ1_S": 2020140256,
     "IQ2_XS": 2606294240,
     "IQ3_XS": 3519259872,
     "IQ4_XS": 4448175328,
     "Q2_K": 3179644128,
     "Q3_K_L": 4322469088,
     "Q3_K_M": 4019430624,
     "Q3_K_S": 3665011936,
     "Q4_K_M": 4921246944,
     "Q4_K_S": 4693181664,
     "Q5_K_M": 5733500128,
     "Q5_K_S": 5599806688,
     "Q6_K": 6596519136,
     "Q8_0": 8541283552
    }
   },
   "eci": {
    "score": 116,
    "name": "Llama 3-8B"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "MaziyarPanahi/Meta-Llama-3-8B-Instruct-GGUF",
     "kv": "match",
     "ours": 131072,
     "theirs": 131072
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.9
    },
    "languages": [
     "en"
    ],
    "training": {
     "name": "Llama 3-8B",
     "flop": 7.2e+23,
     "tokens": 15000000000000,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "confidence": "Confident"
    }
   }
  },
  "llama-3.2-3b": {
   "name": "Llama 3.2 3B",
   "repo": "meta-llama/Llama-3.2-3B-Instruct",
   "lab": "meta-llama",
   "params": 3.2,
   "released": "2024-09-25",
   "license": "llama3.2",
   "gated": true,
   "hf": {
    "likes": 2932,
    "downloads": 995167
   },
   "ollama": {
    "name": "llama3.2",
    "tag": "3b",
    "pulls": 86816781,
    "sizes": [
     "1b",
     "3b"
    ],
    "bytes": 2019377376,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "LlamaForCausalLM",
    "recipe": "https://recipes.vllm.ai/meta-llama/Llama-3.2-3B-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlxRepo": "mlx-community/Llama-3.2-3B-Instruct"
   },
   "ggufFiles": {
    "repo": "unsloth/Llama-3.2-3B-Instruct-GGUF",
    "files": {
     "BF16": 6433687744,
     "F16": 6433687616,
     "IQ4_NL": 1917190592,
     "IQ4_XS": 1829110208,
     "Q2_K": 1363935680,
     "Q2_K_L": 1363935680,
     "Q3_K_M": 1687159232,
     "Q3_K_S": 1542848960,
     "Q4_0": 1921909184,
     "Q4_1": 2093351360,
     "Q4_K_M": 2019377600,
     "Q4_K_S": 1928200640,
     "Q5_K_M": 2322153920,
     "Q5_K_S": 2269512128,
     "Q6_K": 2643853760,
     "Q8_0": 3421898816,
     "UD-IQ1_M": 960416192,
     "UD-IQ1_S": 912345536,
     "UD-IQ2_M": 1256262080,
     "UD-IQ2_XXS": 1046579648,
     "UD-IQ3_XXS": 1370147264,
     "UD-Q2_K_XL": 1403380160,
     "UD-Q3_K_XL": 1742430656,
     "UD-Q4_K_XL": 2060886464,
     "UD-Q5_K_XL": 2327781824,
     "UD-Q6_K_XL": 2967833024,
     "UD-Q8_K_XL": 4204153280
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Llama-3.2-3B-Instruct-GGUF",
     "kv": "match",
     "ours": 114688,
     "theirs": 114688
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "languages": [
     "en",
     "de",
     "fr",
     "it",
     "pt",
     "hi",
     "es",
     "th"
    ],
    "cutoff": "2023-12-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Llama 3.2 3B",
     "flop": 1.7334e+23,
     "tokens": 9000000000000,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "confidence": "Confident"
    }
   }
  },
  "nanbeige4.3-33b": {
   "name": "Nanbeige4.3 33B",
   "repo": "Nanbeige/Nanbeige4.3-33B",
   "lab": "nanbeige",
   "params": 33.1,
   "released": "2026-10-24",
   "license": "apache-2.0",
   "hf": {
    "likes": 1017,
    "downloads": 17839
   },
   "modelscope": "nanbeige/Nanbeige4.3-33B",
   "engines": {
    "arch": "LlamaForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "Nurymanau/Nanbeige4.3-33B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Nanbeige_Nanbeige4.3-33B-GGUF",
    "files": {
     "IQ2_M": 12187167872,
     "IQ2_S": 11150560384,
     "IQ2_XS": 10634407040,
     "IQ2_XXS": 10071403648,
     "IQ3_M": 17802005632,
     "IQ3_XS": 15212665984,
     "IQ3_XXS": 14489959552,
     "IQ4_NL": 20871343232,
     "IQ4_XS": 18635041920,
     "Q2_K": 13528816768,
     "Q3_K_L": 17270484096,
     "Q3_K_M": 15919746176,
     "Q3_K_S": 15211261056,
     "Q4_0": 19348057216,
     "Q4_1": 21200497792,
     "Q4_K_L": 22344395904,
     "Q4_K_M": 20788825216,
     "Q4_K_S": 19740519552,
     "Q5_K_M": 25073368192,
     "Q5_K_S": 23664311424,
     "Q6_K": 29016857728,
     "Q6_K_L": 30404324480,
     "Q6_K_S": 27750272128,
     "Q8_0": 35195128960,
     "BF16": 66243464192
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/Nanbeige_Nanbeige4.3-33B-GGUF",
     "kv": "match",
     "ours": 212992,
     "theirs": 212992
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "granite-4.2-30b": {
   "name": "Granite 4.2 30B",
   "repo": "ibm-granite/granite-4.2-30b",
   "lab": "ibm-granite",
   "params": 29.3,
   "released": "2026-08-25",
   "license": "apache-2.0",
   "hf": {
    "likes": 140,
    "downloads": 32468
   },
   "ollama": {
    "name": "granite4.2",
    "tag": "30b",
    "pulls": 250474,
    "sizes": [
     "3b",
     "8b",
     "30b"
    ],
    "bytes": 17721455328,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "GraniteForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "ibm-granite/granite-4.2-30b-q4-mlx"
   },
   "ggufFiles": {
    "repo": "ibm-granite/granite-4.2-30b-GGUF",
    "files": {
     "Q2_K": 10858656480,
     "Q3_K_L": 15306519264,
     "Q3_K_M": 14133162720,
     "Q3_K_S": 12745896672,
     "Q4_0": 16579556064,
     "Q4_1": 18383631072,
     "Q4_K_M": 17721455328,
     "Q4_K_S": 16715870944,
     "Q5_0": 20187706080,
     "Q5_1": 21991781088,
     "Q5_K_M": 20775957216,
     "Q5_K_S": 20187706080,
     "Q6_K": 24021365472,
     "Q8_0": 31111705312,
     "BF16": 58558182336
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.16,
      "output": 0.65,
      "tps": 108,
      "ttftMs": 195,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "ibm-granite/granite-4.2-30b-GGUF",
     "kv": "match",
     "ours": 262144,
     "theirs": 262144
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "de",
     "es",
     "fr",
     "ja",
     "pt",
     "ar",
     "cs",
     "it",
     "ko",
     "nl",
     "zh"
    ]
   }
  },
  "granite-4.2-8b": {
   "name": "Granite 4.2 8B",
   "repo": "ibm-granite/granite-4.2-8b",
   "lab": "ibm-granite",
   "params": 8.8,
   "released": "2026-08-25",
   "license": "apache-2.0",
   "hf": {
    "likes": 112,
    "downloads": 70418
   },
   "ollama": {
    "name": "granite4.2",
    "tag": "8b",
    "pulls": 250474,
    "sizes": [
     "3b",
     "8b",
     "30b"
    ],
    "bytes": 5347917952,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "GraniteForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "ibm-granite/granite-4.2-8b-q4-mlx"
   },
   "ggufFiles": {
    "repo": "ibm-granite/granite-4.2-8b-GGUF",
    "files": {
     "Q2_K": 3412312192,
     "Q3_K_L": 4699897984,
     "Q3_K_M": 4347052160,
     "Q3_K_S": 3942957184,
     "Q4_0": 5055955072,
     "Q4_1": 5579718784,
     "Q4_K_M": 5347917952,
     "Q4_K_S": 5090820224,
     "Q5_0": 6103482496,
     "Q5_1": 6627246208,
     "Q5_K_M": 6253887616,
     "Q5_K_S": 6103482496,
     "Q6_K": 7216480384,
     "Q8_0": 9345613952,
     "BF16": 17587421312
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.06,
      "output": 0.25,
      "tps": 139,
      "ttftMs": 290,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "ibm-granite/granite-4.2-8b-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "de",
     "es",
     "fr",
     "ja",
     "pt",
     "ar",
     "cs",
     "it",
     "ko",
     "nl",
     "zh"
    ]
   }
  },
  "granite-4.2-3b": {
   "name": "Granite 4.2 3B",
   "repo": "ibm-granite/granite-4.2-3b",
   "lab": "ibm-granite",
   "params": 3.7,
   "released": "2026-08-25",
   "license": "apache-2.0",
   "hf": {
    "likes": 127,
    "downloads": 33072
   },
   "ollama": {
    "name": "granite4.2",
    "tag": "3b",
    "pulls": 250474,
    "sizes": [
     "3b",
     "8b",
     "30b"
    ],
    "bytes": 2244012160,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "GraniteForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "ibm-granite/granite-4.2-3b-q4-mlx"
   },
   "ggufFiles": {
    "repo": "ibm-granite/granite-4.2-3b-GGUF",
    "files": {
     "Q2_K": 1455736352,
     "Q3_K_L": 1974576672,
     "Q3_K_M": 1835968032,
     "Q3_K_S": 1677207072,
     "Q4_0": 2129118752,
     "Q4_1": 2341783072,
     "Q4_K_M": 2244011552,
     "Q4_K_S": 2142881312,
     "Q5_0": 2554447392,
     "Q5_1": 2767111712,
     "Q5_K_M": 2613634592,
     "Q5_K_S": 2554447392,
     "Q6_K": 3006359072,
     "Q8_0": 3892651552,
     "BF16": 7323461152
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.03,
      "output": 0.12,
      "tps": 139,
      "ttftMs": 350,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "ibm-granite/granite-4.2-3b-GGUF",
     "kv": "match",
     "ours": 81920,
     "theirs": 81920
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "de",
     "es",
     "fr",
     "ja",
     "pt",
     "ar",
     "cs",
     "it",
     "ko",
     "nl",
     "zh"
    ]
   }
  },
  "minicpm5-2b": {
   "name": "MiniCPM5 2B",
   "repo": "openbmb/MiniCPM5-2B",
   "lab": "openbmb",
   "params": 2.5,
   "released": "2026-09-06",
   "license": "apache-2.0",
   "hf": {
    "likes": 1832,
    "downloads": 1067287
   },
   "modelscope": "OpenBMB/MiniCPM5-2B",
   "engines": {
    "arch": "LlamaForCausalLM",
    "recipe": "https://recipes.vllm.ai/openbmb/MiniCPM5-2B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install \"vllm>=0.21\"",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/MiniCPM5-2B-mlx-4Bit"
   },
   "ggufFiles": {
    "repo": "bartowski/MiniCPM5-2B-GGUF",
    "files": {
     "IQ2_M": 969755872,
     "IQ3_M": 1362734304,
     "IQ3_XS": 1193749728,
     "IQ3_XXS": 1143844064,
     "IQ4_NL": 1605668064,
     "IQ4_XS": 1463942368,
     "Q2_K": 1014320352,
     "Q3_K_L": 1287011552,
     "Q3_K_M": 1236085984,
     "Q3_K_S": 1189694688,
     "Q4_0": 1516997856,
     "Q4_1": 1648135392,
     "Q4_K_L": 1714719968,
     "Q4_K_M": 1615826144,
     "Q4_K_S": 1534004448,
     "Q5_K_M": 1920175328,
     "Q5_K_S": 1816530144,
     "Q6_K": 2107305184,
     "Q6_K_L": 2278976736,
     "Q8_0": 2679712992,
     "BF16": 5039008704
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/MiniCPM5-2B-GGUF",
     "kv": "match",
     "ours": 43008,
     "theirs": 43008
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2602.09003",
      "title": "Data Science and Technology Towards AGI Part I: Tiered Data Management",
      "date": "2026-02-09"
     },
     {
      "id": "2506.07900",
      "title": "MiniCPM4: Ultra-Efficient LLMs on End Devices",
      "date": "2025-06-09"
     }
    ]
   }
  },
  "minicpm5-1b": {
   "name": "MiniCPM5 1B",
   "repo": "openbmb/MiniCPM5-1B",
   "lab": "openbmb",
   "params": 1.1,
   "released": "2026-05-21",
   "license": "apache-2.0",
   "hf": {
    "likes": 1178,
    "downloads": 273109
   },
   "modelscope": "OpenBMB/MiniCPM5-1B",
   "engines": {
    "arch": "LlamaForCausalLM",
    "recipe": "https://recipes.vllm.ai/openbmb/MiniCPM5-1B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install \"vllm>=0.21\"",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/MiniCPM5-1B-OptiQ-4bit"
   },
   "ggufFiles": {
    "repo": "NANI-Nithin/MiniCPM5-1B-GGUF",
    "files": {
     "BF16": 2166553184,
     "IQ1_M": 366263168,
     "IQ1_S": 352826240,
     "IQ2_M": 459989888,
     "IQ2_S": 442073984,
     "IQ2_XS": 408933248,
     "IQ2_XXS": 388658048,
     "IQ3_M": 562176896,
     "IQ3_S": 549329792,
     "IQ3_XS": 533404544,
     "IQ3_XXS": 489517952,
     "IQ4_NL": 666133376,
     "IQ4_XS": 638927744,
     "Q1_0": 293696384,
     "Q2_0": 473850752,
     "Q2_K": 485831264,
     "Q2_K_S": 465888128,
     "Q3_K_L": 613767776,
     "Q3_K_M": 582900320,
     "Q3_K_S": 548076128,
     "Q4_0": 664953440,
     "Q4_1": 719954528,
     "Q4_K_M": 688067168,
     "Q4_K_S": 667804256,
     "Q5_0": 774955616,
     "Q5_1": 829956704,
     "Q5_K_M": 786862688,
     "Q5_K_S": 774955616,
     "Q6_K": 891832928,
     "Q8_0": 1153530464
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "NANI-Nithin/MiniCPM5-1B-GGUF",
     "kv": "match",
     "ours": 24576,
     "theirs": 24576
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.9,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2602.09003",
      "title": "Data Science and Technology Towards AGI Part I: Tiered Data Management",
      "date": "2026-02-09"
     },
     {
      "id": "2506.07900",
      "title": "MiniCPM4: Ultra-Efficient LLMs on End Devices",
      "date": "2025-06-09"
     }
    ]
   }
  },
  "ministral-3-14b": {
   "name": "Ministral 3 14B",
   "repo": "mistralai/Ministral-3-14B-Instruct-2512",
   "lab": "mistralai",
   "params": 14,
   "released": "2025-12-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 351,
    "downloads": 155356
   },
   "ollama": {
    "name": "ministral-3",
    "tag": "14b",
    "pulls": 1573291,
    "sizes": [
     "3b",
     "8b",
     "14b"
    ],
    "bytes": 9082522240,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/mistralai/Ministral-3-14B-Instruct-2512",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/mistralai_Ministral-3-14B-Instruct-2512-MLX-MXFP4"
   },
   "ggufFiles": {
    "repo": "unsloth/Ministral-3-14B-Instruct-2512-GGUF",
    "files": {
     "BF16": 27020865952,
     "IQ4_NL": 7805711040,
     "IQ4_XS": 7432155840,
     "Q2_K": 5246530240,
     "Q2_K_L": 5403816640,
     "Q3_K_M": 6682096320,
     "Q3_K_S": 6074905280,
     "Q4_0": 7805711040,
     "Q4_1": 8581657280,
     "Q4_K_M": 8239067840,
     "Q4_K_S": 7834546880,
     "Q5_K_M": 9620566720,
     "Q5_K_S": 9383817920,
     "Q6_K": 11088409280,
     "Q8_0": 14359311040,
     "UD-IQ1_M": 3671126720,
     "UD-IQ1_S": 3441750720,
     "UD-IQ2_M": 4912132800,
     "UD-IQ2_XXS": 4057379520,
     "UD-IQ3_XXS": 5493437120,
     "UD-Q2_K_XL": 5527106240,
     "UD-Q3_K_XL": 6931092160,
     "UD-Q4_K_XL": 8366207680,
     "UD-Q5_K_XL": 9640104640,
     "UD-Q6_K_XL": 12124533440,
     "UD-Q8_K_XL": 17116738240
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Ministral-3-14B-Instruct-2512-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "sampling": {
     "source": "openrouter",
     "temperature": 0.3
    },
    "languages": [
     "en",
     "fr",
     "es",
     "de",
     "it",
     "pt",
     "nl",
     "zh",
     "ja",
     "ko",
     "ar"
    ],
    "papers": [
     {
      "id": "2601.08584",
      "title": "Ministral 3",
      "date": "2026-01-13"
     }
    ]
   }
  },
  "ministral-3-8b": {
   "name": "Ministral 3 8B",
   "repo": "mistralai/Ministral-3-8B-Instruct-2512",
   "lab": "mistralai",
   "params": 8.9,
   "released": "2025-12-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 236,
    "downloads": 99973
   },
   "ollama": {
    "name": "ministral-3",
    "tag": "8b",
    "pulls": 1573291,
    "sizes": [
     "3b",
     "8b",
     "14b"
    ],
    "bytes": 6022221312,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/mistralai/Ministral-3-8B-Instruct-2512",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Ministral-3-8B-Instruct-2512"
   },
   "ggufFiles": {
    "repo": "unsloth/Ministral-3-8B-Instruct-2512-GGUF",
    "files": {
     "BF16": 16987559168,
     "IQ4_NL": 4940469792,
     "IQ4_XS": 4713190944,
     "Q2_K": 3352925728,
     "Q2_K_L": 3478754848,
     "Q3_K_M": 4242052640,
     "Q3_K_S": 3866465824,
     "Q4_0": 4937324064,
     "Q4_1": 5419669024,
     "Q4_K_M": 5198386720,
     "Q4_K_S": 4954101280,
     "Q5_K_M": 6058743328,
     "Q5_K_S": 5916694048,
     "Q6_K": 6972872224,
     "Q8_0": 9028867616,
     "UD-IQ1_M": 2411238944,
     "UD-IQ1_S": 2276824608,
     "UD-IQ2_M": 3168114208,
     "UD-IQ2_XXS": 2637010464,
     "UD-IQ3_XXS": 3502216736,
     "UD-Q2_K_XL": 3565262368,
     "UD-Q3_K_XL": 4432664096,
     "UD-Q4_K_XL": 5288072736,
     "UD-Q5_K_XL": 6072243744,
     "UD-Q6_K_XL": 7724570144,
     "UD-Q8_K_XL": 11093251616
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Ministral-3-8B-Instruct-2512-GGUF",
     "kv": "match",
     "ours": 139264,
     "theirs": 139264
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "sampling": {
     "source": "openrouter",
     "temperature": 0.3
    },
    "languages": [
     "en",
     "fr",
     "es",
     "de",
     "it",
     "pt",
     "nl",
     "zh",
     "ja",
     "ko",
     "ar"
    ],
    "papers": [
     {
      "id": "2601.08584",
      "title": "Ministral 3",
      "date": "2026-01-13"
     }
    ]
   }
  },
  "ministral-3-3b": {
   "name": "Ministral 3 3B",
   "repo": "mistralai/Ministral-3-3B-Instruct-2512",
   "lab": "mistralai",
   "params": 3.9,
   "released": "2025-12-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 316,
    "downloads": 74088
   },
   "ollama": {
    "name": "ministral-3",
    "tag": "3b",
    "pulls": 1573291,
    "sizes": [
     "3b",
     "8b",
     "14b"
    ],
    "bytes": 2953825504,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/mistralai/Ministral-3-3B-Instruct-2512",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Ministral-3-3B-Instruct-2512"
   },
   "ggufFiles": {
    "repo": "unsloth/Ministral-3-3B-Instruct-2512-GGUF",
    "files": {
     "BF16": 6866220032,
     "IQ4_NL": 2051290400,
     "IQ4_XS": 1959277856,
     "Q2_K": 1458959648,
     "Q2_K_L": 1458959648,
     "Q3_K_M": 1795552544,
     "Q3_K_S": 1639150880,
     "Q4_0": 2046375200,
     "Q4_1": 2230203680,
     "Q4_K_M": 2146497824,
     "Q4_K_S": 2053256480,
     "Q5_K_M": 2473653536,
     "Q5_K_S": 2419340576,
     "Q6_K": 2821256480,
     "Q8_0": 3651679520,
     "UD-IQ1_M": 1019196704,
     "UD-IQ1_S": 969159968,
     "UD-IQ2_M": 1339888928,
     "UD-IQ2_XXS": 1108948256,
     "UD-IQ3_XXS": 1457804576,
     "UD-Q2_K_XL": 1492333856,
     "UD-Q3_K_XL": 1856083232,
     "UD-Q4_K_XL": 2191963424,
     "UD-Q5_K_XL": 2479158560,
     "UD-Q6_K_XL": 3174757664,
     "UD-Q8_K_XL": 4501026080
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Ministral-3-3B-Instruct-2512-GGUF",
     "kv": "match",
     "ours": 106496,
     "theirs": 106496
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "sampling": {
     "source": "openrouter",
     "temperature": 0.3
    },
    "languages": [
     "en",
     "fr",
     "es",
     "de",
     "it",
     "pt",
     "nl",
     "zh",
     "ja",
     "ko",
     "ar"
    ],
    "papers": [
     {
      "id": "2601.08584",
      "title": "Ministral 3",
      "date": "2026-01-13"
     }
    ]
   }
  },
  "devstral-2": {
   "name": "Devstral 2 123B",
   "repo": "mistralai/Devstral-2-123B-Instruct-2512",
   "lab": "mistralai",
   "params": 125,
   "released": "2025-12-09",
   "license": "other",
   "hf": {
    "likes": 360,
    "downloads": 6125
   },
   "ollama": {
    "name": "devstral-2",
    "tag": "123b",
    "pulls": 374446,
    "sizes": [
     "123b"
    ],
    "bytes": 74897647584,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Ministral3ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install -U vllm",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Devstral-2-123B-Instruct-2512-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Devstral-2-123B-Instruct-2512-GGUF",
    "files": {
     "BF16": 250064773760,
     "Q2_K": 46591221984,
     "Q2_K_L": 46968709344,
     "UD-IQ1_M": 30565310688,
     "UD-IQ1_S": 28445876448,
     "UD-IQ2_M": 43543404768,
     "UD-IQ2_XXS": 34404671712,
     "UD-IQ3_XXS": 48963887328,
     "UD-Q2_K_XL": 47942312160,
     "IQ4_NL": 70896689568,
     "IQ4_XS": 67124961696,
     "Q3_K_M": 60620382656,
     "Q3_K_S": 54367461792,
     "Q4_0": 71000498592,
     "Q4_1": 78471602592,
     "Q4_K_M": 74897662400,
     "Q4_K_S": 71249011104,
     "Q5_K_M": 88317338016,
     "Q5_K_S": 86184927680,
     "Q6_K": 102575743552,
     "Q8_0": 132854948384,
     "UD-Q3_K_XL": 61939622304,
     "UD-Q4_K_XL": 75498889664,
     "UD-Q5_K_XL": 88249704864,
     "UD-Q6_K_XL": 109840802336,
     "UD-Q8_K_XL": 146067005984
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Devstral-2-123B-Instruct-2512-GGUF",
     "kv": "match",
     "ours": 360448,
     "theirs": 360448
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.15
    }
   }
  },
  "devstral-small-2": {
   "name": "Devstral Small 2 24B",
   "repo": "mistralai/Devstral-Small-2-24B-Instruct-2512",
   "lab": "mistralai",
   "params": 24,
   "released": "2025-12-09",
   "license": "apache-2.0",
   "hf": {
    "likes": 713,
    "downloads": 138229
   },
   "ollama": {
    "name": "devstral-small-2",
    "tag": "24b",
    "pulls": 2503840,
    "sizes": [
     "24b"
    ],
    "bytes": 15177370240,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install -U vllm",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Devstral-Small-2-24B-Instruct-2512-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Devstral-Small-2-24B-Instruct-2512-GGUF",
    "files": {
     "BF16": 47154056032,
     "IQ4_NL": 13468552352,
     "IQ4_XS": 12780424352,
     "Q2_K": 8890862752,
     "Q2_K_L": 9048149152,
     "Q3_K_M": 11474619552,
     "Q3_K_S": 10400812192,
     "Q4_0": 13494766752,
     "Q4_1": 14873644192,
     "Q4_K_M": 14334446752,
     "Q4_K_S": 13549816992,
     "Q5_K_M": 16764521632,
     "Q5_K_S": 16304950432,
     "Q6_K": 19346476192,
     "Q8_0": 25055317152,
     "UD-IQ1_M": 6017846432,
     "UD-IQ1_S": 5559094432,
     "UD-IQ2_M": 8243858592,
     "UD-IQ2_XXS": 6751440032,
     "UD-IQ3_XXS": 9409744032,
     "UD-Q2_K_XL": 9292680352,
     "UD-Q3_K_XL": 11851410592,
     "UD-Q4_K_XL": 14506151072,
     "UD-Q5_K_XL": 16766364832,
     "UD-Q6_K_XL": 20788923552,
     "UD-Q8_K_XL": 28992392352
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Devstral-Small-2-24B-Instruct-2512-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.15
    }
   }
  },
  "mistral-medium-3.5": {
   "name": "Mistral Medium 3.5 128B",
   "repo": "mistralai/Mistral-Medium-3.5-128B",
   "lab": "mistralai",
   "params": 127.7,
   "released": "2026-05-22",
   "license": "other",
   "hf": {
    "likes": 496,
    "downloads": 26656
   },
   "ollama": {
    "name": "mistral-medium-3.5",
    "tag": "128b",
    "pulls": 437930,
    "sizes": [
     "128b"
    ],
    "bytes": 80241468320,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/mistralai/Mistral-Medium-3.5-128B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "majentik/Mistral-Medium-3.5-128B-MLX-MXFP4"
   },
   "ggufFiles": {
    "repo": "unsloth/Mistral-Medium-3.5-128B-GGUF",
    "files": {
     "BF16": 250064250304,
     "IQ4_NL": 70896166304,
     "IQ4_XS": 67124438432,
     "Q2_K": 46590698592,
     "Q2_K_L": 46968185952,
     "UD-IQ2_M": 44109112416,
     "UD-IQ2_XXS": 34937742432,
     "UD-IQ3_XXS": 49252770912,
     "UD-Q2_K_XL": 48129746016,
     "Q3_K_M": 60619859360,
     "Q3_K_S": 54366938528,
     "Q4_0": 70999975328,
     "Q4_1": 78471079328,
     "Q4_K_M": 74897139136,
     "Q4_K_S": 71248487840,
     "Q5_K_M": 88316814752,
     "Q5_K_S": 86184404416,
     "Q6_K": 102575220288,
     "Q8_0": 132854425088,
     "UD-Q3_K_XL": 62499038624,
     "UD-Q4_K_XL": 75686323648,
     "UD-Q5_K_XL": 88382088608,
     "UD-Q6_K_XL": 109157656096,
     "UD-Q8_K_XL": 144745276960
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Mistral-Medium-3.5-128B-GGUF",
     "kv": "match",
     "ours": 360448,
     "theirs": 360448
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "effort",
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "pt",
     "it",
     "ja",
     "ko",
     "ru",
     "zh",
     "ar",
     "fa",
     "id",
     "ms",
     "ne",
     "pl",
     "ro",
     "sr",
     "sv",
     "tr",
     "uk",
     "vi",
     "hi",
     "bn"
    ]
   }
  },
  "magistral-small": {
   "name": "Magistral Small 1.2 24B",
   "repo": "mistralai/Magistral-Small-2509",
   "lab": "mistralai",
   "params": 24,
   "released": "2025-09-17",
   "license": "apache-2.0",
   "hf": {
    "likes": 316,
    "downloads": 29510
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install --upgrade vllm",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Magistral-Small-2509-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Magistral-Small-2509-GGUF",
    "files": {
     "BF16": 47153522624,
     "IQ4_NL": 13468018880,
     "IQ4_XS": 12779890880,
     "Q2_K": 8890329280,
     "Q2_K_L": 9047615680,
     "Q3_K_M": 11474086080,
     "Q3_K_S": 10400278720,
     "Q4_0": 13494233280,
     "Q4_1": 14873110720,
     "Q4_K_M": 14333913280,
     "Q4_K_S": 13549283520,
     "Q5_K_M": 16763988160,
     "Q5_K_S": 16304416960,
     "Q6_K": 19345942720,
     "Q8_0": 25054783680,
     "UD-IQ2_M": 8243325120,
     "UD-IQ2_XXS": 6750906560,
     "UD-IQ3_XXS": 9409210560,
     "UD-Q2_K_XL": 9292146880,
     "UD-Q3_K_XL": 11850877120,
     "UD-Q4_K_XL": 14505617600,
     "UD-Q5_K_XL": 16765831360,
     "UD-Q6_K_XL": 20788390080,
     "UD-Q8_K_XL": 28991858880
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Magistral-Small-2509-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.95
    },
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "pt",
     "it",
     "ja",
     "ko",
     "ru",
     "zh",
     "ar",
     "fa",
     "id",
     "ms",
     "ne",
     "pl",
     "ro",
     "sr",
     "sv",
     "tr",
     "uk",
     "vi",
     "hi",
     "bn"
    ],
    "papers": [
     {
      "id": "2506.10910",
      "title": "Magistral",
      "date": "2025-06-12"
     }
    ]
   }
  },
  "mistral-small-3": {
   "name": "Mistral Small 3 24B",
   "repo": "mistralai/Mistral-Small-24B-Instruct-2501",
   "lab": "mistralai",
   "params": 23.6,
   "released": "2025-01-30",
   "license": "apache-2.0",
   "hf": {
    "likes": 991,
    "downloads": 85293
   },
   "engines": {
    "arch": "MistralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Mistral-Small-24B-Instruct-2501-4bit"
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/Mistral-Small-24B-Instruct-2501-GGUF",
    "files": {
     "Q2_K": 8890324416,
     "Q3_K_L": 12400760256,
     "Q3_K_M": 11474081216,
     "Q3_K_S": 10400273856,
     "Q4_K_M": 14333908416,
     "Q4_K_S": 13549278656,
     "Q5_K_M": 16763983296,
     "Q5_K_S": 16304412096,
     "Q6_K": 19345937856,
     "Q8_0": 25054778816
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "MaziyarPanahi/Mistral-Small-24B-Instruct-2501-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.15
    },
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "it",
     "pt",
     "zh",
     "ja",
     "ru",
     "ko"
    ],
    "cutoff": "2023-10-31",
    "cutoffFrom": "openrouter"
   }
  },
  "mistral-large-2411": {
   "name": "Mistral Large 2411 123B",
   "repo": "mistralai/Mistral-Large-Instruct-2411",
   "lab": "mistralai",
   "params": 122.6,
   "released": "2024-11-18",
   "license": "other",
   "licenseName": "mrl",
   "hf": {
    "likes": 288,
    "downloads": 11947
   },
   "engines": {
    "arch": "MistralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "zachlandes/Mistral-Large-Instruct-2411-Q4-MLX"
   },
   "ggufFiles": {
    "repo": "bartowski/Mistral-Large-Instruct-2411-GGUF",
    "files": {
     "IQ1_M": 28386314528,
     "IQ2_M": 41619605792,
     "IQ2_XS": 36081158432,
     "IQ2_XXS": 32430541088,
     "IQ3_M": 55276390880,
     "IQ3_XXS": 47009024288,
     "IQ4_XS": 65434339840,
     "Q2_K": 45196298528,
     "Q2_K_L": 45589514528,
     "Q3_K_L": 64554322432,
     "Q3_K_M": 59102775808,
     "Q3_K_S": 52849854976,
     "Q3_K_XL": 64906643968,
     "Q4_0": 69322459648,
     "Q4_0_8_8": 69080238560,
     "Q4_K_M": 73219623424,
     "Q4_K_S": 69570972160,
     "Q5_K_M": 86488304224,
     "Q5_K_S": 84355893856,
     "Q6_K": 100586277472,
     "Q8_0": 130280376800
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/Mistral-Large-Instruct-2411-GGUF",
     "kv": "match",
     "ours": 360448,
     "theirs": 360448
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "it",
     "pt",
     "zh",
     "ja",
     "ru",
     "ko"
    ]
   }
  },
  "pixtral-large": {
   "name": "Pixtral Large 124B",
   "repo": "mistralai/Pixtral-Large-Instruct-2411",
   "lab": "mistralai",
   "params": 124.1,
   "released": "2024-11-18",
   "license": "other",
   "licenseName": "mrl",
   "hf": {
    "likes": 444,
    "downloads": 191
   },
   "engines": {
    "vllmCard": true
   },
   "ggufFiles": {
    "repo": "EnlistedGhost/Pixtral-Large-Instruct-2411-GGUF",
    "files": {
     "Q2_K": 46742425248,
     "Q2_K_L": 58611256992,
     "Q3_K_L": 66552647328,
     "Q4_K_XL": 77435293344,
     "Q5_K_XL": 96105189024,
     "Q6_K_L": 111947075232
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "EnlistedGhost/Pixtral-Large-Instruct-2411-GGUF",
     "kv": "match",
     "ours": 360448,
     "theirs": 360448
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "it",
     "pt",
     "zh",
     "ja",
     "ru",
     "ko"
    ]
   }
  },
  "codestral-22b": {
   "name": "Codestral 22B",
   "repo": "mistralai/Codestral-22B-v0.1",
   "lab": "mistralai",
   "params": 22.3,
   "released": "2024-05-29",
   "license": "other",
   "licenseName": "mnpl",
   "hf": {
    "likes": 1364,
    "downloads": 4719
   },
   "ollama": {
    "name": "codestral",
    "tag": "22b",
    "pulls": 1372107,
    "sizes": [
     "22b"
    ],
    "bytes": 12569157728,
    "quant": "Q4_0"
   },
   "engines": {
    "arch": "MistralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "rairahulr1/Codestral-22B-v0.1-mlx-4Bit"
   },
   "ggufFiles": {
    "repo": "SanctumAI/Codestral-22B-v0.1-GGUF",
    "files": {
     "Q2_K": 8272093280,
     "Q3_K_L": 11730428000,
     "Q3_K_M": 10756825184,
     "Q3_K_S": 9641271392,
     "Q4_0": 12569157728,
     "Q4_1": 13946986592,
     "Q4_K": 13341237344,
     "Q4_K_M": 13341237344,
     "Q4_K_S": 12660383840,
     "Q5_0": 15324815456,
     "Q5_1": 16702644320,
     "Q5_K": 15722553440,
     "Q5_K_M": 15722553440,
     "Q5_K_S": 15324815456,
     "Q6_K": 18252701792,
     "Q8_0": 23640547424,
     "F16": 44496724064
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "SanctumAI/Codestral-22B-v0.1-GGUF",
     "kv": "match",
     "ours": 229376,
     "theirs": 229376
    }
   }
  },
  "mistral-small-2409": {
   "name": "Mistral Small 2409 22B",
   "repo": "mistralai/Mistral-Small-Instruct-2409",
   "lab": "mistralai",
   "params": 22.3,
   "released": "2024-09-17",
   "license": "other",
   "licenseName": "mrl",
   "hf": {
    "likes": 406,
    "downloads": 8698
   },
   "engines": {
    "arch": "MistralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install --upgrade vllm",
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/Mistral-Small-Instruct-2409-GGUF",
    "files": {
     "IQ1_M": 5267138688,
     "IQ1_S": 4829489280,
     "IQ2_XS": 6646147200,
     "IQ3_XS": 9176098944,
     "IQ4_XS": 11935295616,
     "Q2_K": 8272098048,
     "Q3_K_L": 11730432768,
     "Q3_K_M": 10756829952,
     "Q3_K_S": 9641276160,
     "Q4_K_M": 13341242112,
     "Q4_K_S": 12660388608,
     "Q5_K_M": 15722558208,
     "Q5_K_S": 15324820224,
     "Q6_K": 18252706560,
     "Q8_0": 23640552192
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "MaziyarPanahi/Mistral-Small-Instruct-2409-GGUF",
     "kv": "match",
     "ours": 229376,
     "theirs": 229376
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "it",
     "pt",
     "zh",
     "ja",
     "ru",
     "ko"
    ]
   }
  },
  "pixtral-12b": {
   "name": "Pixtral 12B",
   "repo": "mistralai/Pixtral-12B-2409",
   "lab": "mistralai",
   "params": 12.7,
   "released": "2024-09-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 718,
    "downloads": 9532
   },
   "engines": {
    "vllmCard": true,
    "vllmSetup": "pip install --upgrade vllm"
   },
   "ggufFiles": {
    "repo": "EnlistedGhost/Pixtral-12B-2409-GGUF",
    "files": {
     "BF16": 24504275872,
     "IQ3_M": 5724607648,
     "IQ4_XS": 6994039712,
     "Q2_K": 5121348512,
     "Q2_K_L": 6975034272,
     "Q2_K_M": 6445831072,
     "Q2_K_XL": 7940051872,
     "Q3_K_L": 6823646112,
     "Q3_K_M": 6345233312,
     "Q3_K_S": 5796369312,
     "Q3_K_XL": 7148704672,
     "Q4_K_M": 7703795680,
     "Q4_K_S": 7293211552,
     "Q4_K_XL": 9358906272,
     "Q5_K_M": 8816761504,
     "Q5_K_S": 8607863712,
     "Q5_K_XL": 10427143072,
     "Q6_K": 10056209312,
     "Q6_K_L": 10381267872,
     "Q6_K_XL": 11346285472,
     "Q8_0": 13022368672
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "EnlistedGhost/Pixtral-12B-2409-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "it",
     "pt",
     "ru",
     "zh",
     "ja"
    ]
   }
  },
  "nemotron-3.5-parse": {
   "name": "Nemotron 3.5 Parse",
   "repo": "nvidia/Nemotron-3.5-Parse",
   "lab": "nvidia",
   "params": 0.6,
   "released": "2026-09-03",
   "license": "openmdw-1.1",
   "hf": {
    "likes": 142,
    "downloads": 14306
   },
   "engines": {
    "arch": "RadioMBartPrefixForCausalLM",
    "vllm": true,
    "llamacpp": false,
    "vllmCard": true,
    "gguf": {
     "repo": "SkyContact/Nemotron-3.5-Parse-GGUF",
     "arch": "nemotron_parse",
     "llamacpp": false
    },
    "sglang": false,
    "mlx": false,
    "mlxRepo": "geoHeil/Nemotron-3.5-Parse-MLX-bf16"
   },
   "ggufFiles": {
    "repo": "SkyContact/Nemotron-3.5-Parse-GGUF",
    "files": {
     "F16": 1307010336,
     "Q8_0": 866349216
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "SkyContact/Nemotron-3.5-Parse-GGUF",
     "kv": "match",
     "ours": 20480,
     "theirs": 20480
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "sampling": {
     "source": "generation_config",
     "repetitionPenalty": 1.1
    }
   }
  },
  "gemma-2-9b": {
   "name": "Gemma 2 9B",
   "repo": "google/gemma-2-9b-it",
   "lab": "google",
   "params": 9.2,
   "released": "2024-06-27",
   "license": "gemma",
   "gated": true,
   "hf": {
    "likes": 1164,
    "downloads": 130249
   },
   "ollama": {
    "name": "gemma2",
    "tag": "9b",
    "pulls": 36277982,
    "sizes": [
     "2b",
     "9b",
     "27b"
    ],
    "bytes": 5443143296,
    "quant": "Q4_0"
   },
   "engines": {
    "arch": "Gemma2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/gemma-2-9b-it-6bit"
   },
   "ggufFiles": {
    "repo": "bartowski/gemma-2-9b-it-GGUF",
    "files": {
     "IQ2_M": 3434668992,
     "IQ2_S": 3211487104,
     "IQ2_XS": 3067381632,
     "IQ3_M": 4494615488,
     "IQ3_XS": 4144989120,
     "IQ3_XXS": 3796739008,
     "IQ4_XS": 5183030208,
     "Q2_K": 3805397952,
     "Q2_K_L": 4027605952,
     "Q8": 7811278720,
     "Q3_K_L": 5132452800,
     "Q3_K_M": 4761781184,
     "Q3_K_S": 4337664960,
     "Q3_K_XL": 5354660768,
     "Q4_K_L": 5983265728,
     "Q4_K_M": 5761057728,
     "Q4_K_S": 5478925248,
     "Q5_K_L": 6869574592,
     "Q5_K_M": 6647366592,
     "Q5_K_S": 6483592128,
     "F32": 36972880544,
     "Q6_K": 7589069760,
     "Q6_K_L": 7811277760,
     "F16": 10687308704,
     "Q8_0": 9827148736,
     "Q8_0_L": 10687309696
    }
   },
   "eci": {
    "score": 120,
    "name": "Gemma 2 9B"
   },
   "about": {
    "inputs": [
     "text"
    ],
    "training": {
     "name": "Gemma 2 9B",
     "flop": 4.32e+23,
     "tokens": 8000000000000,
     "hardware": "Google TPU v4",
     "chips": 4096,
     "confidence": "Confident"
    }
   }
  },
  "gemma-3-4b": {
   "name": "Gemma 3 4B",
   "repo": "google/gemma-3-4b-it",
   "lab": "google",
   "params": 4.3,
   "released": "2025-03-12",
   "license": "gemma",
   "gated": true,
   "hf": {
    "likes": 1615,
    "downloads": 962830
   },
   "ollama": {
    "name": "gemma3",
    "tag": "4b",
    "pulls": 41599076,
    "sizes": [
     "270m",
     "1b",
     "4b",
     "12b",
     "27b"
    ],
    "bytes": 2499012288,
    "projector": 851251104,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Gemma3ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "unsloth/gemma-3-4b-it-GGUF",
    "files": {
     "BF16": 7767803520,
     "IQ4_NL": 2363511936,
     "IQ4_XS": 2263241856,
     "Q2_K": 1729164416,
     "Q2_K_L": 1729164416,
     "Q3_K_M": 2098459776,
     "Q3_K_S": 1937364096,
     "Q4_0": 2370065536,
     "Q4_1": 2564052096,
     "Q4_K_M": 2489894016,
     "Q4_K_S": 2377929856,
     "Q5_K_M": 2829698176,
     "Q5_K_S": 2764592256,
     "Q6_K": 3190740096,
     "Q8_0": 4130402176,
     "UD-IQ1_M": 1239711616,
     "UD-IQ1_S": 1179910016,
     "UD-IQ2_M": 1565015936,
     "UD-IQ2_XXS": 1342275456,
     "UD-IQ3_XXS": 1710751616,
     "UD-Q2_K_XL": 1769407616,
     "UD-Q3_K_XL": 2150929536,
     "UD-Q4_K_XL": 2544288896,
     "UD-Q5_K_XL": 2836231296,
     "UD-Q6_K_XL": 3566628736,
     "UD-Q8_K_XL": 5165205376
    }
   },
   "eci": {
    "score": 116,
    "name": "Gemma 3 4B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.05,
      "output": 0.1,
      "tps": 20,
      "ttftMs": 357,
      "context": 131072
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "sampling": {
     "source": "generation_config",
     "topP": 0.95,
     "topK": 64
    },
    "cutoff": "2024-08-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Gemma 3 4B",
     "flop": 9.6e+22,
     "tokens": 4000000000000,
     "hardware": "Google TPU v5e",
     "chips": 2048,
     "confidence": "Confident"
    }
   }
  },
  "llava-1.6-mistral-7b": {
   "name": "LLaVA 1.6 Mistral 7B",
   "repo": "llava-hf/llava-v1.6-mistral-7b-hf",
   "lab": "llava-hf",
   "params": 7.6,
   "released": "2024-02-20",
   "license": "apache-2.0",
   "hf": {
    "likes": 315,
    "downloads": 186359
   },
   "engines": {
    "arch": "LlavaNextForConditionalGeneration",
    "vllm": true,
    "llamacpp": false,
    "sglang": false,
    "mlx": false
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "languages": [
     "en"
    ]
   }
  },
  "mistral-small-3.2": {
   "name": "Mistral Small 3.2 24B",
   "repo": "mistralai/Mistral-Small-3.2-24B-Instruct-2506",
   "lab": "mistralai",
   "params": 24,
   "released": "2025-06-19",
   "license": "apache-2.0",
   "hf": {
    "likes": 643,
    "downloads": 119985
   },
   "ollama": {
    "name": "mistral-small3.2",
    "tag": "24b",
    "pulls": 2520222,
    "sizes": [
     "24b"
    ],
    "bytes": 15177369888,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Mistral-Small-3.2-24B-Instruct-2506-MLX-6bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Mistral-Small-3.2-24B-Instruct-2506-GGUF",
    "files": {
     "BF16": 47153532160,
     "IQ4_NL": 13468028448,
     "IQ4_XS": 12779900448,
     "Q2_K": 8890338848,
     "Q2_K_L": 9047625248,
     "Q3_K_M": 11474095648,
     "Q3_K_S": 10400288288,
     "Q4_0": 13494242848,
     "Q4_1": 14873120288,
     "Q4_K_M": 14333922848,
     "Q4_K_S": 13549293088,
     "Q5_K_M": 16763997728,
     "Q5_K_S": 16304426528,
     "Q6_K": 19345952288,
     "Q8_0": 25054793248,
     "UD-IQ1_M": 6017322528,
     "UD-IQ1_S": 5558570528,
     "UD-IQ2_M": 8243334688,
     "UD-IQ2_XXS": 6750916128,
     "UD-IQ3_XXS": 9409220128,
     "UD-Q2_K_XL": 9292156448,
     "UD-Q3_K_XL": 11850886688,
     "UD-Q4_K_XL": 14548880928,
     "UD-Q5_K_XL": 16788123168,
     "UD-Q6_K_XL": 20788399648,
     "UD-Q8_K_XL": 28991868448
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Mistral-Small-3.2-24B-Instruct-2506-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.15
    },
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "pt",
     "it",
     "ja",
     "ko",
     "ru",
     "zh",
     "ar",
     "fa",
     "id",
     "ms",
     "ne",
     "pl",
     "ro",
     "sr",
     "sv",
     "tr",
     "uk",
     "vi",
     "hi",
     "bn"
    ],
    "cutoff": "2023-10-31",
    "cutoffFrom": "openrouter"
   }
  },
  "qwen3-32b": {
   "name": "Qwen3 32B",
   "repo": "Qwen/Qwen3-32B",
   "lab": "qwen",
   "params": 32.8,
   "released": "2025-04-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 792,
    "downloads": 2952541
   },
   "ollama": {
    "name": "qwen3",
    "tag": "32b",
    "pulls": 42279328,
    "sizes": [
     "0.6b",
     "1.7b",
     "4b",
     "8b",
     "14b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 20201240160,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3-32B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "Qwen/Qwen3-32B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen3-32B-GGUF",
    "files": {
     "Q4_K_M": 19762149024,
     "Q5_0": 22635493024,
     "Q5_K_M": 23214831232,
     "Q6_K": 26883306112,
     "Q8_0": 34817718912
    }
   },
   "eci": {
    "score": 138,
    "name": "Qwen3-32B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.08,
      "output": 0.25,
      "tps": 40,
      "ttftMs": 416,
      "context": 40960
     },
     {
      "name": "DeepInfra",
      "input": 0.08,
      "output": 0.28,
      "tps": 30,
      "ttftMs": 276,
      "context": 40960
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen3-32B-GGUF",
     "kv": "match",
     "ours": 262144,
     "theirs": 262144
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "cutoff": "2025-03-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Qwen3-32B",
     "flop": 7.0848e+24,
     "confidence": "Confident"
    }
   }
  },
  "llama-3.3-70b": {
   "name": "Llama 3.3 70B",
   "repo": "meta-llama/Llama-3.3-70B-Instruct",
   "lab": "meta-llama",
   "params": 70.6,
   "released": "2024-11-26",
   "license": "llama3.3",
   "gated": true,
   "hf": {
    "likes": 3184,
    "downloads": 365518
   },
   "ollama": {
    "name": "llama3.3",
    "tag": "70b",
    "pulls": 4450056,
    "sizes": [
     "70b"
    ],
    "bytes": 42520398528,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "LlamaForCausalLM",
    "recipe": "https://recipes.vllm.ai/meta-llama/Llama-3.3-70B-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlxRepo": "mlx-community/Llama-3.3-70B-Instruct-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Llama-3.3-70B-Instruct-GGUF",
    "files": {
     "IQ1_M": 16751201248,
     "IQ2_M": 24119299040,
     "IQ2_S": 22242348000,
     "IQ2_XS": 21142113248,
     "IQ2_XXS": 19097390048,
     "IQ3_M": 31937039328,
     "IQ3_XS": 29307735008,
     "IQ3_XXS": 27469499360,
     "IQ4_NL": 40053623776,
     "IQ4_XS": 37902666720,
     "Q2_K": 26375113696,
     "Q2_K_L": 27401161696,
     "Q3_K_L": 37140597728,
     "Q3_K_M": 34267499488,
     "Q3_K_S": 30912056288,
     "Q3_K_XL": 38059936736,
     "Q4_0": 40116538336,
     "Q4_0_4_4": 39969737696,
     "Q4_0_4_8": 39969737696,
     "Q4_0_8_8": 39969737696,
     "Q4_K_L": 43300195296,
     "Q4_K_M": 42520398816,
     "Q4_K_S": 40347225056,
     "Q5_K_L": 50598284448,
     "Q5_K_M": 49949822112,
     "Q5_K_S": 48657452000,
     "Q6_K": 57888148672,
     "Q6_K_L": 58397068448,
     "Q8_0": 74975055008,
     "F16": 141117918624
    }
   },
   "eci": {
    "score": 127,
    "name": "Llama 3.3 70B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.135,
      "output": 0.4,
      "tps": 47,
      "ttftMs": 498,
      "context": 12288
     },
     {
      "name": "OVHcloud",
      "input": 0.74,
      "output": 0.74,
      "tps": 33,
      "ttftMs": 408,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/Llama-3.3-70B-Instruct-GGUF",
     "kv": "match",
     "ours": 327680,
     "theirs": 327680
    },
    "inferencex": {
     "model": "Llama-3.3-70B-Instruct-FP8",
     "runs": [
      {
       "id": "42017",
       "day": "2025-10-29",
       "gpu": "h100",
       "gpus": 2,
       "engine": "vllm",
       "format": "fp8",
       "tps": 57.4,
       "ttft": 0.108,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "41187",
       "day": "2025-10-29",
       "gpu": "h100",
       "gpus": 4,
       "engine": "vllm",
       "format": "fp8",
       "tps": 84.9,
       "ttft": 0.072,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "41625",
       "day": "2025-10-29",
       "gpu": "h100",
       "gpus": 8,
       "engine": "vllm",
       "format": "fp8",
       "tps": 110,
       "ttft": 0.065,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40446",
       "day": "2025-10-29",
       "gpu": "h200",
       "gpus": 1,
       "engine": "vllm",
       "format": "fp8",
       "tps": 46.5,
       "ttft": 0.175,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39587",
       "day": "2025-10-29",
       "gpu": "h200",
       "gpus": 2,
       "engine": "vllm",
       "format": "fp8",
       "tps": 71.8,
       "ttft": 0.11,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40409",
       "day": "2025-10-29",
       "gpu": "h200",
       "gpus": 4,
       "engine": "vllm",
       "format": "fp8",
       "tps": 101.4,
       "ttft": 0.082,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40525",
       "day": "2025-10-29",
       "gpu": "h200",
       "gpus": 8,
       "engine": "vllm",
       "format": "fp8",
       "tps": 125.9,
       "ttft": 0.067,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40624",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 1,
       "engine": "vllm",
       "format": "fp8",
       "tps": 61.2,
       "ttft": 0.107,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40085",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 1,
       "engine": "vllm",
       "format": "nvfp4",
       "tps": 76.5,
       "ttft": 0.083,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40087",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 2,
       "engine": "vllm",
       "format": "fp8",
       "tps": 93.9,
       "ttft": 0.083,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40415",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 2,
       "engine": "vllm",
       "format": "nvfp4",
       "tps": 103.5,
       "ttft": 0.073,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40041",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 4,
       "engine": "vllm",
       "format": "fp8",
       "tps": 124.3,
       "ttft": 0.117,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39563",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 4,
       "engine": "vllm",
       "format": "nvfp4",
       "tps": 138.1,
       "ttft": 0.067,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40503",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 8,
       "engine": "vllm",
       "format": "nvfp4",
       "tps": 158.4,
       "ttft": 0.066,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40483",
       "day": "2025-10-29",
       "gpu": "b200",
       "gpus": 8,
       "engine": "vllm",
       "format": "fp8",
       "tps": 158.2,
       "ttft": 0.075,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40445",
       "day": "2025-10-29",
       "gpu": "mi300x",
       "gpus": 1,
       "engine": "vllm",
       "format": "fp8",
       "tps": 38.4,
       "ttft": 0.235,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39918",
       "day": "2025-10-29",
       "gpu": "mi300x",
       "gpus": 2,
       "engine": "vllm",
       "format": "fp8",
       "tps": 64.6,
       "ttft": 0.157,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40295",
       "day": "2025-10-29",
       "gpu": "mi300x",
       "gpus": 4,
       "engine": "vllm",
       "format": "fp8",
       "tps": 91.2,
       "ttft": 0.119,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39775",
       "day": "2025-10-29",
       "gpu": "mi300x",
       "gpus": 8,
       "engine": "vllm",
       "format": "fp8",
       "tps": 112.4,
       "ttft": 0.114,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39453",
       "day": "2025-10-29",
       "gpu": "mi325x",
       "gpus": 1,
       "engine": "vllm",
       "format": "fp8",
       "tps": 48,
       "ttft": 0.169,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "40213",
       "day": "2025-10-29",
       "gpu": "mi325x",
       "gpus": 2,
       "engine": "vllm",
       "format": "fp8",
       "tps": 73.1,
       "ttft": 0.178,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39956",
       "day": "2025-10-29",
       "gpu": "mi325x",
       "gpus": 4,
       "engine": "vllm",
       "format": "fp8",
       "tps": 86.2,
       "ttft": 0.11,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39889",
       "day": "2025-10-29",
       "gpu": "mi325x",
       "gpus": 8,
       "engine": "vllm",
       "format": "fp8",
       "tps": 124.4,
       "ttft": 0.081,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      },
      {
       "id": "39922",
       "day": "2025-10-29",
       "gpu": "mi355x",
       "gpus": 1,
       "engine": "vllm",
       "format": "fp8",
       "tps": 61.6,
       "ttft": 0.114,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/18924448230/attempts/2"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "languages": [
     "en",
     "fr",
     "it",
     "pt",
     "hi",
     "es",
     "th",
     "de"
    ],
    "cutoff": "2023-12-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Llama 3.3 70B",
     "flop": 6.8649768e+24,
     "tokens": 15000000000000,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "confidence": "Confident"
    }
   }
  },
  "llama-3.1-405b": {
   "name": "Llama 3.1 405B",
   "repo": "meta-llama/Llama-3.1-405B",
   "lab": "meta-llama",
   "params": 405.9,
   "released": "2024-07-16",
   "license": "llama3.1",
   "gated": true,
   "hf": {
    "likes": 993,
    "downloads": 41521
   },
   "ollama": {
    "name": "llama3.1",
    "tag": "405b",
    "pulls": 120791266,
    "sizes": [
     "8b",
     "70b",
     "405b"
    ],
    "bytes": 243069610720,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "LlamaForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "ThomasBaruzier/Meta-Llama-3.1-405B-Instruct-GGUF",
    "files": {
     "F16": 811722961632,
     "IQ1_M": 93498010752,
     "IQ1_S": 85233396896,
     "IQ2_M": 136667131168,
     "IQ2_S": 125647645952,
     "IQ2_XS": 119348817152,
     "IQ2_XXS": 107272367360,
     "IQ3_M": 181744528736,
     "IQ3_S": 175514414464,
     "IQ3_XS": 166059928992,
     "IQ3_XXS": 155846634880,
     "IQ4_NL": 229120667104,
     "IQ4_XS": 216569605632,
     "Q2_K": 149322788224,
     "Q2_K_S": 137790549248,
     "Q3_K_L": 212838477312,
     "Q3_K_M": 195373395488,
     "Q3_K_S": 175226367200,
     "Q4_K_M": 243069611648,
     "Q4_K_S": 230500593120
    }
   },
   "eci": {
    "score": 129,
    "name": "Llama 3.1-405B"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "ThomasBaruzier/Meta-Llama-3.1-405B-Instruct-GGUF",
     "kv": "match",
     "ours": 516096,
     "theirs": 516096
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.9
    },
    "languages": [
     "en",
     "de",
     "fr",
     "it",
     "pt",
     "hi",
     "es",
     "th"
    ],
    "training": {
     "name": "Llama 3.1-405B",
     "flop": 3.8e+25,
     "tokens": 15600000000000,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "chips": 16384,
     "confidence": "Confident"
    }
   }
  },
  "hy-memory-30b-a3b": {
   "name": "Hy-Memory 30B-A3B",
   "repo": "tencent/Hy-Memory-30B-A3B",
   "lab": "tencent",
   "params": 30.1,
   "released": "2026-10-15",
   "license": "apache-2.0",
   "hf": {
    "likes": 322,
    "downloads": 6130
   },
   "modelscope": "Tencent-Hunyuan/Hy-Memory-30B-A3B",
   "engines": {
    "arch": "HYV3ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "abenzerps/Hy-Memory-30B-A3B-Quantized"
   },
   "ggufFiles": {
    "repo": "vinnipukh/Hy-Memory-30B-A3B-GGUF",
    "files": {
     "BF16": 60159655488,
     "IQ4_XS": 16099901024,
     "Q2_0": 8710454656,
     "Q3_K_M": 14446329440,
     "Q4_0": 17023434112,
     "Q4_1": 18886229376,
     "Q4_K_M": 18236702304,
     "Q5_0": 20749024640,
     "Q5_1": 22611819904,
     "Q5_K_M": 21374041696,
     "Q5_K_S": 20749024864,
     "Q6_K": 24707464800,
     "Q8_0": 31985728896,
     "TQ1_0": 6632209792,
     "TQ2_0": 8017706368
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "vinnipukh/Hy-Memory-30B-A3B-GGUF",
     "kv": "match",
     "ours": 98304,
     "theirs": 98304
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "kimi-vl-a3b-instruct": {
   "name": "Kimi VL A3B Instruct",
   "repo": "moonshotai/Kimi-VL-A3B-Instruct",
   "lab": "moonshotai",
   "params": 16.4,
   "released": "2025-04-09",
   "license": "mit",
   "hf": {
    "likes": 285,
    "downloads": 95666
   },
   "modelscope": "moonshotai/Kimi-VL-A3B-Instruct",
   "engines": {
    "arch": "KimiVLForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "internetoftim/Kimi-VL-A3B-Instruct-mlx-4bit"
   },
   "ggufFiles": {
    "repo": "mradermacher/Kimi-VL-A3B-Instruct-GGUF",
    "files": {
     "IQ4_XS": 8820448800,
     "Q2_K": 6582289952,
     "Q3_K_L": 8623006240,
     "Q3_K_M": 8290214432,
     "Q3_K_S": 7649526304,
     "Q4_K_M": 10540748320,
     "Q4_K_S": 9713880608,
     "Q5_K_M": 12041768480,
     "Q5_K_S": 11337453088,
     "Q6_K": 14279399968,
     "Q8_0": 16974941728
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.2
    },
    "papers": [
     {
      "id": "2504.07491",
      "title": "Kimi-VL Technical Report",
      "date": "2025-04-10"
     }
    ]
   }
  },
  "mixtral-8x7b": {
   "name": "Mixtral 8x7B",
   "repo": "mistralai/Mixtral-8x7B-Instruct-v0.1",
   "lab": "mistralai",
   "params": 46.7,
   "released": "2023-12-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 4775,
    "downloads": 283508
   },
   "ollama": {
    "name": "mixtral",
    "tag": "8x7b",
    "pulls": 2942995,
    "sizes": [
     "8x7b",
     "8x22b"
    ],
    "bytes": 26443590560,
    "quant": "Q4_0"
   },
   "engines": {
    "arch": "MixtralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "Open4bits/Mixtral-8x7B-Instruct-v0.1-mlx-4Bit"
   },
   "ggufFiles": {
    "repo": "TheBloke/Mixtral-8x7B-Instruct-v0.1-GGUF",
    "files": {
     "Q2_K": 15644035008,
     "Q3_K_M": 20363356096,
     "Q4_0": 26441533376,
     "Q4_K_M": 26441533376,
     "Q5_0": 32229279680,
     "Q5_K_M": 32229279680,
     "Q6_K": 38378760128,
     "Q8_0": 49624262592
    }
   },
   "eci": {
    "score": 118,
    "name": "Mixtral 8x7B"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "TheBloke/Mixtral-8x7B-Instruct-v0.1-GGUF",
     "kv": "match",
     "ours": 131072,
     "theirs": 131072
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "languages": [
     "fr",
     "it",
     "de",
     "es",
     "en"
    ],
    "training": {
     "name": "Mixtral 8x7B",
     "flop": 7.74e+23,
     "confidence": "Speculative"
    }
   }
  },
  "unlimited-ocr-2": {
   "name": "Unlimited-OCR 2",
   "repo": "baidu/Unlimited-OCR-2",
   "lab": "baidu",
   "params": 3.3,
   "released": "2026-10-27",
   "license": "mit",
   "hf": {
    "likes": 577,
    "downloads": 189897
   },
   "engines": {
    "arch": "UnlimitedOCRForCausalLM",
    "vllm": false,
    "llamacpp": false,
    "sglang": false,
    "mlx": false,
    "mlxRepo": "mlx-community/Unlimited-OCR-2-8bit"
   },
   "ggufFiles": {
    "repo": "AtomicChat/Unlimited-OCR-2-GGUF",
    "files": {
     "Q4_K": 2023848064,
     "Q5_K": 2276161664,
     "Q6_K": 2742941824,
     "BF16": 5884466304,
     "Q8_0": 3134027904
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "papers": [
     {
      "id": "2610.39308",
      "title": "Unlimited OCR Works 2",
      "date": "2026-10-29"
     },
     {
      "id": "2606.23050",
      "title": "Unlimited OCR Works",
      "date": "2026-06-22"
     }
    ]
   }
  },
  "xing4.0-29b-a4b": {
   "name": "Xing4.0 29B-A4B",
   "repo": "XingChen-AGI/Xing4.0-29B-A4B",
   "lab": "xingchen-agi",
   "params": 31.2,
   "released": "2026-09-16",
   "license": "apache-2.0",
   "hf": {
    "likes": 1860,
    "downloads": 5601
   },
   "modelscope": "XingChen-AGI/Xing4.0-29B-A4B",
   "engines": {
    "arch": "Xing4_0ForCausalLM",
    "vllm": false,
    "llamacpp": false,
    "gguf": {
     "repo": "XingChen-AGI/Xing4.0-29B-A4B-GGUF",
     "arch": "xing4_0",
     "llamacpp": false
    },
    "sglang": false,
    "mlx": false,
    "mlxRepo": "mlx-community/Xing4.0-29B-A4B-OptiQ-4bit"
   },
   "ggufFiles": {
    "repo": "dealignai/Xing4.0-29B-A4B-CRACK-GGUF",
    "files": {
     "IQ3_M": 13871038688,
     "IQ4_NL": 17754323936,
     "Q3_K_M": 15019868384,
     "Q4_K_M": 18950630368,
     "Q5_K_M": 22208994272,
     "Q6_K": 25692165856,
     "Q8_0": 33222310880
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "qwen3.5-4b": {
   "name": "Qwen3.5 4B",
   "repo": "Qwen/Qwen3.5-4B",
   "lab": "qwen",
   "params": 4.7,
   "released": "2026-02-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 1182,
    "downloads": 6376702
   },
   "ollama": {
    "name": "qwen3.5",
    "tag": "4b",
    "pulls": 24161275,
    "sizes": [
     "0.8b",
     "2b",
     "4b",
     "9b",
     "27b",
     "35b",
     "122b"
    ],
    "bytes": 2648593216,
    "projector": 675569120,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3.5-4B",
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.5-4B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto --extra-index-url https://wheels.vllm.ai/nightly",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Qwen3.5-4B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.5-4B-GGUF",
    "files": {
     "BF16": 8424393632,
     "IQ4_NL": 2579944608,
     "IQ4_XS": 2477053088,
     "Q3_K_M": 2293388448,
     "Q3_K_S": 2105791648,
     "Q4_0": 2583221408,
     "Q4_1": 2784416928,
     "Q4_K_M": 2740937888,
     "Q4_K_S": 2590430368,
     "Q5_K_M": 3143656608,
     "Q5_K_S": 3024934048,
     "Q6_K": 3525956768,
     "Q8_0": 4482403488,
     "UD-IQ2_M": 1759997088,
     "UD-IQ2_XXS": 1520217248,
     "UD-IQ3_XXS": 1949047968,
     "UD-Q2_K_XL": 1940825248,
     "UD-Q3_K_XL": 2436420768,
     "UD-Q4_K_XL": 2912109728,
     "UD-Q5_K_XL": 3250869408,
     "UD-Q6_K_XL": 4145548448,
     "UD-Q8_K_XL": 5952048288
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking"
   }
  },
  "minicpm-v-4.7-1b": {
   "name": "MiniCPM-V-4.7 1B",
   "repo": "openbmb/MiniCPM-V-4.7-1B",
   "lab": "openbmb",
   "params": 1.6,
   "released": "2026-10-06",
   "license": "apache-2.0",
   "hf": {
    "likes": 412,
    "downloads": 241677
   },
   "modelscope": "OpenBMB/MiniCPM-V-4.7-1B",
   "engines": {
    "arch": "MiniCPMV4_7ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "mlx-community/MiniCPM-V-4.7-1B-8bit"
   },
   "ggufFiles": {
    "repo": "openbmb/MiniCPM-V-4.7-1B-gguf",
    "files": {
     "F16": 438065792,
     "IQ3_M": 562920864,
     "IQ3_XS": 552267168,
     "IQ4_NL": 658708352,
     "IQ4_XS": 638856128,
     "Q4_0": 644159072,
     "Q4_1": 691138016,
     "Q4_K_M": 672003680,
     "Q4_K_S": 647960160,
     "Q5_0": 738116960,
     "Q5_1": 785095904,
     "Q5_K_M": 752461152,
     "Q5_K_S": 738116960,
     "Q6_K": 837947232,
     "Q8_0": 1081517920
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking"
   }
  },
  "raon-1-mini-preview": {
   "name": "Raon-1 mini preview",
   "repo": "KRAFTON/Raon-1-mini-preview",
   "lab": "krafton",
   "params": 28.8,
   "released": "2026-10-21",
   "license": "apache-2.0",
   "hf": {
    "likes": 231,
    "downloads": 3666
   },
   "engines": {
    "arch": "Raon1MiniForCausalLM",
    "vllm": false,
    "llamacpp": false,
    "vllmCard": true,
    "gguf": {
     "repo": "KRAFTON/Raon-1-mini-preview-gguf",
     "arch": "raon1",
     "llamacpp": false
    },
    "sglang": false,
    "mlx": false,
    "mlxRepo": "KRAFTON/Raon-1-mini-preview-mlx"
   },
   "ggufFiles": {
    "repo": "NANI-Nithin/Raon-1-mini-preview-GGUF",
    "files": {
     "BF16": 57596903520,
     "IQ1_M": 10261282304,
     "IQ1_S": 9842169344,
     "IQ2_M": 12148125184,
     "IQ2_S": 11589307904,
     "IQ2_XS": 11518621184,
     "IQ2_XXS": 10959803904,
     "IQ3_M": 14285551104,
     "IQ3_S": 14160996864,
     "IQ3_XS": 13537257984,
     "IQ3_XXS": 13192431104,
     "IQ4_NL": 16659741184,
     "IQ4_XS": 16071801344,
     "MXFP4_MOE": 17012741792,
     "Q2_0": 8738945024,
     "Q2_K": 12277281952,
     "Q2_K_S": 12346540544,
     "Q3_K_L": 15834084864,
     "Q3_K_M": 15273096704,
     "Q3_K_S": 14160996864,
     "Q4_0": 16449004192,
     "Q4_1": 18203925152,
     "Q4_K_M": 19686434304,
     "Q4_K_S": 18122586624,
     "Q5_0": 19958846112,
     "Q5_1": 21713767072,
     "Q5_K_M": 22183765504,
     "Q5_K_S": 20842740224,
     "Q6_K": 25839461792,
     "Q8_0": 30693555872
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "qwen3.5-9b": {
   "name": "Qwen3.5 9B",
   "repo": "Qwen/Qwen3.5-9B",
   "lab": "qwen",
   "params": 9.7,
   "released": "2026-02-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 2296,
    "downloads": 6412961
   },
   "ollama": {
    "name": "qwen3.5",
    "tag": "9b",
    "pulls": 24161275,
    "sizes": [
     "0.8b",
     "2b",
     "4b",
     "9b",
     "27b",
     "35b",
     "122b"
    ],
    "bytes": 5629109120,
    "projector": 921704832,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3.5-9B",
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.5-9B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto --extra-index-url https://wheels.vllm.ai/nightly",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3.5-9B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.5-9B-GGUF",
    "files": {
     "BF16": 17920697312,
     "IQ4_NL": 5371028704,
     "IQ4_XS": 5168653536,
     "Q3_K_M": 4673643744,
     "Q3_K_S": 4316865760,
     "Q4_0": 5379417312,
     "Q4_1": 5837251808,
     "Q4_K_M": 5680522464,
     "Q4_K_S": 5394097376,
     "Q5_K_M": 6577841376,
     "Q5_K_S": 6361146592,
     "Q6_K": 7458301152,
     "Q8_0": 9527502048,
     "UD-IQ2_M": 3649365216,
     "UD-IQ2_XXS": 3190613216,
     "UD-IQ3_XXS": 4016235744,
     "UD-Q2_K_XL": 4121781472,
     "UD-Q3_K_XL": 5053834464,
     "UD-Q4_K_XL": 5966095584,
     "UD-Q5_K_XL": 6743680224,
     "UD-Q6_K_XL": 8756929760,
     "UD-Q8_K_XL": 12974040288
    }
   },
   "eci": {
    "score": 139,
    "name": "Qwen3.5-9B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.1,
      "output": 0.15,
      "tps": 28,
      "ttftMs": 293,
      "context": 262144
     },
     {
      "name": "OVHcloud",
      "input": 0.12,
      "output": 0.18,
      "tps": 20,
      "ttftMs": 410,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking"
   }
  },
  "qwen3.8-27b": {
   "name": "Qwen3.8 27B",
   "repo": "Qwen/Qwen3.8-27B",
   "lab": "qwen",
   "params": 27.8,
   "released": "2026-08-05",
   "license": "apache-2.0",
   "hf": {
    "likes": 19046,
    "downloads": 8014877
   },
   "ollama": {
    "name": "qwen3.8",
    "tag": "27b",
    "pulls": 5629191,
    "sizes": [
     "27b"
    ],
    "bytes": 16810714464,
    "projector": 931146016,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3.8-27B",
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.8-27B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3.8-27B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "ggml-org/Qwen3.8-27B-GGUF",
    "files": {
     "BF16": 53808282048,
     "Q4_K_M": 18973870528,
     "Q8_0": 28595763648
    }
   },
   "eci": {
    "score": 152,
    "name": "Qwen 3.8 27B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Cerebras",
      "input": 0.99,
      "output": 1.49,
      "tps": 799,
      "ttftMs": 142,
      "context": 65536
     },
     {
      "name": "Nscale",
      "input": 0.2,
      "output": 2.5,
      "tps": 118,
      "ttftMs": 529,
      "context": 1048576
     },
     {
      "name": "DeepInfra",
      "input": 0.2,
      "output": 2.5,
      "tps": 48,
      "ttftMs": 405,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.42,
      "output": 3,
      "tps": 33,
      "ttftMs": 1177,
      "context": 1000000
     },
     {
      "name": "OVHcloud",
      "input": 0.47,
      "output": 3.19,
      "tps": 10,
      "ttftMs": 2519,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "qwen3.6-35b-a3b": {
   "name": "Qwen3.6 35B-A3B",
   "repo": "Qwen/Qwen3.6-35B-A3B",
   "lab": "qwen",
   "params": 36,
   "released": "2026-04-15",
   "license": "apache-2.0",
   "hf": {
    "likes": 3069,
    "downloads": 4555162
   },
   "ollama": {
    "name": "qwen3.6",
    "tag": "35b",
    "pulls": 7449367,
    "sizes": [
     "27b",
     "35b"
    ],
    "bytes": 21718480960,
    "projector": 902821728,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3.6-35B-A3B",
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.6-35B-A3B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3.6-35B-A3B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Qwen_Qwen3.6-35B-A3B-GGUF",
    "files": {
     "IQ1_M": 9421649536,
     "IQ2_M": 12964402816,
     "IQ2_S": 11907962496,
     "IQ2_XS": 11694831232,
     "IQ2_XXS": 10676139648,
     "IQ3_M": 17791661696,
     "IQ3_XS": 17110087296,
     "IQ3_XXS": 15761446528,
     "IQ4_NL": 20754978432,
     "IQ4_XS": 19699553920,
     "Q2_K": 13506778752,
     "Q2_K_L": 14003418752,
     "Q3_K_L": 17777899136,
     "Q3_K_M": 17117951616,
     "Q3_K_S": 16404919936,
     "Q3_K_XL": 18222888576,
     "Q4_0": 20836243072,
     "Q4_1": 22868448896,
     "Q4_K_L": 22662526592,
     "Q4_K_M": 22285080192,
     "Q4_K_S": 21486360192,
     "Q5_K_L": 26227062400,
     "Q5_K_M": 25913185920,
     "Q5_K_S": 25051879040,
     "Q6_K": 30947309184,
     "Q6_K_L": 31193642624,
     "Q8_0": 37812647552,
     "BF16": 71065941536
    }
   },
   "eci": {
    "score": 144,
    "name": "Qwen 3.6 35B-A3B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.1,
      "output": 0.95,
      "tps": 174,
      "ttftMs": 384,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "clover-35b-a3b-preview": {
   "name": "Clover 35B-A3B Preview",
   "repo": "Diffuspace/Clover-35B-A3B-Preview",
   "lab": "diffuspace",
   "params": 34.7,
   "released": "2026-10-28",
   "license": "apache-2.0",
   "parent": "Qwen/Qwen3.6-35B-A3B",
   "hf": {
    "likes": 232,
    "downloads": 3017
   },
   "engines": {
    "arch": "CloverMoeModelLM",
    "vllm": false,
    "llamacpp": true,
    "sglang": false,
    "mlx": false
   },
   "ggufFiles": {
    "repo": "maternion/Clover-35B-A3B-Preview-GGUF",
    "files": {
     "IQ4_XS": 18939304864,
     "Q3_K_M": 16764756896,
     "Q3_K_S": 15182177184,
     "Q4_K_M": 21166750624,
     "Q6_K": 28514145184,
     "Q8_0": 36903132064
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1,
     "repetitionPenalty": 1.05
    }
   }
  },
  "qwen3.5-122b-a10b": {
   "name": "Qwen3.5 122B-A10B",
   "repo": "Qwen/Qwen3.5-122B-A10B",
   "lab": "qwen",
   "params": 125.1,
   "released": "2026-02-24",
   "license": "apache-2.0",
   "hf": {
    "likes": 652,
    "downloads": 994398
   },
   "ollama": {
    "name": "qwen3.5",
    "tag": "122b",
    "pulls": 24161275,
    "sizes": [
     "0.8b",
     "2b",
     "4b",
     "9b",
     "27b",
     "35b",
     "122b"
    ],
    "bytes": 81370024480,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.5-122B-A10B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto --extra-index-url https://wheels.vllm.ai/nightly",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Qwen3.5-122B-A10B-mxfp8"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.5-122B-A10B-GGUF",
    "files": {
     "BF16": 244314011488,
     "MXFP4_MOE": 74664408608,
     "Q3_K_M": 56420881952,
     "Q3_K_S": 52495013376,
     "Q4_K_M": 76536964608,
     "Q4_K_S": 71705126400,
     "Q5_K_M": 91519219200,
     "Q5_K_S": 86385391136,
     "Q6_K": 101009782432,
     "Q8_0": 129871935104,
     "UD-IQ1_M": 34221749440,
     "UD-IQ2_M": 39148942528,
     "UD-IQ2_XXS": 36637668544,
     "UD-IQ3_S": 46556959936,
     "UD-IQ3_XXS": 44745020608,
     "UD-Q2_K_XL": 41845347520,
     "UD-IQ4_NL": 61437470208,
     "UD-IQ4_XS": 60229510656,
     "UD-Q3_K_XL": 56970536480,
     "UD-Q4_K_XL": 77029996032,
     "UD-Q5_K_XL": 91928163840,
     "UD-Q6_K_XL": 112401249920,
     "UD-Q8_K_XL": 170838161152
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.29,
      "output": 2.4,
      "tps": 57,
      "ttftMs": 262,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.4,
      "output": 3.2,
      "tps": 106,
      "ttftMs": 1007,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "qwen3.8-flash-next": {
   "name": "Qwen3.8-Flash-Next",
   "repo": "Qwen/Qwen3.8-Flash-Next",
   "lab": "qwen",
   "params": 180,
   "released": "2026-08-24",
   "license": "other",
   "licenseName": "qwen-community-1.0",
   "hf": {
    "likes": 6737,
    "downloads": 3867800
   },
   "ollama": {
    "name": "qwen3.8-flash-next",
    "pulls": 232806,
    "sizes": []
   },
   "modelscope": "Qwen/Qwen3.8-Flash-Next",
   "engines": {
    "arch": "Qwen4ExpForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.8-Flash-Next",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "Jundot/Qwen3.8-Flash-Next-oQ4e-mtp"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.8-Flash-Next-GGUF",
    "files": {
     "BF16": 354029930496,
     "Q8_0": 188225033248,
     "UD-IQ1_M": 74538755776,
     "UD-IQ1_S": 72546461344,
     "UD-IQ3_XXS": 81961823936,
     "UD-IQ4_XS": 93682584224,
     "UD-Q2_K_XL": 78869128864,
     "UD-Q3_K_XL": 89986353824,
     "UD-Q4_K_XL": 111334654784,
     "UD-Q5_K_XL": 158286406650,
     "UD-Q6_K_XL": 169165382688
    }
   },
   "strata": {
    "repo": "Niko1221/Strata",
    "checked": "2026-11-03",
    "minVramGB": 12,
    "diskGB": 80,
    "gpus": "NVIDIA GeForce RTX 20 to 50 series, AMD Radeon RX 7700 and newer or Radeon AI PRO R9700; Intel Arc (Linux), Apple Silicon Macs, Ryzen AI Max and DGX Spark also work",
    "how": "Your graphics card keeps the experts used most often, your RAM holds all of them and the processor runs the rest; the n-gram lookup table stays on the SSD.",
    "promptTokens": 32768,
    "ram": [
     {
      "gb": 32,
      "pick": "Coder (for code); with a 24 GB card, also Q2_0 or IQ2_XS, slower"
     },
     {
      "gb": 48,
      "pick": "Q2_0 (the fastest) or IQ2_XS"
     },
     {
      "gb": 64,
      "pick": "Any size, up to IQ3_S (the closest to the full model)"
     },
     {
      "gb": 72,
      "pick": "Unsloth UD-IQ4_XS to Q8_0 (4 to 8 bit, 72 to 136 GB of RAM)"
     }
    ],
    "speeds": [
     {
      "setup": "RTX 5070 12 GB, 64 GB RAM",
      "size": "Q2_0",
      "write": 94,
      "read": 2650
     },
     {
      "setup": "RTX 5070 12 GB, 64 GB RAM",
      "size": "IQ2_XS",
      "write": 79,
      "read": 2090
     },
     {
      "setup": "RTX 5070 12 GB, 64 GB RAM",
      "size": "IQ3_XXS",
      "write": 62,
      "read": 1750
     },
     {
      "setup": "RTX 5070 12 GB, 64 GB RAM",
      "size": "IQ3_S",
      "write": 53,
      "read": 1620
     },
     {
      "setup": "RTX 5070 12 GB, 64 GB RAM",
      "size": "Coder",
      "write": 55,
      "read": 2180
     },
     {
      "setup": "RX 9070 XT 16 GB, 47 GB RAM",
      "size": "Q2_0",
      "write": 60,
      "read": 1160
     },
     {
      "setup": "RX 9070 XT 16 GB, 47 GB RAM",
      "size": "IQ2_XS",
      "write": 52,
      "read": 1110
     },
     {
      "setup": "RX 9070 XT 16 GB, 47 GB RAM",
      "size": "Coder",
      "write": 44,
      "read": 1420
     }
    ],
    "version": "v0.2.10",
    "released": "2026-11-02",
    "stars": 38436
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "lfm3-1.7b": {
   "name": "LFM3 1.7B",
   "repo": "LiquidAI/LFM3-1.7B",
   "lab": "liquidai",
   "params": 1.7,
   "released": "2026-10-27",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 1324,
    "downloads": 47817
   },
   "ollama": {
    "name": "lfm3",
    "tag": "1.7b",
    "pulls": 37901,
    "sizes": [
     "1.7b"
    ],
    "bytes": 1099627808,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Lfm3ForCausalLM",
    "vllm": false,
    "llamacpp": true,
    "sglang": false,
    "mlx": false,
    "mlxRepo": "LiquidAI/LFM3-1.7B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "LiquidAI/LFM3-1.7B-GGUF",
    "files": {
     "BF16": 3466626336,
     "F16": 3466626336,
     "Q4_K_M": 1099627808,
     "Q5_K_M": 1258663200,
     "Q6_K": 1427638304,
     "Q8_0": 1846238496,
     "Q4_0": 1049615680
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.1,
     "topK": 50,
     "repetitionPenalty": 1.1
    },
    "languages": [
     "en",
     "ar",
     "zh",
     "fr",
     "de",
     "it",
     "ja",
     "ko",
     "pt",
     "es",
     "vi",
     "th",
     "id",
     "hi",
     "ru",
     "pl"
    ]
   }
  },
  "lfm3-vl-2b": {
   "name": "LFM3-VL 2B",
   "repo": "LiquidAI/LFM3-VL-2B",
   "lab": "liquidai",
   "params": 1.9,
   "released": "2026-10-27",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 222,
    "downloads": 11153
   },
   "ollama": {
    "name": "lfm3-vl",
    "tag": "2b",
    "pulls": 12061,
    "sizes": [
     "2b"
    ],
    "bytes": 1099627808,
    "projector": 378996032,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Lfm3VlForConditionalGeneration",
    "vllm": false,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install \"transformers>=5.21.0\" torch torchvision pillow",
    "sglang": false,
    "mlx": false,
    "mlxRepo": "LiquidAI/LFM3-VL-2B-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "LiquidAI/LFM3-VL-2B-GGUF",
    "files": {
     "BF16": 3466626336,
     "F16": 3466626336,
     "Q4_K_M": 1099627808,
     "Q5_K_M": 1258663200,
     "Q6_K": 1427638304,
     "Q8_0": 1846238496,
     "Q4_0": 1049615648
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.1,
     "topP": 1,
     "topK": 50,
     "minP": 0,
     "repetitionPenalty": 1.1
    },
    "languages": [
     "en",
     "ar",
     "zh",
     "fr",
     "de",
     "it",
     "ja",
     "ko",
     "pt",
     "es",
     "vi",
     "th",
     "id",
     "hi",
     "ru",
     "pl"
    ]
   }
  },
  "d1-2b": {
   "name": "d1 2B",
   "repo": "LiquidAI/d1-2B",
   "lab": "liquidai",
   "params": 1.9,
   "released": "2026-10-27",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 194,
    "downloads": 5952
   },
   "ollama": {
    "name": "d1",
    "tag": "2b",
    "pulls": 31803,
    "sizes": [
     "2b",
     "3b"
    ]
   },
   "engines": {
    "arch": "D1Model",
    "vllm": false,
    "llamacpp": true,
    "sglang": false,
    "mlx": false,
    "mlxRepo": "LiquidAI/d1-2B-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "AtomicChat/d1-2B-GGUF",
    "files": {
     "IQ3_S": 950699776,
     "IQ4_XS": 1054533376,
     "Q4_K_M": 1121232640,
     "Q5_K_M": 1290913536,
     "Q6_K": 1545815808,
     "BF16": 3466628640,
     "Q8_0": 1846241024
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "languages": [
     "en",
     "ar",
     "zh",
     "fr",
     "de",
     "it",
     "ja",
     "ko",
     "pt",
     "es",
     "vi",
     "th",
     "id",
     "hi",
     "ru",
     "pl"
    ]
   }
  },
  "lfm2.5-8b-a1b": {
   "name": "LFM2.5 8B-A1B",
   "repo": "LiquidAI/LFM2.5-8B-A1B",
   "lab": "liquidai",
   "params": 8.5,
   "released": "2026-05-28",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 805,
    "downloads": 30197
   },
   "ollama": {
    "name": "lfm2.5",
    "tag": "8b",
    "pulls": 294561,
    "sizes": [
     "8b",
     "24b"
    ],
    "bytes": 5156064416,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Lfm2MoeForCausalLM",
    "recipe": "https://recipes.vllm.ai/LiquidAI/LFM2.5-8B-A1B",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "LiquidAI/LFM2.5-8B-A1B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "LiquidAI/LFM2.5-8B-A1B-GGUF",
    "files": {
     "BF16": 16947260640,
     "F16": 16947260640,
     "Q4_0": 4844678368,
     "Q4_K_M": 5155564768,
     "Q5_K_M": 6030339296,
     "Q6_K": 6959787232,
     "Q8_0": 9010195680
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "LiquidAI/LFM2.5-8B-A1B-GGUF",
     "kv": "match",
     "ours": 12288,
     "theirs": 12288
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.2,
     "topK": 80,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en",
     "ar",
     "zh",
     "fr",
     "de",
     "ja",
     "ko",
     "es",
     "pt",
     "it"
    ],
    "papers": [
     {
      "id": "2511.23404",
      "title": "LFM2 Technical Report",
      "date": "2025-11-28"
     }
    ]
   }
  },
  "lfm2-24b-a2b": {
   "name": "LFM2 24B-A2B",
   "repo": "LiquidAI/LFM2-24B-A2B",
   "lab": "liquidai",
   "params": 23.8,
   "released": "2026-02-24",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 357,
    "downloads": 3340
   },
   "ollama": {
    "name": "lfm2",
    "tag": "24b",
    "pulls": 1146940,
    "sizes": [
     "24b"
    ],
    "bytes": 14415731328,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Lfm2MoeForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "LiquidAI/LFM2.5-24B-A2B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "LiquidAI/LFM2.5-24B-A2B-GGUF",
    "files": {
     "BF16": 47962094880,
     "F16": 47962094880,
     "Q4_K_M": 14526258464,
     "Q5_K_M": 17029602592,
     "Q6_K": 19689405728,
     "Q8_0": 25493732640,
     "Q4_0": 13578190880
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "LiquidAI/LFM2.5-24B-A2B-GGUF",
     "kv": "match",
     "ours": 20480,
     "theirs": 20480
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "thinking",
    "languages": [
     "en",
     "ar",
     "zh",
     "fr",
     "de",
     "ja",
     "ko",
     "es",
     "pt"
    ],
    "papers": [
     {
      "id": "2511.23404",
      "title": "LFM2 Technical Report",
      "date": "2025-11-28"
     }
    ]
   }
  },
  "gemma-4-12b": {
   "name": "Gemma 4 12B",
   "repo": "google/gemma-4-12B-it",
   "lab": "google",
   "params": 12,
   "released": "2026-05-23",
   "license": "apache-2.0",
   "hf": {
    "likes": 1712,
    "downloads": 1718827
   },
   "ollama": {
    "name": "gemma4",
    "tag": "12b",
    "pulls": 28427032,
    "sizes": [
     "e2b",
     "e4b",
     "12b",
     "26b",
     "31b"
    ],
    "bytes": 7381383680,
    "projector": 175115616,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Gemma4UnifiedForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/gemma-4-12B-it-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/gemma-4-12b-it-GGUF",
    "files": {
     "BF16": 23832066656,
     "IQ4_NL": 6716357440,
     "IQ4_XS": 6375734080,
     "Q3_K_M": 5693872960,
     "Q3_K_S": 5135014720,
     "Q4_0": 6738475840,
     "Q4_1": 7397604160,
     "Q4_K_M": 7121861440,
     "Q4_K_S": 6764526400,
     "Q5_K_M": 8413576000,
     "Q5_K_S": 8204680000,
     "Q6_K": 9786022720,
     "Q8_0": 12669647680,
     "UD-IQ2_M": 4213353280,
     "UD-IQ3_XXS": 4639716160,
     "UD-Q2_K_XL": 4661419840,
     "UD-Q3_K_XL": 6022684480,
     "UD-Q4_K_XL": 7366423360,
     "UD-Q5_K_XL": 8606021440,
     "UD-Q6_K_XL": 10685012800,
     "UD-Q8_K_XL": 13637327680
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 64
    },
    "papers": [
     {
      "id": "2607.02770",
      "title": "Gemma 4 Technical Report",
      "date": "2026-07-02"
     }
    ],
    "training": {
     "name": "Gemma 4 12B",
     "hardware": "Google TPU v4",
     "chips": 12288,
     "confidence": "Confident"
    }
   }
  },
  "gemma-4-31b": {
   "name": "Gemma 4 31B",
   "repo": "google/gemma-4-31B-it",
   "lab": "google",
   "params": 31.3,
   "released": "2026-03-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 4275,
    "downloads": 8147734
   },
   "ollama": {
    "name": "gemma4",
    "tag": "31b",
    "pulls": 28427032,
    "sizes": [
     "e2b",
     "e4b",
     "12b",
     "26b",
     "31b"
    ],
    "bytes": 18670033120,
    "projector": 1200726368,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Gemma4ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/gemma-4-31B-it-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/gemma-4-31B-it-GGUF",
    "files": {
     "BF16": 61413190528,
     "IQ4_NL": 17287670720,
     "IQ4_XS": 16372460480,
     "Q3_K_M": 14736608192,
     "Q3_K_S": 13210856384,
     "Q4_0": 17338248128,
     "Q4_1": 19118091200,
     "Q4_K_M": 18323733440,
     "Q4_K_S": 17399835584,
     "Q5_K_M": 21658401728,
     "Q5_K_S": 21124672448,
     "Q6_K": 25201486784,
     "Q8_0": 32635677632,
     "UD-IQ2_M": 10752820160,
     "UD-IQ2_XXS": 8534295488,
     "UD-IQ3_XXS": 11837782976,
     "UD-Q2_K_XL": 11774991296,
     "UD-Q3_K_XL": 15380222912,
     "UD-Q4_K_XL": 18822970304,
     "UD-Q5_K_XL": 21890429888,
     "UD-Q6_K_XL": 27521338304,
     "UD-Q8_K_XL": 35020041152
    }
   },
   "eci": {
    "score": 143,
    "name": "Gemma 4 31B IT"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.14,
      "output": 0.4,
      "tps": 38,
      "ttftMs": 647,
      "context": 262144
     },
     {
      "name": "DeepInfra",
      "input": 0.2,
      "output": 0.4,
      "tps": 71,
      "ttftMs": 255,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 64
    },
    "papers": [
     {
      "id": "2607.02770",
      "title": "Gemma 4 Technical Report",
      "date": "2026-07-02"
     }
    ]
   }
  },
  "gemma-4-26b-a4b": {
   "name": "Gemma 4 26B-A4B",
   "repo": "google/gemma-4-26B-A4B-it",
   "lab": "google",
   "params": 25.8,
   "released": "2026-03-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 1730,
    "downloads": 5944935
   },
   "ollama": {
    "name": "gemma4",
    "tag": "26b",
    "pulls": 28427032,
    "sizes": [
     "e2b",
     "e4b",
     "12b",
     "26b",
     "31b"
    ],
    "bytes": 17074419072,
    "projector": 1194828128,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Gemma4ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/gemma-4-26B-A4B-it-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/gemma-4-26B-A4B-it-GGUF",
    "files": {
     "BF16": 50505137824,
     "MXFP4_MOE": 16551048928,
     "Q8_0": 26859861728,
     "UD-IQ2_M": 10014755296,
     "UD-IQ2_XXS": 9922480608,
     "UD-IQ3_S": 11289671136,
     "UD-IQ3_XXS": 11416548832,
     "UD-IQ4_NL": 13613037280,
     "UD-IQ4_XS": 13597177568,
     "UD-Q2_K_XL": 10546934240,
     "UD-Q3_K_M": 12728497888,
     "UD-Q3_K_XL": 12907280096,
     "UD-Q4_K_M": 16947541728,
     "UD-Q4_K_S": 16487610080,
     "UD-Q4_K_XL": 17010980576,
     "UD-Q5_K_M": 21150365408,
     "UD-Q5_K_S": 18850707168,
     "UD-Q5_K_XL": 21217769184,
     "UD-Q6_K": 23172478688,
     "UD-Q6_K_XL": 23295391456,
     "UD-Q8_K_XL": 27636232928
    }
   },
   "eci": {
    "score": 142,
    "name": "Gemma 4 26B A4B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.07,
      "output": 0.34,
      "tps": 83,
      "ttftMs": 189,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.13,
      "output": 0.4,
      "tps": 98,
      "ttftMs": 345,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 64
    },
    "papers": [
     {
      "id": "2607.02770",
      "title": "Gemma 4 Technical Report",
      "date": "2026-07-02"
     }
    ]
   }
  },
  "gpt-oss-20b": {
   "name": "gpt-oss 20B",
   "repo": "openai/gpt-oss-20b",
   "lab": "openai",
   "params": 20.9,
   "released": "2025-08-04",
   "license": "apache-2.0",
   "hf": {
    "likes": 5263,
    "downloads": 5939725
   },
   "ollama": {
    "name": "gpt-oss",
    "tag": "20b",
    "pulls": 14511395,
    "sizes": [
     "20b",
     "120b"
    ],
    "bytes": 13793422816,
    "quant": "MXFP4"
   },
   "engines": {
    "arch": "GptOssForCausalLM",
    "recipe": "https://recipes.vllm.ai/openai/gpt-oss-20b",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/gpt-oss-20b-MXFP4-Q8"
   },
   "ggufFiles": {
    "repo": "unsloth/gpt-oss-20b-GGUF",
    "files": {
     "F16": 13792639168,
     "Q2_K": 11468317888,
     "Q2_K_L": 11757884608,
     "Q3_K_M": 11506103488,
     "Q3_K_S": 11463894208,
     "Q4_0": 11501495488,
     "Q4_1": 11577504448,
     "Q4_K_M": 11624759488,
     "Q4_K_S": 11618492608,
     "Q5_K_M": 11717357248,
     "Q5_K_S": 11711827648,
     "Q6_K": 12041000128,
     "Q8_0": 12109567168,
     "UD-Q4_K_XL": 11872347328,
     "UD-Q6_K_XL": 12041000128,
     "UD-Q8_K_XL": 13195442368
    }
   },
   "eci": {
    "score": 138,
    "name": "gpt-oss-20b"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.03,
      "output": 0.14,
      "tps": 96,
      "ttftMs": 318,
      "context": 131072
     },
     {
      "name": "OVHcloud",
      "input": 0.05,
      "output": 0.18,
      "tps": 38,
      "ttftMs": 501,
      "context": 131072
     },
     {
      "name": "Nscale",
      "input": 0.05,
      "output": 0.2,
      "tps": 162,
      "ttftMs": 381,
      "context": 131072
     },
     {
      "name": "Groq",
      "input": 0.1,
      "output": 0.5,
      "tps": 650,
      "ttftMs": 326,
      "context": 131072
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "efforts": [
     "low",
     "medium",
     "high"
    ],
    "effortVia": "the system prompt (\"Reasoning: high\")",
    "papers": [
     {
      "id": "2508.10925",
      "title": "gpt-oss-120b & gpt-oss-20b Model Card",
      "date": "2025-08-08"
     }
    ],
    "cutoff": "2024-06-30",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "gpt-oss-20b",
     "flop": 5.49e+23,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "confidence": "Confident"
    }
   }
  },
  "gpt-oss-120b": {
   "name": "gpt-oss 120B",
   "repo": "openai/gpt-oss-120b",
   "lab": "openai",
   "params": 116.8,
   "released": "2025-08-04",
   "license": "apache-2.0",
   "hf": {
    "likes": 5482,
    "downloads": 2475702
   },
   "ollama": {
    "name": "gpt-oss",
    "tag": "120b",
    "pulls": 14511395,
    "sizes": [
     "20b",
     "120b"
    ],
    "bytes": 65369800832,
    "quant": "MXFP4"
   },
   "engines": {
    "arch": "GptOssForCausalLM",
    "recipe": "https://recipes.vllm.ai/openai/gpt-oss-120b",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/gpt-oss-120b-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "unsloth/gpt-oss-120b-GGUF",
    "files": {
     "Q2_K": 62570256992,
     "Q2_K_L": 62859823712,
     "Q3_K_M": 62626843232,
     "Q3_K_S": 62563621472,
     "Q4_0": 62620023392,
     "Q4_1": 62715938912,
     "Q4_K_M": 62768723552,
     "Q4_K_S": 62759138912,
     "Q5_K_M": 62889522272,
     "Q5_K_S": 62881227872,
     "Q6_K": 63284496960,
     "Q8_0": 63387347520,
     "UD-Q4_K_XL": 63016311392,
     "UD-Q6_K_XL": 63284496960,
     "UD-Q8_K_XL": 64473222720,
     "F16": 65369017728
    }
   },
   "eci": {
    "score": 140,
    "name": "gpt-oss-120b"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.037,
      "output": 0.17,
      "tps": 26,
      "ttftMs": 357,
      "context": 131072
     },
     {
      "name": "Novita",
      "input": 0.05,
      "output": 0.25,
      "tps": 151,
      "ttftMs": 503,
      "context": 131072
     },
     {
      "name": "Nscale",
      "input": 0.1,
      "output": 0.4,
      "tps": 115,
      "ttftMs": 353,
      "context": 131072
     },
     {
      "name": "OVHcloud",
      "input": 0.09,
      "output": 0.47,
      "tps": 21,
      "ttftMs": 377,
      "context": 131072
     },
     {
      "name": "Baseten",
      "input": 0.1,
      "output": 0.5,
      "tps": 153,
      "ttftMs": 181,
      "context": 128072
     },
     {
      "name": "Groq",
      "input": 0.15,
      "output": 0.75,
      "tps": 421,
      "ttftMs": 248,
      "context": 131072
     },
     {
      "name": "Cerebras",
      "input": 0.35,
      "output": 0.75,
      "tps": 999,
      "ttftMs": 328,
      "context": 131072
     }
    ]
   },
   "verified": {
    "inferencex": {
     "model": "gpt-oss-120b",
     "runs": [
      {
       "id": "409792",
       "day": "2026-05-17",
       "gpu": "h100",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 34.38,
       "kvGiB": 32.73,
       "kvTokens": 1051112,
       "utilization": 0.9,
       "tps": 193.9,
       "ttft": 0.058,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/25956497716/attempts/2"
      },
      {
       "id": "409799",
       "day": "2026-05-17",
       "gpu": "h100",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 17.22,
       "kvGiB": 49.87,
       "kvTokens": 3200119,
       "utilization": 0.9,
       "tps": 243.5,
       "ttft": 0.045,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/25956497716/attempts/2"
      },
      {
       "id": "409806",
       "day": "2026-05-17",
       "gpu": "h100",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 8.66,
       "kvGiB": 58.32,
       "kvTokens": 7484972,
       "utilization": 0.9,
       "tps": 266.4,
       "ttft": 0.035,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/25956497716/attempts/2"
      },
      {
       "id": "416874",
       "day": "2026-05-30",
       "gpu": "h200",
       "gpus": 1,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 66.14,
       "kvGiB": 57.25,
       "kvTokens": 825734,
       "utilization": 0.9,
       "tps": 157.3,
       "ttft": 0.082,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696231118/attempts/1"
      },
      {
       "id": "416860",
       "day": "2026-05-30",
       "gpu": "h200",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 34.38,
       "kvGiB": 88.52,
       "kvTokens": 2553520,
       "utilization": 0.9,
       "tps": 204.1,
       "ttft": 0.057,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696231118/attempts/1"
      },
      {
       "id": "416877",
       "day": "2026-05-30",
       "gpu": "h200",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 17.22,
       "kvGiB": 106.33,
       "kvTokens": 6134797,
       "utilization": 0.9,
       "tps": 248.1,
       "ttft": 0.041,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696231118/attempts/1"
      },
      {
       "id": "416889",
       "day": "2026-05-30",
       "gpu": "h200",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 8.66,
       "kvGiB": 114.86,
       "kvTokens": 13254311,
       "utilization": 0.9,
       "tps": 270.2,
       "ttft": 0.034,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696231118/attempts/1"
      },
      {
       "id": "417473",
       "day": "2026-05-31",
       "gpu": "b200",
       "gpus": 1,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 68.84,
       "kvGiB": 88.18,
       "kvTokens": 2543846,
       "utilization": 0.9,
       "tps": 288.6,
       "ttft": 0.031,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696226421/attempts/1"
      },
      {
       "id": "417499",
       "day": "2026-05-31",
       "gpu": "b200",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 34.46,
       "kvGiB": 121.47,
       "kvTokens": 7008119,
       "utilization": 0.9,
       "tps": 341.9,
       "ttft": 0.025,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696226421/attempts/1"
      },
      {
       "id": "417472",
       "day": "2026-05-31",
       "gpu": "b200",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 17.28,
       "kvGiB": 138.78,
       "kvTokens": 16014647,
       "utilization": 0.9,
       "tps": 392.1,
       "ttft": 0.023,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696226421/attempts/1"
      },
      {
       "id": "417474",
       "day": "2026-05-31",
       "gpu": "b200",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 11.39,
       "kvGiB": 134.67,
       "kvTokens": 31080233,
       "utilization": 0.9,
       "tps": 415.6,
       "ttft": 0.022,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696226421/attempts/1"
      },
      {
       "id": "200928",
       "day": "2026-04-21",
       "gpu": "mi300x",
       "gpus": 1,
       "engine": "vllm",
       "format": "native",
       "version": "v0.17.0",
       "weightsGiB": 67.7,
       "kvGiB": 110.46,
       "kvTokens": 1608704,
       "utilization": 0.95,
       "tps": 31.7,
       "ttft": 0.133,
       "conc": 64,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/24699285782/attempts/1"
      },
      {
       "id": "200963",
       "day": "2026-04-21",
       "gpu": "mi300x",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.17.0",
       "weightsGiB": 35.26,
       "kvGiB": 142.57,
       "kvTokens": 4152704,
       "utilization": 0.95,
       "tps": 172,
       "ttft": 0.062,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/24699285782/attempts/1"
      },
      {
       "id": "200957",
       "day": "2026-04-21",
       "gpu": "mi300x",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.17.0",
       "weightsGiB": 17.83,
       "kvGiB": 159.88,
       "kvTokens": 9312896,
       "utilization": 0.95,
       "tps": 133.7,
       "ttft": 0.058,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/24699285782/attempts/1"
      },
      {
       "id": "200961",
       "day": "2026-04-21",
       "gpu": "mi300x",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.17.0",
       "weightsGiB": 8.92,
       "kvGiB": 167.71,
       "kvTokens": 19515520,
       "utilization": 0.95,
       "tps": 249,
       "ttft": 0.033,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/24699285782/attempts/1"
      },
      {
       "id": "417118",
       "day": "2026-05-30",
       "gpu": "mi325x",
       "gpus": 1,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 68.7,
       "kvGiB": 170.94,
       "kvTokens": 2455432,
       "utilization": 0.95,
       "tps": 72.6,
       "ttft": 0.089,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696264378/attempts/1"
      },
      {
       "id": "417113",
       "day": "2026-05-30",
       "gpu": "mi325x",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 34.45,
       "kvGiB": 201.86,
       "kvTokens": 5798978,
       "utilization": 0.95,
       "tps": 96,
       "ttft": 0.058,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696264378/attempts/1"
      },
      {
       "id": "417122",
       "day": "2026-05-30",
       "gpu": "mi325x",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 17.27,
       "kvGiB": 218.91,
       "kvTokens": 12576936,
       "utilization": 0.95,
       "tps": 105.4,
       "ttft": 0.043,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696264378/attempts/1"
      },
      {
       "id": "417120",
       "day": "2026-05-30",
       "gpu": "mi325x",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 11.39,
       "kvGiB": 223.71,
       "kvTokens": 25684266,
       "utilization": 0.95,
       "tps": 109.8,
       "ttft": 0.039,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696264378/attempts/1"
      },
      {
       "id": "419963",
       "day": "2026-06-05",
       "gpu": "mi355x",
       "gpus": 1,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 68.7,
       "kvGiB": 200.89,
       "kvTokens": 2885617,
       "utilization": 0.95,
       "tps": 238.3,
       "ttft": 0.04,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26998598877/attempts/1"
      },
      {
       "id": "419976",
       "day": "2026-06-05",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 17.27,
       "kvGiB": 248.34,
       "kvTokens": 14261728,
       "utilization": 0.95,
       "tps": 318,
       "ttft": 0.03,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26998598877/attempts/1"
      },
      {
       "id": "419978",
       "day": "2026-06-05",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 11.39,
       "kvGiB": 252.61,
       "kvTokens": 29025855,
       "utilization": 0.95,
       "tps": 312.6,
       "ttft": 0.029,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26998598877/attempts/1"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "efforts": [
     "low",
     "medium",
     "high"
    ],
    "effortVia": "the system prompt (\"Reasoning: high\")",
    "papers": [
     {
      "id": "2508.10925",
      "title": "gpt-oss-120b & gpt-oss-20b Model Card",
      "date": "2025-08-08"
     }
    ],
    "cutoff": "2024-06-30",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "gpt-oss-120b",
     "flop": 4.94e+24,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "confidence": "Confident"
    }
   }
  },
  "llama-4-scout": {
   "name": "Llama 4 Scout 17B-16E",
   "repo": "meta-llama/Llama-4-Scout-17B-16E-Instruct",
   "lab": "meta-llama",
   "params": 108.6,
   "released": "2025-04-02",
   "license": "other",
   "licenseName": "llama4",
   "gated": true,
   "hf": {
    "likes": 1384,
    "downloads": 105430
   },
   "engines": {
    "arch": "Llama4ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/meta-llama/Llama-4-Scout-17B-16E-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlxRepo": "baa-ai/Llama-4-Scout-17B-16E-Instruct-RAM-60GB-MLX"
   },
   "ggufFiles": {
    "repo": "unsloth/Llama-4-Scout-17B-16E-Instruct-GGUF",
    "files": {
     "BF16": 215561682208,
     "IQ4_NL": 60947033792,
     "IQ4_XS": 57651883712,
     "Q2_K": 39563317760,
     "Q2_K_L": 39805775360,
     "Q3_K_S": 46740372480,
     "UD-IQ1_M": 34988428800,
     "UD-IQ1_S": 32470126080,
     "UD-IQ2_M": 39078694400,
     "UD-IQ2_XXS": 37400972800,
     "UD-IQ3_XXS": 45725847040,
     "UD-Q2_K_XL": 42376957440,
     "UD-Q3_K_XL": 49019031040,
     "UD-TQ1_0": 29261483520,
     "Q3_K_M": 51755187392,
     "Q4_0": 61182963392,
     "Q4_1": 67586260672,
     "Q4_K_M": 65359900352,
     "Q4_K_S": 61452971712,
     "Q5_K_M": 76546444992,
     "Q5_K_S": 74256944832,
     "Q6_K": 88432148672,
     "Q8_0": 114531589472,
     "UD-Q4_K_XL": 61998108352,
     "UD-Q5_K_XL": 79146503872,
     "UD-Q6_K_XL": 94073216160,
     "UD-Q8_K_XL": 128179256608
    }
   },
   "eci": {
    "score": 130,
    "name": "Llama 4 Scout"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.09,
      "output": 0.29,
      "tps": 70,
      "ttftMs": 324,
      "context": 890000
     },
     {
      "name": "DeepInfra",
      "input": 0.1,
      "output": 0.3,
      "tps": 34,
      "ttftMs": 628,
      "context": 327680
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "languages": [
     "ar",
     "de",
     "en",
     "es",
     "fr",
     "hi",
     "id",
     "it",
     "pt",
     "th",
     "tl",
     "vi"
    ],
    "cutoff": "2024-08-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Llama 4 Scout",
     "flop": 4.08e+24,
     "tokens": 30000000000000,
     "confidence": "Likely"
    }
   }
  },
  "llama-4-maverick": {
   "name": "Llama 4 Maverick 17B-128E",
   "repo": "meta-llama/Llama-4-Maverick-17B-128E-Instruct",
   "lab": "meta-llama",
   "params": 401.6,
   "released": "2025-04-01",
   "license": "other",
   "licenseName": "llama4",
   "gated": true,
   "hf": {
    "likes": 520,
    "downloads": 11569
   },
   "engines": {
    "arch": "Llama4ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlxRepo": "baa-ai/Llama-4-Maverick-17B-128E-Instruct-RAM-170GB-MLX"
   },
   "ggufFiles": {
    "repo": "unsloth/Llama-4-Maverick-17B-128E-Instruct-GGUF",
    "files": {
     "BF16": 801469242368,
     "IQ4_NL": 225767442656,
     "IQ4_XS": 214324857120,
     "UD-TQ1_0": 105711920832,
     "Q2_K": 145645120544,
     "Q2_K_L": 145887578144,
     "Q3_K_M": 191068984960,
     "Q3_K_S": 172655990400,
     "Q4_0": 226766211296,
     "Q4_1": 250714806624,
     "Q4_K_M": 242767153440,
     "Q4_K_S": 227799058688,
     "Q5_K_M": 284467259776,
     "Q5_K_S": 275693627776,
     "Q6_K": 328773622752,
     "Q8_0": 425817094048,
     "UD-IQ1_M": 127539546144,
     "UD-IQ1_S": 120769472544,
     "UD-IQ2_M": 141235914784,
     "UD-IQ2_XXS": 135196116992,
     "UD-IQ3_XXS": 169314814080,
     "UD-Q2_K_XL": 152655890592,
     "UD-Q3_K_XL": 179554486432,
     "UD-Q4_K_XL": 232134674688,
     "UD-Q5_K_XL": 287011613056,
     "UD-Q6_K_XL": 341078390912,
     "UD-Q8_K_XL": 459990636896
    }
   },
   "eci": {
    "score": 132,
    "name": "Llama 4 Maverick"
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "languages": [
     "ar",
     "de",
     "en",
     "es",
     "fr",
     "hi",
     "id",
     "it",
     "pt",
     "th",
     "tl",
     "vi"
    ],
    "cutoff": "2024-08-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Llama 4 Maverick",
     "flop": 2.244000000001e+24,
     "tokens": 30000000000000,
     "confidence": "Likely"
    }
   }
  },
  "kolibri-1": {
   "name": "Kolibri-1",
   "repo": "Aleph-Alpha/Kolibri-1",
   "lab": "aleph-alpha",
   "params": 78.1,
   "released": "2026-10-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 1000,
    "downloads": 23818
   },
   "engines": {
    "arch": "Kolibri1ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install 'aleph-alpha-inference>=1'",
    "sglang": false,
    "mlx": false,
    "mlxRepo": "eins78/Kolibri-1-mlx-mixed-4-8-bit"
   },
   "ggufFiles": {
    "repo": "Hob-forge/Kolibri-1-GGUF",
    "files": {
     "Q2_K": 28634017760,
     "Q3_K_M": 37523996640,
     "Q4_K_M": 47454113472,
     "Q5_K_M": 55588769664,
     "Q6_K": 64231841664,
     "Q8_0": 83135393696
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.97,
     "topK": 128
    },
    "languages": [
     "de",
     "en"
    ]
   }
  },
  "flint": {
   "name": "Recursive Flint",
   "repo": "RecursiveSI/flint",
   "lab": "recursivesi",
   "params": 39.8,
   "released": "2026-10-21",
   "license": "apache-2.0",
   "hf": {
    "likes": 1315,
    "downloads": 32677
   },
   "ollama": {
    "name": "flint",
    "tag": "40b",
    "pulls": 47426,
    "sizes": [
     "40b"
    ],
    "bytes": 22863084160,
    "quant": "NVFP4"
   },
   "engines": {
    "arch": "FlintForCausalLM",
    "recipe": "https://recipes.vllm.ai/RecursiveSI/flint",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "RecursiveSI/flint-int4"
   },
   "ggufFiles": {
    "repo": "unsloth/flint-GGUF",
    "files": {
     "BF16": 79576479200,
     "Q8_0": 42301076928,
     "UD-IQ1_M": 11352241600,
     "UD-IQ2_XXS": 11855541696,
     "UD-IQ3_XXS": 14535427520,
     "UD-Q2_K_XL": 13562207680,
     "UD-Q3_K_XL": 18494977472,
     "UD-Q4_K_XL": 25054688704,
     "UD-Q5_K_XL": 29919491520,
     "UD-Q6_K_XL": 36319999424
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "nemotron-labs-dory-1.0-4b": {
   "name": "Nemotron Labs Dory 1.0 4B",
   "repo": "nvidia/NVIDIA-Nemotron-Labs-Dory1.0-4B-BF16",
   "lab": "nvidia",
   "params": 4,
   "released": "2026-10-16",
   "license": "other",
   "licenseName": "openmdw-1.1",
   "hf": {
    "likes": 201,
    "downloads": 9943
   },
   "engines": {
    "arch": "DoryForCausalLM",
    "vllm": true,
    "llamacpp": false,
    "vllmCard": true,
    "sglang": false,
    "mlx": false
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en"
    ]
   }
  },
  "step-3.5-flash": {
   "name": "Step 3.5 Flash",
   "repo": "stepfun-ai/Step-3.5-Flash",
   "lab": "stepfun-ai",
   "params": 199.4,
   "released": "2026-02-01",
   "license": "apache-2.0",
   "hf": {
    "likes": 847,
    "downloads": 226377
   },
   "engines": {
    "arch": "Step3p5ForCausalLM",
    "recipe": "https://recipes.vllm.ai/stepfun-ai/Step-3.5-Flash",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Step-3.5-Flash-4bit"
   },
   "ggufFiles": {
    "repo": "stepfun-ai/Step-3.5-Flash-GGUF-Q8_0",
    "files": {
     "Q8_0": 209417873376
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.1,
      "output": 0.3,
      "tps": 25,
      "ttftMs": 547,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "papers": [
     {
      "id": "2602.10604",
      "title": "Step 3.5 Flash: Open Frontier-Level Intelligence with 11B Active Parameters",
      "date": "2026-02-11"
     },
     {
      "id": "2601.05593",
      "title": "PaCoRe: Learning to Scale Test-Time Compute with Parallel Coordinated Reasoning",
      "date": "2026-01-09"
     },
     {
      "id": "2507.19427",
      "title": "Step-3 is Large yet Affordable: Model-system Co-design for Cost-effective Decoding",
      "date": "2025-07-25"
     }
    ]
   }
  },
  "step-3.7-flash": {
   "name": "Step 3.7 Flash",
   "repo": "stepfun-ai/Step-3.7-Flash",
   "lab": "stepfun-ai",
   "params": 201.4,
   "released": "2026-05-23",
   "license": "apache-2.0",
   "hf": {
    "likes": 462,
    "downloads": 11749
   },
   "modelscope": "stepfun-ai/Step-3.7-Flash",
   "engines": {
    "arch": "Step3p7ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/stepfun-ai/Step-3.7-Flash",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "mlx-community/Step-3.7-Flash-4bit"
   },
   "ggufFiles": {
    "repo": "stepfun-ai/Step-3.7-Flash-GGUF",
    "files": {
     "BF16": 394017423776,
     "IQ3_XXS": 75758680960,
     "IQ4_XS": 104993562624,
     "Q3_K_L": 102504428544,
     "Q3_K_M": 93801444352,
     "Q4_K_S": 111499087872,
     "Q8_0": 209417871264
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.2,
      "output": 1.15,
      "tps": 17,
      "ttftMs": 2294,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "languages": [
     "en"
    ]
   }
  },
  "laguna-s-2.1": {
   "name": "Laguna S 2.1",
   "repo": "poolside/Laguna-S-2.1",
   "lab": "poolside",
   "params": 117.6,
   "released": "2026-07-21",
   "license": "openmdw-1.1",
   "hf": {
    "likes": 1077,
    "downloads": 633997
   },
   "ollama": {
    "name": "laguna-s-2.1",
    "pulls": 187115,
    "sizes": [],
    "bytes": 96031829760,
    "quant": "Q8_0"
   },
   "modelscope": "poolside/Laguna-S-2.1",
   "engines": {
    "arch": "LagunaForCausalLM",
    "recipe": "https://recipes.vllm.ai/poolside/Laguna-S-2.1",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "poolside/Laguna-S-2.1-NVFP4-mlx"
   },
   "ggufFiles": {
    "repo": "poolside/Laguna-S-2.1-GGUF",
    "files": {
     "F16": 235202258240,
     "Q4_K_M": 96031829760,
     "Q8_0": 128750823168
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1,
     "topK": 20,
     "minP": 0
    }
   }
  },
  "laguna-xs-2.1": {
   "name": "Laguna XS 2.1",
   "repo": "poolside/Laguna-XS-2.1",
   "lab": "poolside",
   "params": 33.4,
   "released": "2026-06-20",
   "license": "openmdw-1.1",
   "hf": {
    "likes": 263,
    "downloads": 776738
   },
   "ollama": {
    "name": "laguna-xs-2.1",
    "pulls": 148593,
    "sizes": [],
    "bytes": 20274300032,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "LagunaForCausalLM",
    "recipe": "https://recipes.vllm.ai/poolside/Laguna-XS-2.1",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install 'vllm>=0.21.0'",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "poolside/Laguna-XS-2.1-NVFP4-mlx"
   },
   "ggufFiles": {
    "repo": "bartowski/Laguna-XS-2.1-GGUF",
    "files": {
     "IQ2_M": 11635506048,
     "IQ2_S": 10620330880,
     "IQ2_XS": 10386596736,
     "IQ2_XXS": 9404976000,
     "IQ3_M": 16282120064,
     "IQ3_XS": 15563714432,
     "IQ3_XXS": 14285958016,
     "IQ4_NL": 19212625280,
     "IQ4_XS": 18211212672,
     "Q2_K": 12157833600,
     "Q2_K_L": 12358537600,
     "Q3_K_L": 16129879936,
     "Q3_K_M": 15575904128,
     "Q3_K_S": 14894198656,
     "Q3_K_XL": 16309710720,
     "Q4_0": 19210003840,
     "Q4_1": 21183993216,
     "Q4_K_L": 20700620160,
     "Q4_K_M": 20548085120,
     "Q4_K_S": 19781477760,
     "Q5_K_L": 24131880320,
     "Q5_K_M": 24005035392,
     "Q5_K_S": 23226631552,
     "Q6_K": 29036854144,
     "Q6_K_L": 29136403328,
     "Q8_0": 35597116800,
     "BF16": 66930226496
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1,
     "topK": 20,
     "minP": 0
    }
   }
  },
  "command-a-plus": {
   "name": "Command A+",
   "repo": "CohereLabs/command-a-plus-05-2026-bf16",
   "lab": "coherelabs",
   "params": 218.8,
   "released": "2026-05-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 146,
    "downloads": 17373
   },
   "engines": {
    "arch": "Cohere2VisionForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm>=0.21.0",
    "sglang": true,
    "mlx": false
   },
   "ggufFiles": {
    "repo": "DevQuasar/CohereLabs.command-a-plus-05-2026-bf16-GGUF-EXPERIMENTAL",
    "files": {
     "Q2_K": 79662922176,
     "Q3_K_M": 104541436416,
     "Q4_K_M": 132266310432,
     "Q5_K_M": 154974272544,
     "Q6_K": 179101481984,
     "Q8_0": 231956004320
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "effort",
    "languages": [
     "en",
     "ar",
     "bg",
     "bn",
     "ca",
     "cs",
     "da",
     "de",
     "el",
     "es",
     "et",
     "fa",
     "fi",
     "fr",
     "ga",
     "he",
     "hi",
     "hr",
     "hu",
     "id",
     "is",
     "it",
     "ja",
     "ko",
     "lt",
     "lv",
     "ms",
     "mt",
     "nl",
     "no",
     "pa",
     "pl",
     "pt",
     "ro",
     "ru",
     "sk",
     "sl",
     "sr",
     "sv",
     "ta",
     "te",
     "th",
     "tr",
     "uk",
     "ur",
     "vi",
     "zh"
    ]
   }
  },
  "inkling-small": {
   "name": "Inkling Small",
   "repo": "thinkingmachines/Inkling-Small",
   "lab": "thinkingmachines",
   "params": 266,
   "released": "2026-07-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 435,
    "downloads": 1364234
   },
   "modelscope": "thinkingmachines/Inkling-Small",
   "engines": {
    "arch": "InklingForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/thinkingmachines/Inkling-Small",
    "vllm": true,
    "llamacpp": false,
    "gguf": {
     "repo": "unsloth/Inkling-Small-GGUF",
     "arch": "inkling",
     "llamacpp": false
    },
    "sglang": true,
    "mlx": false,
    "mlxRepo": "mlx-community/Inkling-Small-mlx-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Inkling-Small-GGUF",
    "files": {
     "BF16": 527412980416,
     "MXFP4_MOE": 158039402688,
     "Q8_0": 280278198720,
     "UD-IQ1_M": 78830168032,
     "UD-IQ1_S": 74770081728,
     "UD-IQ2_M": 82436908992,
     "UD-IQ2_XXS": 82286274496,
     "UD-IQ3_S": 107460376672,
     "UD-IQ3_XXS": 97930917856,
     "UD-IQ4_NL": 130090471520,
     "UD-IQ4_XS": 127406116928,
     "UD-Q2_K_XL": 87939835872,
     "UD-Q3_K_M": 119354964032,
     "UD-Q3_K_XL": 119554379840,
     "UD-Q4_K_M": 162537607392,
     "UD-Q4_K_S": 152337060032,
     "UD-Q4_K_XL": 163273894112,
     "UD-Q5_K_M": 196090128608,
     "UD-Q5_K_S": 184211859680,
     "UD-Q5_K_XL": 196660553952,
     "UD-Q6_K": 218907142464,
     "UD-Q6_K_XL": 239710890304,
     "UD-Q8_K_XL": 288419736000
    }
   },
   "eci": {
    "score": 150,
    "name": "Inkling-Small"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.45,
      "output": 1.2,
      "tps": 130,
      "ttftMs": 337,
      "context": 524288
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "audio"
    ],
    "tools": true,
    "thinking": "effort"
   }
  },
  "muse-glimmer-30b": {
   "name": "Muse Glimmer 30B",
   "repo": "meta-models/Muse-Glimmer-30B",
   "lab": "meta-models",
   "params": 29.8,
   "released": "2026-08-09",
   "license": "apache-2.0",
   "hf": {
    "likes": 2108,
    "downloads": 194076
   },
   "ollama": {
    "name": "muse-glimmer",
    "tag": "30b",
    "pulls": 358401,
    "sizes": [
     "30b"
    ],
    "bytes": 16756681056,
    "projector": 1400328928,
    "quant": "Q4_K_M"
   },
   "modelscope": "meta-models/Muse-Glimmer-30B",
   "engines": {
    "arch": "MuseGlimmerForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/meta-models/Muse-Glimmer-30B",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Muse-Glimmer-30B-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Muse-Glimmer-30B-GGUF",
    "files": {
     "IQ2_M": 10657479200,
     "IQ2_S": 10040015392,
     "IQ2_XS": 9582585120,
     "IQ2_XXS": 8920818976,
     "IQ3_M": 13106238240,
     "IQ3_XS": 12315026208,
     "IQ3_XXS": 11546640928,
     "IQ4_NL": 16238568480,
     "IQ4_XS": 15435096096,
     "Q2_K": 11035579936,
     "Q2_K_L": 12348891936,
     "Q3_K_L": 14782112544,
     "Q3_K_M": 13962519328,
     "Q3_K_S": 12789199648,
     "Q3_K_XL": 15958840096,
     "Q4_0": 16265565216,
     "Q4_1": 17828207648,
     "Q4_K_L": 18304441120,
     "Q4_K_M": 17306324000,
     "Q4_K_S": 16320943136,
     "Q5_K_L": 20935584544,
     "Q5_K_M": 20105571360,
     "Q5_K_S": 19440690208,
     "Q6_K": 23414418720,
     "Q6_K_L": 24065821472,
     "Q8_0": 29612958496,
     "BF16": 55725511360
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.3,
      "output": 1.2,
      "tps": 81,
      "ttftMs": 425,
      "context": 131072
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "supported",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 64
    },
    "papers": [
     {
      "id": "2610.24628",
      "title": "Muse Glimmer 30B: An On-Device Agentic Model",
      "date": "2026-10-17"
     }
    ]
   }
  },
  "nemotron-3-nano": {
   "name": "Nemotron 3 Nano 30B-A3B",
   "repo": "nvidia/NVIDIA-Nemotron-3-Nano-30B-A3B-BF16",
   "lab": "nvidia",
   "params": 31.6,
   "released": "2025-12-04",
   "license": "other",
   "licenseName": "nvidia-nemotron-open-model-license",
   "hf": {
    "likes": 840,
    "downloads": 1715687
   },
   "ollama": {
    "name": "nemotron-3-nano",
    "tag": "30b",
    "pulls": 974780,
    "sizes": [
     "4b",
     "30b"
    ],
    "bytes": 24271924224,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "NemotronHForCausalLM",
    "recipe": "https://recipes.vllm.ai/nvidia/NVIDIA-Nemotron-3-Nano-30B-A3B-BF16",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install -U \"vllm>=0.12.0\"",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/NVIDIA-Nemotron-3-Nano-30B-A3B-MLX-BF16"
   },
   "ggufFiles": {
    "repo": "mradermacher/NVIDIA-Nemotron-3-Nano-30B-A3B-BF16-GGUF",
    "files": {
     "IQ4_XS": 18210355648,
     "Q2_K": 17908998592,
     "Q3_K_L": 20749440448,
     "Q3_K_M": 19849240000,
     "Q3_K_S": 17934717376,
     "Q4_K_M": 24515134912,
     "Q4_K_S": 21920548288,
     "Q5_K_M": 26040166336,
     "Q5_K_S": 23810309056,
     "Q6_K": 33508172224,
     "Q8_0": 33585500608
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "mradermacher/NVIDIA-Nemotron-3-Nano-30B-A3B-BF16-GGUF",
     "kv": "match",
     "ours": 6144,
     "theirs": 6144
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1
    },
    "languages": [
     "en",
     "es",
     "fr",
     "de",
     "ja",
     "it"
    ],
    "papers": [
     {
      "id": "2512.20856",
      "title": "NVIDIA Nemotron 3: Efficient and Open Intelligence",
      "date": "2025-12-24"
     },
     {
      "id": "2512.20848",
      "title": "Nemotron 3 Nano: Open, Efficient Mixture-of-Experts Hybrid Mamba-Transformer Model for Agentic Reasoning",
      "date": "2025-12-23"
     }
    ],
    "training": {
     "name": "Nemotron 3-Nano-30B-A3B",
     "flop": 4.8e+23,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "confidence": "Likely"
    }
   }
  },
  "nemotron-3-super": {
   "name": "Nemotron 3 Super 120B-A12B",
   "repo": "nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-BF16",
   "lab": "nvidia",
   "params": 123.6,
   "released": "2026-03-10",
   "license": "other",
   "licenseName": "nvidia-nemotron-open-model-license",
   "hf": {
    "likes": 440,
    "downloads": 1124825
   },
   "ollama": {
    "name": "nemotron-3-super",
    "tag": "120b",
    "pulls": 3041356,
    "sizes": [
     "120b"
    ],
    "bytes": 86827809984,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "NemotronHForCausalLM",
    "recipe": "https://recipes.vllm.ai/nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-BF16",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install vllm==0.18.1",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "DreamFoundries/NVIDIA-Nemotron-3-Super-120B-A12B-BF16-8bit"
   },
   "ggufFiles": {
    "repo": "mradermacher/NVIDIA-Nemotron-3-Super-120B-A12B-BF16-GGUF",
    "files": {
     "IQ4_XS": 67668986496,
     "Q2_K": 53500791424,
     "Q3_K_L": 70697208448,
     "Q3_K_M": 67227994752,
     "Q3_K_S": 59863714432,
     "Q4_K_M": 86051080832,
     "Q4_K_S": 75821501056,
     "Q5_K_M": 95716330112,
     "Q5_K_S": 86849243776,
     "Q6_K": 112921987712,
     "Q8_0": 128472992384
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "mradermacher/NVIDIA-Nemotron-3-Super-120B-A12B-BF16-GGUF",
     "kv": "match",
     "ours": 8192,
     "theirs": 8192
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "fr",
     "es",
     "it",
     "de",
     "ja",
     "zh"
    ],
    "papers": [
     {
      "id": "2512.20856",
      "title": "NVIDIA Nemotron 3: Efficient and Open Intelligence",
      "date": "2025-12-24"
     },
     {
      "id": "2512.20848",
      "title": "Nemotron 3 Nano: Open, Efficient Mixture-of-Experts Hybrid Mamba-Transformer Model for Agentic Reasoning",
      "date": "2025-12-23"
     }
    ]
   }
  },
  "nemotron-3-ultra": {
   "name": "Nemotron 3 Ultra 550B-A55B",
   "repo": "nvidia/NVIDIA-Nemotron-3-Ultra-550B-A55B-BF16",
   "lab": "nvidia",
   "params": 560.5,
   "released": "2026-06-04",
   "license": "other",
   "licenseName": "openmdw-1.1",
   "hf": {
    "likes": 381,
    "downloads": 1390699
   },
   "engines": {
    "arch": "NemotronHForCausalLM",
    "recipe": "https://recipes.vllm.ai/nvidia/NVIDIA-Nemotron-3-Ultra-550B-A55B-BF16",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "DevQuasar/nvidia.NVIDIA-Nemotron-3-Ultra-550B-A55B-BF16-GGUF",
    "files": {
     "IQ1_M": 125780181920,
     "IQ2_XXS": 145625465888,
     "Q2_K": 208206054464,
     "Q3_K_M": 274115217376,
     "Q4_K_M": 345131239808,
     "Q5_K_M": 396593777664,
     "Q6_K": 451272723616,
     "Q8_0": 584258245728
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 1,
      "output": 5,
      "tps": 53,
      "ttftMs": 354,
      "context": 262144
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "DevQuasar/nvidia.NVIDIA-Nemotron-3-Ultra-550B-A55B-BF16-GGUF",
     "kv": "match",
     "ours": 12288,
     "theirs": 12288
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "fr",
     "es",
     "it",
     "de",
     "pt",
     "ja",
     "ko",
     "hi",
     "ar",
     "zh",
     "he"
    ]
   }
  },
  "mamba-codestral-7b": {
   "name": "Mamba-Codestral 7B",
   "repo": "mistralai/Mamba-Codestral-7B-v0.1",
   "lab": "mistralai",
   "params": 7.3,
   "released": "2024-07-16",
   "license": "apache-2.0",
   "hf": {
    "likes": 630,
    "downloads": 17428
   },
   "engines": {
    "mlxRepo": "mlx-community/Mamba-Codestral-7B-v0.1-8bit"
   },
   "ggufFiles": {
    "repo": "gabriellarson/Mamba-Codestral-7B-v0.1-GGUF",
    "files": {
     "F16": 14579764032,
     "IQ1_M": 1687522368,
     "IQ1_S": 1523158080,
     "IQ2_M": 2413399104,
     "IQ2_S": 2194246720,
     "IQ2_XS": 2180615232,
     "IQ2_XXS": 1961462848,
     "IQ3_M": 3198258240,
     "IQ3_XXS": 2851703872,
     "IQ4_NL": 4147481664,
     "IQ4_XS": 3924134976,
     "Q2_K": 2472381504,
     "Q3_K_M": 3198258240,
     "Q4_0": 4147481664,
     "Q5_0": 5040868416,
     "Q6_K": 5990091840,
     "Q8_0": 7753534528
    }
   }
  },
  "nemotron-3.5-super-vl-120b-a12b": {
   "name": "Nemotron 3.5 Super VL 120B-A12B",
   "repo": "nvidia/NVIDIA-Nemotron-3.5-Super-VL-120B-A12B-BF16",
   "lab": "nvidia",
   "params": 124.5,
   "released": "2026-10-15",
   "license": "other",
   "licenseName": "openmdw-1.1",
   "hf": {
    "likes": 112,
    "downloads": 58445
   },
   "engines": {
    "arch": "NemotronH_Omni_Reasoning_V3",
    "recipe": "https://recipes.vllm.ai/nvidia/NVIDIA-Nemotron-3.5-Super-VL-120B-A12B-BF16",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": false
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "es",
     "fr",
     "de",
     "it",
     "ja"
    ]
   }
  },
  "nemotron-3.5-bolt-74b-a9b": {
   "name": "Nemotron 3.5 Bolt 74B-A9B",
   "repo": "nvidia/NVIDIA-Nemotron-3.5-Bolt-74B-A9B-BF16",
   "lab": "nvidia",
   "params": 74.9,
   "released": "2026-10-15",
   "license": "other",
   "licenseName": "openmdw-1.1",
   "hf": {
    "likes": 52,
    "downloads": 7429
   },
   "engines": {
    "arch": "NemotronH_Omni_Reasoning_V3",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "nativ-community/NVIDIA-Nemotron-3.5-Bolt-74B-A9B-BF16"
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "es",
     "fr",
     "de",
     "it",
     "ja"
    ]
   }
  },
  "minimax-m3.1-flash": {
   "name": "MiniMax M3.1 Flash",
   "repo": "MiniMaxAI/MiniMax-M3.1-Flash",
   "lab": "minimaxai",
   "params": 427.1,
   "released": "2026-10-22",
   "license": "other",
   "licenseName": "minimax-community",
   "hf": {
    "likes": 543,
    "downloads": 24952
   },
   "modelscope": "MiniMax/MiniMax-M3.1-Flash",
   "engines": {
    "arch": "MiniMaxM3SparseForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/MiniMaxAI/MiniMax-M3.1-Flash",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/MiniMax-M3.1-Flash-Text-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/MiniMax-M3.1-Flash-GGUF",
    "files": {
     "UD-IQ1_M": 129361076548,
     "UD-IQ2_XXS": 134947889444,
     "UD-IQ3_S": 175450454084,
     "UD-IQ3_XXS": 160048968132,
     "UD-Q2_K_XL": 143910068580,
     "UD-Q3_K_XL": 193951346788,
     "UD-Q4_K_XL": 249402105310,
     "UD-Q8_K_XL": 259081117182
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.15,
      "output": 0.6,
      "tps": 97,
      "ttftMs": 833,
      "context": 1000000
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2606.13392",
      "title": "MiniMax Sparse Attention",
      "date": "2026-06-11"
     }
    ]
   }
  },
  "minimax-m3": {
   "name": "MiniMax M3",
   "repo": "MiniMaxAI/MiniMax-M3",
   "lab": "minimaxai",
   "params": 427,
   "released": "2026-06-02",
   "license": "other",
   "licenseName": "minimax-community",
   "hf": {
    "likes": 1601,
    "downloads": 189276
   },
   "modelscope": "MiniMax/MiniMax-M3",
   "engines": {
    "arch": "MiniMaxM3SparseForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/MiniMaxAI/MiniMax-M3",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/MiniMax-M3-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/MiniMax-M3-GGUF",
    "files": {
     "IQ1_M": 100738523488,
     "IQ1_S": 90527490400,
     "IQ2_M": 145576741344,
     "IQ2_S": 132138191328,
     "IQ2_XS": 129521934816,
     "IQ2_XXS": 116611867008,
     "IQ3_M": 205523227392,
     "IQ3_XS": 196357952096,
     "IQ3_XXS": 180011108960,
     "IQ4_NL": 242752199456,
     "IQ4_XS": 229685754592,
     "Q2_K": 151886604736,
     "Q2_K_L": 153086988768,
     "Q3_K_L": 204971152128,
     "Q3_K_M": 196614525536,
     "Q3_K_S": 187251069504,
     "Q3_K_XL": 206046696160,
     "Q4_0": 243644013344,
     "Q4_1": 268894526304,
     "Q4_K_M": 261282110272,
     "Q4_K_S": 251358911328,
     "Q5_K_M": 305348746176,
     "Q5_K_S": 295228545984,
     "Q6_K": 369400554688,
     "Q8_0": 453611164768
    }
   },
   "eci": {
    "score": 147,
    "name": "MiniMax-M3"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.28,
      "output": 1.1,
      "tps": 49,
      "ttftMs": 767,
      "context": 524288
     },
     {
      "name": "Novita",
      "input": 0.3,
      "output": 1.2,
      "tps": 92,
      "ttftMs": 835,
      "context": 1000000
     }
    ]
   },
   "verified": {
    "inferencex": {
     "model": "MiniMax-M3",
     "runs": [
      {
       "id": "438412",
       "day": "2026-08-04",
       "gpu": "b200",
       "gpus": 2,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "kvTokens": 1291264,
       "tps": 190.9,
       "ttft": 0.218,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30841588412/attempts/2"
      },
      {
       "id": "438421",
       "day": "2026-08-04",
       "gpu": "b200",
       "gpus": 4,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 58.22,
       "kvGiB": 102.63,
       "kvTokens": 4864127,
       "utilization": 0.95,
       "tps": 221,
       "ttft": 0.188,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30841588412/attempts/2"
      },
      {
       "id": "438415",
       "day": "2026-08-04",
       "gpu": "b200",
       "gpus": 8,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 29.33,
       "kvGiB": 131.5,
       "kvTokens": 6232320,
       "utilization": 0.95,
       "tps": 43.2,
       "ttft": 0.931,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30841588412/attempts/2"
      },
      {
       "id": "438370",
       "day": "2026-08-04",
       "gpu": "b300",
       "gpus": 2,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 115.97,
       "kvGiB": 130.59,
       "kvTokens": 3688320,
       "utilization": 0.95,
       "tps": 137.3,
       "ttft": 0.198,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30841588542/attempts/1"
      },
      {
       "id": "438376",
       "day": "2026-08-04",
       "gpu": "b300",
       "gpus": 4,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 58.22,
       "kvGiB": 187.35,
       "kvTokens": 8878848,
       "utilization": 0.95,
       "tps": 227.9,
       "ttft": 0.144,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30841588542/attempts/1"
      },
      {
       "id": "438378",
       "day": "2026-08-04",
       "gpu": "b300",
       "gpus": 8,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 29.33,
       "kvGiB": 216.37,
       "kvTokens": 10254592,
       "utilization": 0.95,
       "tps": 241.9,
       "ttft": 0.141,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30841588542/attempts/1"
      },
      {
       "id": "438466",
       "day": "2026-08-04",
       "gpu": "mi355x",
       "gpus": 2,
       "engine": "vllm",
       "format": "mxfp4",
       "version": "nightly",
       "weightsGiB": 112.5,
       "kvGiB": 147.94,
       "kvTokens": 3505536,
       "tps": 138.3,
       "ttft": 0.327,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30865586311/attempts/1"
      },
      {
       "id": "438465",
       "day": "2026-08-04",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "vllm",
       "format": "mxfp4",
       "version": "nightly",
       "weightsGiB": 56.41,
       "kvGiB": 203.38,
       "kvTokens": 7286528,
       "tps": 167,
       "ttft": 0.235,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30865586311/attempts/1"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "supported",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2606.13392",
      "title": "MiniMax Sparse Attention",
      "date": "2026-06-11"
     }
    ]
   }
  },
  "minimax-m2.7": {
   "name": "MiniMax M2.7",
   "repo": "MiniMaxAI/MiniMax-M2.7",
   "lab": "minimaxai",
   "params": 228.7,
   "released": "2026-04-09",
   "license": "other",
   "licenseName": "other",
   "hf": {
    "likes": 1261,
    "downloads": 330252
   },
   "modelscope": "MiniMax/MiniMax-M2.7",
   "engines": {
    "arch": "MiniMaxM2ForCausalLM",
    "recipe": "https://recipes.vllm.ai/MiniMaxAI/MiniMax-M2.7",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "JANGQ-AI/MiniMax-M2.7-JANGTQ"
   },
   "ggufFiles": {
    "repo": "bartowski/MiniMaxAI_MiniMax-M2.7-GGUF",
    "files": {
     "IQ1_M": 52200589024,
     "IQ1_S": 46670399008,
     "IQ2_M": 76417481440,
     "IQ2_S": 69131975424,
     "IQ2_XS": 67866314496,
     "IQ2_XXS": 60845049568,
     "IQ3_M": 108803129184,
     "IQ3_XS": 104127004512,
     "IQ3_XXS": 95183862656,
     "IQ4_NL": 129462535136,
     "IQ4_XS": 122403189760,
     "Q2_K": 80051669856,
     "Q2_K_L": 80651861856,
     "Q3_K_L": 108501434240,
     "Q3_K_M": 104127004512,
     "Q3_K_S": 99314040672,
     "Q3_K_XL": 109039206240,
     "Q4_0": 129844741088,
     "Q4_1": 143508087776,
     "Q4_K_L": 139261493216,
     "Q4_K_M": 138805347296,
     "Q4_K_S": 133846107104,
     "Q5_K_M": 162668299360,
     "Q5_K_S": 157699916768,
     "Q6_K": 197054679168,
     "Q8_0": 243136872576
    }
   },
   "eci": {
    "score": 146,
    "name": "MiniMax-M2.7"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.25,
      "output": 1,
      "tps": 30,
      "ttftMs": 461,
      "context": 196608
     },
     {
      "name": "Novita",
      "input": 0.3,
      "output": 1.2,
      "tps": 46,
      "ttftMs": 997,
      "context": 204800
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/MiniMaxAI_MiniMax-M2.7-GGUF",
     "kv": "match",
     "ours": 253952,
     "theirs": 253952
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 40
    }
   }
  },
  "deepseek-r1": {
   "name": "DeepSeek R1",
   "repo": "deepseek-ai/DeepSeek-R1",
   "lab": "deepseek-ai",
   "params": 684.5,
   "released": "2025-01-20",
   "license": "mit",
   "hf": {
    "likes": 14425,
    "downloads": 1690495
   },
   "ollama": {
    "name": "deepseek-r1",
    "tag": "671b",
    "pulls": 94652678,
    "sizes": [
     "1.5b",
     "7b",
     "8b",
     "14b",
     "32b",
     "70b",
     "671b"
    ],
    "bytes": 404430186848,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "DeepseekV3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/deepseek-ai/DeepSeek-R1",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/DeepSeek-R1-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/DeepSeek-R1-GGUF",
    "files": {
     "BF16": 1342273048096,
     "Q2_K": 244028343936,
     "Q2_K_L": 244245534336,
     "Q2_K_XS": 221253686944,
     "Q3_K_M": 319198395744,
     "Q4_K_M": 404430187616,
     "Q5_K_M": 475396558144,
     "Q6_K": 550798326880,
     "Q8_0": 713286514368,
     "UD-IQ1_M": 168916283648,
     "UD-IQ1_S": 140231438464,
     "UD-IQ2_XXS": 196162482432,
     "UD-Q2_K_XL": 226601595040
    }
   },
   "eci": {
    "score": 139,
    "name": "DeepSeek-R1"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.7,
      "output": 2.5,
      "tps": 19,
      "ttftMs": 1329,
      "context": 64000
     }
    ]
   },
   "verified": {
    "inferencex": {
     "model": "DeepSeek-R1-0528",
     "runs": [
      {
       "id": "445985",
       "day": "2026-10-22",
       "gpu": "h200",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.22",
       "tps": 90.8,
       "ttft": 0.305,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/39260981870/attempts/1"
      },
      {
       "id": "442280",
       "day": "2026-09-16",
       "gpu": "b200",
       "gpus": 4,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.19",
       "weightsGiB": 92.07,
       "tps": 189.7,
       "ttft": 0.208,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/34557177019/attempts/1"
      },
      {
       "id": "415304",
       "day": "2026-05-22",
       "gpu": "b200",
       "gpus": 4,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.12",
       "weightsGiB": 158.29,
       "kvGiB": 9.12,
       "kvTokens": 278720,
       "utilization": 0.95,
       "tps": 125.7,
       "ttft": 0.409,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26306422380/attempts/1"
      },
      {
       "id": "415388",
       "day": "2026-05-22",
       "gpu": "b200",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.12",
       "weightsGiB": 79.77,
       "kvGiB": 64.68,
       "kvTokens": 1976640,
       "utilization": 0.82,
       "tps": 139.2,
       "ttft": 0.157,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26306422380/attempts/1"
      },
      {
       "id": "96439",
       "day": "2026-03-25",
       "gpu": "b200",
       "gpus": 8,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.9",
       "weightsGiB": 52.16,
       "kvGiB": 97.95,
       "kvTokens": 2993152,
       "utilization": 0.85,
       "tps": 123.2,
       "ttft": 0.188,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/23552373331/attempts/2"
      },
      {
       "id": "445481",
       "day": "2026-10-20",
       "gpu": "b300",
       "gpus": 4,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.21",
       "tps": 172.4,
       "ttft": 0.215,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/37935856210/attempts/1"
      },
      {
       "id": "445471",
       "day": "2026-10-20",
       "gpu": "b300",
       "gpus": 4,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.21",
       "tps": 143.1,
       "ttft": 0.382,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/37898647160/attempts/1"
      },
      {
       "id": "445488",
       "day": "2026-10-20",
       "gpu": "b300",
       "gpus": 8,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.21",
       "tps": 188.7,
       "ttft": 0.206,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/37935856210/attempts/1"
      },
      {
       "id": "445476",
       "day": "2026-10-20",
       "gpu": "b300",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.21",
       "tps": 153.2,
       "ttft": 0.295,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/37898647160/attempts/1"
      },
      {
       "id": "445980",
       "day": "2026-10-22",
       "gpu": "mi300x",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.22",
       "tps": 54.1,
       "ttft": 0.534,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/39562635990/attempts/1"
      },
      {
       "id": "445892",
       "day": "2026-10-22",
       "gpu": "mi325x",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.22",
       "tps": 55,
       "ttft": 0.504,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/39665000782/attempts/1"
      },
      {
       "id": "420407",
       "day": "2026-06-11",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "sglang",
       "format": "mxfp4",
       "version": "v0.5.12",
       "weightsGiB": 89.96,
       "kvGiB": 99.92,
       "kvTokens": 3053452,
       "utilization": 0.68,
       "tps": 103.6,
       "ttft": 0.102,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/27213443242/attempts/1"
      },
      {
       "id": "446025",
       "day": "2026-10-22",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.22",
       "tps": 26.6,
       "ttft": 0.421,
       "conc": 32,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/39166423424/attempts/1"
      },
      {
       "id": "446029",
       "day": "2026-10-22",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.22",
       "tps": 85,
       "ttft": 0.246,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/39166423424/attempts/1"
      },
      {
       "id": "420401",
       "day": "2026-06-11",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "sglang",
       "format": "mxfp4",
       "version": "v0.5.12",
       "weightsGiB": 46.22,
       "kvGiB": 142.27,
       "kvTokens": 4347622,
       "utilization": 0.68,
       "tps": 116.2,
       "ttft": 0.09,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/27213443242/attempts/1"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2501.12948",
      "title": "DeepSeek-R1: Incentivizing Reasoning Capability in LLMs via Reinforcement Learning",
      "date": "2025-01-22"
     }
    ],
    "training": {
     "name": "DeepSeek-R1",
     "flop": 3.5e+24,
     "tokens": 14800000000000,
     "confidence": "Confident"
    }
   }
  },
  "kimi-k2.6": {
   "name": "Kimi K2.6",
   "repo": "moonshotai/Kimi-K2.6",
   "lab": "moonshotai",
   "params": 1026.9,
   "released": "2026-04-14",
   "license": "other",
   "licenseName": "modified-mit",
   "hf": {
    "likes": 1640,
    "downloads": 246535
   },
   "modelscope": "moonshotai/Kimi-K2.6",
   "engines": {
    "arch": "KimiK25ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/moonshotai/Kimi-K2.6",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Kimi-K2.6-mlx-DQ3_K_M-q8"
   },
   "ggufFiles": {
    "repo": "DevQuasar/moonshotai.Kimi-K2.6-GGUF",
    "files": {
     "IQ2_XS": 298567841632,
     "Q2_K": 372860184448,
     "Q3_K_M": 489085340320,
     "Q4_K_M": 620554699488,
     "Q5_K_M": 728167786496,
     "Q6_K": 842569654336,
     "Q8_0": 1091050690624
    }
   },
   "eci": {
    "score": 151,
    "name": "Kimi K2.6"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.8,
      "output": 3.4,
      "tps": 35,
      "ttftMs": 1936,
      "context": 262144
     },
     {
      "name": "DeepInfra",
      "input": 0.75,
      "output": 3.5,
      "tps": 8,
      "ttftMs": 751,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "thinking",
    "papers": [
     {
      "id": "2602.02276",
      "title": "Kimi K2.5: Visual Agentic Intelligence",
      "date": "2026-02-02"
     }
    ]
   }
  },
  "glm-5.3": {
   "name": "GLM-5.3",
   "repo": "zai-org/GLM-5.3",
   "lab": "zai-org",
   "params": 753.3,
   "released": "2026-08-25",
   "license": "other",
   "licenseName": "glm-5.3",
   "hf": {
    "likes": 2367,
    "downloads": 2406057
   },
   "modelscope": "ZhipuAI/GLM-5.3",
   "engines": {
    "arch": "GlmMoeDsaForCausalLM",
    "recipe": "https://recipes.vllm.ai/zai-org/GLM-5.3",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "orcarouter/GLM-5.3-MLX"
   },
   "ggufFiles": {
    "repo": "unsloth/GLM-5.3-GGUF",
    "files": {
     "BF16": 1507988027936,
     "Q8_0": 801357677216,
     "UD-IQ1_M": 228492971557,
     "UD-IQ1_S": 216715365893,
     "UD-IQ2_M": 238577585701,
     "UD-IQ3_XXS": 281688436357,
     "UD-IQ4_XS": 365313228709,
     "UD-Q2_K_XL": 253878406789,
     "UD-Q3_K_XL": 342965977029,
     "UD-Q4_K_XL": 467289116837,
     "UD-Q5_K_XL": 562466263429,
     "UD-Q6_K_XL": 684369515173
    }
   },
   "eci": {
    "score": 156,
    "name": "GLM-5.3"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.9,
      "output": 4,
      "tps": 22,
      "ttftMs": 2008,
      "context": 1048576
     },
     {
      "name": "Novita",
      "input": 1.4,
      "output": 4.4,
      "tps": 120,
      "ttftMs": 1035,
      "context": 1048576
     },
     {
      "name": "Nscale",
      "input": 1.4,
      "output": 4.4,
      "tps": 120,
      "ttftMs": 488,
      "context": 1048576
     },
     {
      "name": "Baseten",
      "input": 1.4,
      "output": 4.4,
      "tps": 56,
      "ttftMs": 1777,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2602.15763",
      "title": "GLM-5: from Vibe Coding to Agentic Engineering",
      "date": "2026-02-17"
     }
    ]
   }
  },
  "hy4-preview": {
   "name": "Hy4 Preview",
   "repo": "tencent/Hy4-preview",
   "lab": "tencent",
   "params": 780,
   "released": "2026-08-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 523,
    "downloads": 11335
   },
   "modelscope": "Tencent-Hunyuan/Hy4-preview",
   "engines": {
    "arch": "HYV4ForCausalLM",
    "recipe": "https://recipes.vllm.ai/tencent/Hy4-preview",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "inferencerlabs/Hy4-preview-MLX-Q4i"
   },
   "ggufFiles": {
    "repo": "6block/Hy4-preview-GGUF",
    "files": {
     "IQ2_XS": 235105725664,
     "IQ4_XS": 416970583264,
     "Q2_K": 289535765728
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.834,
      "output": 2.501,
      "tps": 36,
      "ttftMs": 2752,
      "context": 1000000
     },
     {
      "name": "DeepInfra",
      "input": 0.834,
      "output": 2.501,
      "tps": 24,
      "ttftMs": 442,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.9,
     "topP": 1
    }
   }
  },
  "k-exaone-2.0": {
   "name": "K-EXAONE 2.0 750B-A37B",
   "repo": "LGAI-EXAONE/K-EXAONE-2.0-750B-A37B",
   "lab": "lgai-exaone",
   "params": 749.4,
   "released": "2026-07-29",
   "license": "apache-2.0",
   "hf": {
    "likes": 159,
    "downloads": 4168
   },
   "engines": {
    "arch": "ExaoneMoeForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install git+https://github.com/lkm2835/vllm@add-k-exaone2 --torch-backend auto",
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "DevQuasar/NOT_WOKRKING-LGAI-EXAONE.K-EXAONE-2.0-750B-A37B-GGUF",
    "files": {
     "Q2_K": 272312552512
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "ko",
     "es",
     "de",
     "ja",
     "vi",
     "fr",
     "it",
     "pl",
     "pt"
    ],
    "papers": [
     {
      "id": "2608.04505",
      "title": "K-EXAONE 2.0 Technical Report",
      "date": "2026-08-05"
     }
    ]
   }
  },
  "inkling": {
   "name": "Inkling",
   "repo": "thinkingmachines/Inkling",
   "lab": "thinkingmachines",
   "params": 952.4,
   "released": "2026-07-15",
   "license": "apache-2.0",
   "hf": {
    "likes": 1833,
    "downloads": 2005047
   },
   "engines": {
    "arch": "InklingForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/thinkingmachines/Inkling",
    "vllm": true,
    "llamacpp": false,
    "gguf": {
     "repo": "unsloth/inkling-GGUF",
     "arch": "inkling",
     "llamacpp": false
    },
    "sglang": true,
    "mlx": false,
    "mlxRepo": "mlx-community/Inkling-mlx-4bit"
   },
   "ggufFiles": {
    "repo": "DevQuasar/thinkingmachines.Inkling-GGUF",
    "files": {
     "IQ2_XXS": 246467064896,
     "Q2_K": 343956042176,
     "Q3_K_M": 451035398944,
     "Q4_K_M": 572500476128
    }
   },
   "eci": {
    "score": 149,
    "name": "Inkling"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.95,
      "output": 4.05,
      "tps": 134,
      "ttftMs": 333,
      "context": 524288
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "audio"
    ],
    "tools": true,
    "thinking": "effort",
    "training": {
     "name": "Inkling",
     "flop": 1.1e+25,
     "tokens": 45000000000000,
     "hardware": "NVIDIA GB300 (Blackwell Ultra)",
     "confidence": "Likely"
    }
   }
  },
  "glm-5.3-flash": {
   "name": "GLM-5.3-Flash",
   "repo": "zai-org/GLM-5.3-Flash",
   "lab": "zai-org",
   "params": 321.3,
   "released": "2026-08-25",
   "license": "mit",
   "hf": {
    "likes": 3023,
    "downloads": 6313299
   },
   "modelscope": "ZhipuAI/GLM-5.3-Flash",
   "engines": {
    "arch": "Glm5NextForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/zai-org/GLM-5.3-Flash",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "Jundot/GLM-5.3-Flash-oQ4e-mtp"
   },
   "ggufFiles": {
    "repo": "patrickbdevaney/GLM-5.3-Flash-REAP50-GGUF",
    "files": {
     "IQ3_M": 72132392352,
     "IQ4_XS": 88048752032,
     "Q3_K_M": 78776759712,
     "Q4_K_M": 99330938048,
     "Q4_K_S": 93526480064
    }
   },
   "eci": {
    "score": 153,
    "name": "GLM-5.3-Flash"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.15,
      "output": 0.5,
      "tps": 53,
      "ttftMs": 1345,
      "context": 1048576
     },
     {
      "name": "Baseten",
      "input": 0.15,
      "output": 0.5,
      "tps": 88,
      "ttftMs": 270,
      "context": 1048576
     },
     {
      "name": "DeepInfra",
      "input": 0.15,
      "output": 0.5,
      "tps": 54,
      "ttftMs": 410,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2602.15763",
      "title": "GLM-5: from Vibe Coding to Agentic Engineering",
      "date": "2026-02-17"
     }
    ],
    "training": {
     "name": "GLM-5.3-Flash",
     "flop": 3.24e+24,
     "tokens": 30000000000000,
     "confidence": "Likely"
    }
   }
  },
  "deepseek-v4-flash": {
   "name": "DeepSeek V4 Flash",
   "repo": "deepseek-ai/DeepSeek-V4-Flash",
   "lab": "deepseek-ai",
   "params": 290.9,
   "released": "2026-04-22",
   "license": "mit",
   "hf": {
    "likes": 2364,
    "downloads": 1060406
   },
   "modelscope": "deepseek-ai/DeepSeek-V4-Flash",
   "engines": {
    "arch": "DeepseekV4ForCausalLM",
    "recipe": "https://recipes.vllm.ai/deepseek-ai/DeepSeek-V4-Flash",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false
   },
   "ggufFiles": {
    "repo": "unsloth/DeepSeek-V4-Flash-GGUF",
    "files": {
     "UD-IQ1_M": 86901313152,
     "UD-IQ1_S": 82539237024,
     "UD-IQ2_M": 90926927488,
     "UD-IQ2_XXS": 90860736128,
     "UD-IQ3_S": 117310852864,
     "UD-IQ3_XXS": 102999887616,
     "UD-IQ4_NL": 137903959808,
     "UD-IQ4_XS": 137903959808,
     "UD-Q2_K_XL": 96832507552,
     "UD-Q3_K_M": 129319997216,
     "UD-Q3_K_XL": 129448242976,
     "UD-Q4_K_XL": 155095240320,
     "UD-Q8_K_XL": 161869614720
    }
   },
   "eci": {
    "score": 146,
    "name": "DeepSeek-V4-Flash"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.09,
      "output": 0.18,
      "tps": 21,
      "ttftMs": 966,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "efforts": [
     "none",
     "high",
     "max"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1
    },
    "papers": [
     {
      "id": "2606.19348",
      "title": "DeepSeek-V4: Towards Highly Efficient Million-Token Context Intelligence",
      "date": "2026-04-26"
     }
    ],
    "training": {
     "name": "DeepSeek-V4-Flash",
     "flop": 2.496e+24,
     "confidence": "Likely"
    }
   }
  },
  "deepseek-v4-pro": {
   "name": "DeepSeek V4 Pro",
   "repo": "deepseek-ai/DeepSeek-V4-Pro",
   "lab": "deepseek-ai",
   "params": 1598.8,
   "released": "2026-04-22",
   "license": "mit",
   "hf": {
    "likes": 5693,
    "downloads": 357030
   },
   "modelscope": "deepseek-ai/DeepSeek-V4-Pro",
   "engines": {
    "arch": "DeepseekV4ForCausalLM",
    "recipe": "https://recipes.vllm.ai/deepseek-ai/DeepSeek-V4-Pro",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "mlx-community/DeepSeek-V4-Pro"
   },
   "ggufFiles": {
    "repo": "DevQuasar/deepseek-ai.DeepSeek-V4-Pro-GGUF",
    "files": {
     "Q2_K": 569417383712,
     "Q3_K_M": 748403474176,
     "Q4_K_M": 950879579072,
     "Q5_K_M": 1115575760000
    }
   },
   "eci": {
    "score": 149,
    "name": "DeepSeek-V4-Pro"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 1.3,
      "output": 2.6,
      "tps": 38,
      "ttftMs": 482,
      "context": 1048576
     },
     {
      "name": "Novita",
      "input": 1.6,
      "output": 3.2,
      "tps": 71,
      "ttftMs": 638,
      "context": 1048576
     }
    ]
   },
   "verified": {
    "inferencex": {
     "model": "DeepSeek-V4-Pro",
     "runs": [
      {
       "id": "431227",
       "day": "2026-07-01",
       "gpu": "b200",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "nightly",
       "weightsGiB": 104.29,
       "utilization": 0.9,
       "tps": 103.4,
       "ttft": 0.214,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28403258484/attempts/2"
      },
      {
       "id": "440982",
       "day": "2026-09-03",
       "gpu": "b200",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "nightly",
       "kvTokens": 99593,
       "tps": 103.3,
       "ttft": 0.277,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/33554397154/attempts/1"
      },
      {
       "id": "429923",
       "day": "2026-06-26",
       "gpu": "b300",
       "gpus": 4,
       "engine": "sglang",
       "format": "native",
       "version": "nightly",
       "weightsGiB": 204.27,
       "utilization": 0.9,
       "tps": 43.2,
       "ttft": 0.137,
       "conc": 32,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28078823761/attempts/4"
      },
      {
       "id": "434510",
       "day": "2026-07-12",
       "gpu": "b300",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.25.0",
       "weightsGiB": 201.1,
       "kvGiB": 35.3,
       "kvTokens": 75793,
       "tps": 95.4,
       "ttft": 0.075,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/29177379558/attempts/1"
      },
      {
       "id": "429925",
       "day": "2026-06-26",
       "gpu": "b300",
       "gpus": 8,
       "engine": "sglang",
       "format": "native",
       "version": "nightly",
       "weightsGiB": 104.29,
       "utilization": 0.9,
       "tps": 105.1,
       "ttft": 0.109,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28078823761/attempts/4"
      },
      {
       "id": "434528",
       "day": "2026-07-12",
       "gpu": "b300",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.25.0",
       "weightsGiB": 134.29,
       "kvGiB": 102.18,
       "kvTokens": 219383,
       "tps": 99.8,
       "ttft": 0.069,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/29177379558/attempts/1"
      },
      {
       "id": "435003",
       "day": "2026-07-14",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "sglang",
       "format": "native",
       "version": "v0.5.14",
       "weightsGiB": 210.74,
       "utilization": 0.9,
       "tps": 73.3,
       "ttft": 0.147,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28838628949/attempts/4"
      },
      {
       "id": "441260",
       "day": "2026-09-09",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "nightly",
       "weightsGiB": 104.97,
       "kvGiB": 97.55,
       "kvTokens": 4386107,
       "utilization": 0.8,
       "tps": 57.4,
       "ttft": 0.376,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/34287188950/attempts/5"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "efforts": [
     "none",
     "high",
     "max"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1
    },
    "papers": [
     {
      "id": "2606.19348",
      "title": "DeepSeek-V4: Towards Highly Efficient Million-Token Context Intelligence",
      "date": "2026-04-26"
     }
    ],
    "training": {
     "name": "DeepSeek-V4-Pro",
     "flop": 9.702e+24,
     "confidence": "Likely"
    }
   }
  },
  "deepseek-v4.1-flash": {
   "name": "DeepSeek V4.1 Flash",
   "repo": "deepseek-ai/DeepSeek-V4.1-Flash",
   "lab": "deepseek-ai",
   "params": 763.2,
   "released": "2026-09-10",
   "license": "mit",
   "hf": {
    "likes": 4845,
    "downloads": 2144269
   },
   "modelscope": "deepseek-ai/DeepSeek-V4.1-Flash",
   "engines": {
    "arch": "DeepseekV41ForCausalLM",
    "recipe": "https://recipes.vllm.ai/deepseek-ai/DeepSeek-V4.1-Flash",
    "vllm": true,
    "llamacpp": true,
    "sglang": false,
    "mlx": true,
    "mlxRepo": "Jundot/DeepSeek-V4.1-Flash-oQ4e-mtp"
   },
   "ggufFiles": {
    "repo": "antirez/deepseek-v4.1-flash-gguf",
    "files": {
     "Q2": 365713686528
    }
   },
   "eci": {
    "score": 156,
    "name": "DeepSeek V4.1 Flash"
   },
   "strata": {
    "repo": "Niko1221/Strata",
    "checked": "2026-11-03",
    "minVramGB": 12,
    "diskGB": 265,
    "gpus": "NVIDIA GeForce RTX 30, 40 and 50 series (Windows, Linux) or AMD Radeon AI PRO R9700 (Linux); also DGX Spark, Ryzen AI Max with 128 GB (Windows) and Apple Silicon Macs with 64 GB or more (text only)",
    "how": "Your graphics card keeps the experts used most often, your RAM holds what it can and the rest is read from the NVMe SSD at every token, so a fast SSD matters.",
    "promptTokens": 4096,
    "ram": [
     {
      "gb": 46,
      "pick": "ISTA-DAS 2.00 bpw (about 265 GB of disk); for code, ISTA-DAS Coder (197 GB)"
     }
    ],
    "speeds": [
     {
      "setup": "RTX 3060 12 GB, 46 GB RAM",
      "size": "2.00 bpw",
      "write": 9,
      "writeTo": 11,
      "read": 155
     },
     {
      "setup": "RTX 5070 12 GB, 64 GB RAM",
      "size": "2.00 bpw",
      "write": 4,
      "writeTo": 6,
      "read": 110
     }
    ],
    "version": "v0.2.10",
    "released": "2026-11-02",
    "stars": 38436
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.2,
      "output": 0.6,
      "tps": 130,
      "ttftMs": 319,
      "context": 1048576
     },
     {
      "name": "Novita",
      "input": 0.3,
      "output": 1.2,
      "tps": 89,
      "ttftMs": 811,
      "context": 1048576
     },
     {
      "name": "Baseten",
      "input": 0.3,
      "output": 1.2,
      "tps": 232,
      "ttftMs": 160,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "training": {
     "name": "DeepSeek V4.1 Flash",
     "flop": 4.32e+24,
     "tokens": 45000000000000,
     "confidence": "Likely"
    }
   }
  },
  "mimo-v2.6-pro": {
   "name": "MiMo-V2.6 Pro",
   "repo": "XiaomiMiMo/MiMo-V2.6-Pro-RL",
   "lab": "xiaomimimo",
   "params": 1024.2,
   "released": "2026-09-21",
   "license": "mit",
   "hf": {
    "likes": 794,
    "downloads": 27678
   },
   "engines": {
    "arch": "MiMoV2ForCausalLM",
    "recipe": "https://recipes.vllm.ai/XiaomiMiMo/MiMo-V2.6-Pro-RL",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "mlx-community/MiMo-V2.6-Pro-RL-mxfp4-q8"
   },
   "ggufFiles": {
    "repo": "ggml-org/MiMo-V2.6-Pro-RL-GGUF",
    "files": {
     "MXFP4": 554211764672,
     "Q2_K": 418769299904
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.435,
      "output": 0.87,
      "tps": 24,
      "ttftMs": 1290,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "mimo-v2.6-flash": {
   "name": "MiMo-V2.6 Flash",
   "repo": "XiaomiMiMo/MiMo-V2.6-Flash-RL",
   "lab": "xiaomimimo",
   "params": 310.8,
   "released": "2026-09-21",
   "license": "mit",
   "hf": {
    "likes": 583,
    "downloads": 75163
   },
   "engines": {
    "arch": "MiMoV2ForCausalLM",
    "recipe": "https://recipes.vllm.ai/XiaomiMiMo/MiMo-V2.6-Flash-RL",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "TensorFold/MiMo-V2.6-Flash-RL-MLX-4bit-MTP"
   },
   "ggufFiles": {
    "repo": "ggml-org/MiMo-V2.6-Flash-RL-GGUF",
    "files": {
     "MXFP4": 167369465248,
     "Q2_K": 126365949344
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.14,
      "output": 0.28,
      "tps": 26,
      "ttftMs": 2109,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "muse-spark-open": {
   "name": "Muse Spark Open",
   "repo": "meta-models/Muse-Spark-Open-816B-A42B",
   "lab": "meta-models",
   "params": 822,
   "released": "2026-10-15",
   "license": "other",
   "licenseName": "muse-model-license",
   "gated": true,
   "hf": {
    "likes": 737,
    "downloads": 9931
   },
   "modelscope": "meta-models/Muse-Spark-Open-816B-A42B",
   "engines": {
    "arch": "MuseSparkForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/meta-models/Muse-Spark-Open-816B-A42B",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Muse-Spark-Open-816B-A42B-4bit"
   },
   "ggufFiles": {
    "repo": "Interchained/Muse-Spark-Open-816B-A42B-GGUF",
    "files": {
     "F16": 1640264558624,
     "Q4_0": 466306938368,
     "Q4_K_M": 499590707040,
     "Q5_K_M": 584688219840
    }
   },
   "eci": {
    "score": 155,
    "name": "Muse Spark Open"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Baseten",
      "input": 1.25,
      "output": 4.25,
      "tps": 155,
      "ttftMs": 284,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "effort",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1,
     "topK": 64
    },
    "languages": [
     "en"
    ]
   }
  },
  "beam-1.0": {
   "name": "Beam 1.0 501B-A23B",
   "repo": "reflection/Beam-1.0-501B-A23B",
   "lab": "reflection",
   "params": 501.3,
   "released": "2026-10-16",
   "license": "apache-2.0",
   "hf": {
    "likes": 300,
    "downloads": 9396
   },
   "engines": {
    "arch": "BeamForCausalLM",
    "recipe": "https://recipes.vllm.ai/reflection/Beam-1.0-501B-A23B",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "OpensourceWTF/Beam-1.0-501B-A23B-NVFP4-q8-mlx-stream"
   },
   "ggufFiles": {
    "repo": "bartowski/Beam-1.0-501B-A23B-GGUF",
    "files": {
     "IQ1_M": 123555142208,
     "IQ1_S": 109586471392,
     "IQ2_M": 178487130816,
     "IQ2_S": 161266072256,
     "IQ2_XS": 151720589920,
     "IQ2_XXS": 145275574880,
     "IQ3_M": 255656098752,
     "IQ3_XS": 224539605856,
     "IQ3_XXS": 211104643936,
     "IQ4_NL": 311912201408,
     "IQ4_XS": 273062460480,
     "Q2_K": 190657657536,
     "Q3_K_L": 249521929152,
     "Q3_K_M": 236624444352,
     "Q3_K_S": 225876540256,
     "Q4_0": 284155590688,
     "Q4_1": 314068965536,
     "Q4_K_M": 314533641408,
     "Q4_K_S": 293378620480,
     "Q5_K_M": 380777430368,
     "Q5_K_S": 355087318240,
     "Q6_K": 441778339360,
     "Q6_K_S": 420649532864,
     "Q8_0": 532794736064
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Baseten",
      "input": 0.4,
      "output": 1.2,
      "tps": 328,
      "ttftMs": 330,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.99
    },
    "languages": [
     "en"
    ],
    "cutoff": "2026-06-30",
    "cutoffFrom": "openrouter"
   }
  },
  "kimi-k3": {
   "name": "Kimi K3",
   "repo": "moonshotai/Kimi-K3",
   "lab": "moonshotai",
   "params": 2779.9,
   "released": "2026-06-13",
   "license": "other",
   "licenseName": "kimi-k3",
   "hf": {
    "likes": 11919,
    "downloads": 781702
   },
   "modelscope": "moonshotai/Kimi-K3",
   "engines": {
    "arch": "KimiK3ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/moonshotai/Kimi-K3",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "pipenetwork/Kimi-K3-REAP80-MLX-mxfp4-q8"
   },
   "ggufFiles": {
    "repo": "unsloth/Kimi-K3-GGUF",
    "files": {
     "UD-IQ1_M": 648872012448,
     "UD-IQ1_S": 594040923616,
     "UD-IQ2_XXS": 711067773664,
     "UD-Q2_K_XL": 861277858912,
     "UD-Q4_K_XL": 1508668683104,
     "UD-Q8_K_XL": 1561157884384,
     "UD-TQ2_0": 551455107488
    }
   },
   "eci": {
    "score": 158,
    "name": "Kimi K3"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 2.85,
      "output": 14.25,
      "tps": 16,
      "ttftMs": 833,
      "context": 1048576
     },
     {
      "name": "Baseten",
      "input": 3,
      "output": 15,
      "tps": 73,
      "ttftMs": 773,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "efforts": [
     "low",
     "high",
     "max"
    ],
    "effortVia": "the \"reasoning_effort\" request field (default \"max\")",
    "sampling": {
     "source": "card",
     "temperature": 1,
     "topP": 0.95
    },
    "training": {
     "name": "Kimi K3",
     "flop": 2.0001e+25,
     "confidence": "Speculative"
    }
   }
  },
  "mistral-large-4": {
   "name": "Mistral Large 4",
   "repo": "mistralai/Mistral-Large-4-1T-A52B",
   "lab": "mistralai",
   "params": 1053.2,
   "released": "2026-10-29",
   "license": "other",
   "hf": {
    "likes": 1500,
    "downloads": 5500
   },
   "engines": {
    "arch": "MistralLarge4ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/mistralai/Mistral-Large-4-1T-A52B",
    "vllm": false,
    "llamacpp": true,
    "sglang": false,
    "mlx": false,
    "mlxRepo": "inferencerlabs/Mistral-Large-4-1T-A52B-MLX-Q3i"
   },
   "ggufFiles": {
    "repo": "ggml-org/Mistral-Large-4-1T-A52B-GGUF",
    "files": {
     "BF16": 2098861021920,
     "IQ2_XXS": 297676048832,
     "Q2_K": 380706433472,
     "Q4_K_M": 634802244608,
     "Q8_0": 1115150340608
    }
   },
   "eci": {
    "score": 151,
    "name": "Mistral Large 4"
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "supported",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "pt",
     "it",
     "ja",
     "ko",
     "ru",
     "zh",
     "ar",
     "fa",
     "id",
     "ms",
     "ne",
     "pl",
     "ro",
     "sr",
     "sv",
     "tr",
     "uk",
     "vi",
     "hi",
     "bn",
     "bg",
     "hr",
     "cs",
     "da",
     "nl",
     "et",
     "fi",
     "el",
     "hu",
     "ga",
     "lv",
     "lt",
     "mt",
     "sk",
     "sl"
    ],
    "training": {
     "name": "Mistral Large 4",
     "flop": 1.24e+25,
     "hardware": "NVIDIA GB200",
     "chips": 3800,
     "confidence": "Confident"
    }
   }
  },
  "mistral-large-3": {
   "name": "Mistral Large 3",
   "repo": "mistralai/Mistral-Large-3-675B-Instruct-2512",
   "lab": "mistralai",
   "params": 676,
   "released": "2025-12-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 261,
    "downloads": 2706
   },
   "engines": {
    "recipe": "https://recipes.vllm.ai/mistralai/Mistral-Large-3-675B-Instruct-2512",
    "vllmCard": true
   },
   "ggufFiles": {
    "repo": "unsloth/Mistral-Large-3-675B-Instruct-2512-GGUF",
    "files": {
     "BF16": 1346959087424,
     "IQ4_NL": 380738813248,
     "IQ4_XS": 359954316736,
     "UD-TQ1_0": 168604875200,
     "Q2_K": 247110065152,
     "Q2_K_L": 247330266208,
     "Q3_K_M": 321845570720,
     "Q3_K_S": 291854199872,
     "Q4_0": 381700357440,
     "Q4_1": 422366526912,
     "Q4_K_M": 406989520384,
     "Q4_K_S": 382661901632,
     "Q5_K_M": 477969661536,
     "Q5_K_S": 464446570080,
     "Q6_K": 553317879616,
     "Q8_0": 715677646752,
     "UD-IQ1_M": 206460042240,
     "UD-IQ1_S": 190801132352,
     "UD-IQ2_M": 235376884672,
     "UD-IQ2_XXS": 224807238656,
     "UD-IQ3_XXS": 279215127616,
     "UD-Q2_K_XL": 256369376320,
     "UD-Q3_K_XL": 300791151872,
     "UD-Q4_K_XL": 387880303968,
     "UD-Q5_K_XL": 479797460544,
     "UD-Q6_K_XL": 576471842784,
     "UD-Q8_K_XL": 773503992160
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "languages": [
     "en",
     "fr",
     "es",
     "de",
     "it",
     "pt",
     "nl",
     "zh",
     "ja",
     "ko",
     "ar"
    ],
    "training": {
     "name": "Mistral Large 3",
     "hardware": "NVIDIA H200",
     "chips": 3000,
     "confidence": "Confident"
    }
   }
  },
  "mistral-small-4": {
   "name": "Mistral Small 4 119B",
   "repo": "mistralai/Mistral-Small-4-119B-2603",
   "lab": "mistralai",
   "params": 119.4,
   "released": "2026-03-16",
   "license": "apache-2.0",
   "hf": {
    "likes": 471,
    "downloads": 55451
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/mistralai/Mistral-Small-4-119B-2603",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Mistral-Small-4-119B-2603-OptiQ-2bit"
   },
   "ggufFiles": {
    "repo": "bartowski/mistralai_Mistral-Small-4-119B-2603-GGUF",
    "files": {
     "IQ1_M": 29534629120,
     "IQ1_S": 26882944256,
     "IQ2_M": 41629199616,
     "IQ2_S": 38138359040,
     "IQ2_XS": 37019921664,
     "IQ2_XXS": 33663298816,
     "IQ3_M": 56959610336,
     "IQ3_XS": 51750284736,
     "IQ3_XXS": 49867042048,
     "IQ4_NL": 67460181472,
     "IQ4_XS": 63794752992,
     "Q2_K": 42069830912,
     "Q2_K_L": 42594118912,
     "Q3_K_L": 56898268640,
     "Q3_K_M": 54562565568,
     "Q3_K_S": 51995651520,
     "Q3_K_XL": 57368030656,
     "Q4_0": 67709742624,
     "Q4_K_L": 73035230656,
     "Q4_K_M": 72636771776,
     "Q4_K_S": 69884358112,
     "Q5_K_L": 85370515008,
     "Q5_K_M": 85039164992,
     "Q5_K_S": 82216562272,
     "Q6_K": 102808727104,
     "Q6_K_L": 103068773952,
     "Q8_0": 126472990400
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "effort",
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "pt",
     "it",
     "ja",
     "ko",
     "ru",
     "zh",
     "ar",
     "fa",
     "id",
     "ms",
     "ne",
     "pl",
     "ro",
     "sr",
     "sv",
     "tr",
     "uk",
     "vi",
     "hi",
     "bn"
    ]
   }
  },
  "leanstral-1.5": {
   "name": "Leanstral 1.5 119B-A6B",
   "repo": "mistralai/Leanstral-1.5-119B-A6B",
   "lab": "mistralai",
   "params": 119.4,
   "released": "2026-07-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 232,
    "downloads": 445
   },
   "engines": {
    "vllmCard": true,
    "vllmSetup": "uv pip install -U vllm --torch-backend=auto",
    "mlxRepo": "mvid/Leanstral-1.5-119B-A6B-MLX-3bit"
   },
   "ggufFiles": {
    "repo": "GZGavinZhao/Leanstral-1.5-119B-A6B-GGUF",
    "files": {
     "BF16": 237992523520,
     "Q4_K_M": 72159246080,
     "Q6_K": 97669011200
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort"
   }
  },
  "mixtral-8x22b": {
   "name": "Mixtral 8x22B",
   "repo": "mistralai/Mixtral-8x22B-Instruct-v0.1",
   "lab": "mistralai",
   "params": 140.6,
   "released": "2024-04-17",
   "license": "apache-2.0",
   "hf": {
    "likes": 781,
    "downloads": 39353
   },
   "ollama": {
    "name": "mixtral",
    "tag": "8x22b",
    "pulls": 2942995,
    "sizes": [
     "8x7b",
     "8x22b"
    ],
    "bytes": 79521266688,
    "quant": "Q4_0"
   },
   "engines": {
    "arch": "MixtralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/Mixtral-8x22B-Instruct-v0.1-GGUF",
    "files": {
     "IQ1_M": 32737212896,
     "IQ1_S": 29648894432,
     "IQ3_XS": 58234125120,
     "IQ4_XS": 76360596160,
     "Q2_K": 52108606272,
     "Q3_K_L": 72585722560,
     "Q3_K_M": 67795565248,
     "Q3_K_S": 61504109376,
     "Q4_K_M": 85593307840,
     "Q4_K_S": 80484645568,
     "Q5_K_M": 99975576480,
     "Q5_K_S": 96980843424,
     "Q6": 115537492896,
     "Q8_0": 149424847776
    }
   },
   "eci": {
    "score": 122,
    "name": "Mixtral 8x22B"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "MaziyarPanahi/Mixtral-8x22B-Instruct-v0.1-GGUF",
     "kv": "match",
     "ours": 229376,
     "theirs": 229376
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "openrouter",
     "temperature": 0.3
    },
    "languages": [
     "en",
     "es",
     "it",
     "de",
     "fr"
    ],
    "cutoff": "2024-01-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Mixtral 8x22B",
     "flop": 2.34e+24,
     "confidence": "Speculative"
    }
   }
  },
  "qwen3-coder-next": {
   "name": "Qwen3-Coder-Next 80B-A3B",
   "repo": "Qwen/Qwen3-Coder-Next",
   "lab": "qwen",
   "params": 79.7,
   "released": "2026-01-30",
   "license": "apache-2.0",
   "hf": {
    "likes": 1728,
    "downloads": 431761
   },
   "ollama": {
    "name": "qwen3-coder-next",
    "pulls": 2102422,
    "sizes": [],
    "bytes": 51741599936,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3NextForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install 'vllm>=0.15.0'",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "NexVeridian/Qwen3-Coder-Next-8bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3-Coder-Next-GGUF",
    "files": {
     "BF16": 159458415168,
     "Q4_1": 50057423200,
     "Q5_K_M": 56847886688,
     "Q5_K_S": 55055280480,
     "Q6_K": 65613992288,
     "Q8_0": 84812255584,
     "IQ4_NL": 45130344480,
     "IQ4_XS": 42676135968,
     "MXFP4_MOE": 48033779712,
     "Q2_K": 29224450080,
     "Q2_K_L": 29297379360,
     "Q3_K_M": 38322487328,
     "Q3_K_S": 34603089952,
     "Q4_0": 45330098208,
     "Q4_K_M": 48528320544,
     "Q4_K_S": 45531949088,
     "UD-IQ1_M": 21701693440,
     "UD-IQ1_S": 21508749344,
     "UD-IQ2_M": 24962293760,
     "UD-IQ2_XXS": 23312490496,
     "UD-IQ3_S": 29690687488,
     "UD-IQ3_XXS": 28482506752,
     "UD-IQ4_NL": 39234725888,
     "UD-IQ4_XS": 38429272064,
     "UD-Q2_K_XL": 26760515584,
     "UD-Q3_K_M": 35937513472,
     "UD-Q3_K_S": 33320267776,
     "UD-Q3_K_XL": 36282685440,
     "UD-Q4_K_M": 49301055488,
     "UD-Q4_K_S": 46079830016,
     "UD-Q4_K_XL": 49608478720,
     "UD-TQ1_0": 18941835296,
     "UD-Q5_K_M": 59242008928,
     "UD-Q5_K_S": 55819456832,
     "UD-Q5_K_XL": 59541180768,
     "UD-Q6_K": 65789092160,
     "UD-Q6_K_XL": 73118769504,
     "UD-Q8_K_XL": 86348747104
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 40
    }
   }
  },
  "qwen3-coder-30b-a3b": {
   "name": "Qwen3-Coder 30B-A3B",
   "repo": "Qwen/Qwen3-Coder-30B-A3B-Instruct",
   "lab": "qwen",
   "params": 30.5,
   "released": "2025-07-31",
   "license": "apache-2.0",
   "hf": {
    "likes": 1317,
    "downloads": 1126184
   },
   "ollama": {
    "name": "qwen3-coder",
    "tag": "30b",
    "pulls": 10571258,
    "sizes": [
     "30b",
     "480b"
    ],
    "bytes": 18556688736,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3MoeForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3-Coder-30B-A3B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3-Coder-30B-A3B-Instruct-GGUF",
    "files": {
     "BF16": 61095806048,
     "IQ4_NL": 17310784672,
     "IQ4_XS": 16378076320,
     "Q2_K": 11258612896,
     "Q2_K_L": 11331542176,
     "Q3_K_M": 14711850144,
     "Q3_K_S": 13292471456,
     "Q4_0": 17379990688,
     "Q4_1": 19192503456,
     "Q4_K_M": 18556689568,
     "Q4_K_S": 17456012448,
     "Q5_K_M": 21725584544,
     "Q5_K_S": 21080513696,
     "Q6_K": 25092535456,
     "Q8_0": 32483935392,
     "UD-IQ1_M": 9627540640,
     "UD-IQ1_S": 8914328736,
     "UD-IQ2_M": 10837007520,
     "UD-IQ2_XXS": 10333691040,
     "UD-IQ3_XXS": 12848766112,
     "UD-Q2_K_XL": 11788590240,
     "UD-Q3_K_XL": 13806312608,
     "UD-Q4_K_XL": 17665334432,
     "UD-Q5_K_XL": 21740305568,
     "UD-Q6_K_XL": 26340328608,
     "UD-Q8_K_XL": 35989947552,
     "UD-TQ1_0": 8005213344
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen3-Coder-30B-A3B-Instruct-GGUF",
     "kv": "match",
     "ours": 98304,
     "theirs": 98304
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "cutoff": "2025-06-30",
    "cutoffFrom": "openrouter"
   }
  },
  "qwen3-coder-480b-a35b": {
   "name": "Qwen3-Coder 480B-A35B",
   "repo": "Qwen/Qwen3-Coder-480B-A35B-Instruct",
   "lab": "qwen",
   "params": 480.2,
   "released": "2025-07-22",
   "license": "apache-2.0",
   "hf": {
    "likes": 1385,
    "downloads": 57959
   },
   "ollama": {
    "name": "qwen3-coder",
    "tag": "480b",
    "pulls": 10571258,
    "sizes": [
     "30b",
     "480b"
    ],
    "bytes": 290058824416,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3MoeForCausalLM",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3-Coder-480B-A35B-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3-Coder-480B-A35B-Instruct-MLX-6bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3-Coder-480B-A35B-Instruct-GGUF",
    "files": {
     "BF16": 960439201856,
     "IQ4_NL": 270594732448,
     "IQ4_XS": 260538233248,
     "Q2_K": 174656356544,
     "Q2_K_L": 174875144416,
     "Q3_K_M": 229248837984,
     "Q3_K_S": 206907582816,
     "Q4_0": 271646978496,
     "Q4_1": 300493451840,
     "Q4_K_M": 290058826208,
     "Q4_K_S": 272751129024,
     "Q5_K_M": 340493005408,
     "Q5_K_S": 330440929888,
     "Q6_K": 394079320928,
     "Q8_0": 510351879264,
     "UD-IQ1_M": 149716201312,
     "UD-IQ3_XXS": 201542070592,
     "UD-Q2_K_XL": 180294643936,
     "UD-Q3_K_XL": 212667330912,
     "UD-Q4_K_XL": 275553579456,
     "UD-Q5_K_XL": 339992097408,
     "UD-Q6_K_XL": 408043760480,
     "UD-Q8_K_XL": 548240698560
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen3-Coder-480B-A35B-Instruct-GGUF",
     "kv": "match",
     "ours": 253952,
     "theirs": 253952
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "cutoff": "2025-06-30",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Qwen3-Coder-480B-A35B",
     "flop": 1.575e+24,
     "tokens": 7500000000000,
     "confidence": "Confident"
    }
   }
  },
  "deepseek-v4-flash-vision-exp": {
   "name": "DeepSeek V4 Flash Vision Exp",
   "repo": "deepseek-ai/DeepSeek-V4-Flash-Vision-Exp",
   "lab": "deepseek-ai",
   "params": 304.6,
   "released": "2026-08-31",
   "license": "mit",
   "hf": {
    "likes": 962,
    "downloads": 202229
   },
   "modelscope": "deepseek-ai/DeepSeek-V4-Flash-Vision-Exp",
   "engines": {
    "arch": "DeepseekV4ForCausalLM",
    "recipe": "https://recipes.vllm.ai/deepseek-ai/DeepSeek-V4-Flash-Vision-Exp",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "inferencerlabs/DeepSeek-V4-Flash-Vision-Exp-MLX"
   },
   "ggufFiles": {
    "repo": "unsloth/DeepSeek-V4-Flash-Vision-Exp-GGUF",
    "files": {
     "UD-IQ1_M": 86867807104,
     "UD-IQ1_S": 82438622112,
     "UD-IQ2_XXS": 90693012352,
     "UD-IQ3_S": 114391665664,
     "UD-IQ3_XXS": 102999936000,
     "UD-IQ4_XS": 136662494240,
     "UD-Q2_K_XL": 96832555936,
     "UD-Q3_K_XL": 128206777376,
     "UD-Q4_K_XL": 155095288672,
     "UD-Q8_K_XL": 161869663072
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.44,
      "output": 1.32,
      "tps": 36,
      "ttftMs": 1677,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "supported",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 1
    }
   }
  },
  "qwen3.8-2.4t-a95b": {
   "name": "Qwen3.8 2.4T-A95B",
   "repo": "Qwen/Qwen3.8-2.4T-A95B",
   "lab": "qwen",
   "params": 2446.2,
   "released": "2026-08-08",
   "license": "other",
   "licenseName": "qwen3.8-max",
   "hf": {
    "likes": 1354,
    "downloads": 26113
   },
   "engines": {
    "arch": "Qwen3_5MoeForCausalLM",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.8-2.4T-A95B",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "pipenetwork/Qwen3.8-2.4T-A95B-MLX-reap75-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.8-2.4T-A95B-GGUF",
    "files": {
     "BF16": 4893172677568,
     "Q8_0": 2600249563264,
     "UD-IQ1_M": 563954811904,
     "UD-IQ1_S": 508388672224,
     "UD-IQ2_XS": 730653230336,
     "UD-IQ2_XXS": 656565044416,
     "UD-IQ3_XXS": 955535034144,
     "UD-IQ4_XS": 1310876469952
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 2,
      "output": 6,
      "tps": 33,
      "ttftMs": 1743,
      "context": 1000000
     },
     {
      "name": "DeepInfra",
      "input": 2,
      "output": 6,
      "tps": 16,
      "ttftMs": 656,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "ornith-1.5-397b": {
   "name": "Ornith 1.5 397B",
   "repo": "ornith-ai/Ornith-1.5-397B",
   "lab": "ornith-ai",
   "params": 403.4,
   "released": "2026-08-18",
   "license": "mit",
   "hf": {
    "likes": 99,
    "downloads": 231020
   },
   "ollama": {
    "name": "ornith-1.5",
    "tag": "397b",
    "pulls": 447698,
    "sizes": [
     "9b",
     "35b",
     "122b",
     "397b"
    ],
    "bytes": 240604935488,
    "projector": 921704576,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "inferencerlabs/Ornith-1.5-397B-MLX-Q9"
   },
   "ggufFiles": {
    "repo": "bartowski/Ornith-1.5-397B-GGUF",
    "files": {
     "IQ1_M": 91360966336,
     "IQ1_S": 81778030272,
     "IQ2_M": 133131532096,
     "IQ2_S": 120510871328,
     "IQ2_XS": 118465607360,
     "IQ2_XXS": 106314708672,
     "IQ3_M": 189560092608,
     "IQ3_XS": 181444114368,
     "IQ3_XXS": 166077413280,
     "IQ4_NL": 224515242048,
     "IQ4_XS": 212233205856,
     "Q2_K": 139499485024,
     "Q2_K_L": 140492764992,
     "Q3_K_L": 189477517248,
     "Q3_K_M": 181491300288,
     "Q3_K_S": 172934920128,
     "Q3_K_XL": 190367496128,
     "Q4_0": 225439037472,
     "Q4_1": 249095043232,
     "Q4_K_M": 241805932672,
     "Q4_K_S": 232835692576,
     "Q5_K_M": 283257518432,
     "Q5_K_S": 273994332320,
     "Q6_K": 342387325376,
     "Q8_0": 421576669536
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "ornith-1.5-35b-a3b": {
   "name": "Ornith 1.5 35B-A3B",
   "repo": "ornith-ai/Ornith-1.5-35B-A3B",
   "lab": "ornith-ai",
   "params": 36,
   "released": "2026-08-18",
   "license": "mit",
   "hf": {
    "likes": 773,
    "downloads": 275679
   },
   "ollama": {
    "name": "ornith-1.5",
    "tag": "35b",
    "pulls": 447698,
    "sizes": [
     "9b",
     "35b",
     "122b",
     "397b"
    ],
    "bytes": 21713462848,
    "projector": 902822016,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "ornith-ai/Ornith-1.5-35B-A3B-MLX"
   },
   "ggufFiles": {
    "repo": "ornith-ai/Ornith-1.5-35B-A3B-GGUF",
    "files": {
     "BF16": 71066994400,
     "Q4_K_M": 21713463040,
     "Q5_K_M": 25347532544,
     "Q6_K": 29208731392,
     "Q8_0": 37802149280
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "ornith-1.5-9b": {
   "name": "Ornith 1.5 9B",
   "repo": "ornith-ai/Ornith-1.5-9B",
   "lab": "ornith-ai",
   "params": 9.7,
   "released": "2026-08-18",
   "license": "mit",
   "hf": {
    "likes": 405,
    "downloads": 475026
   },
   "ollama": {
    "name": "ornith-1.5",
    "tag": "9b",
    "pulls": 447698,
    "sizes": [
     "9b",
     "35b",
     "122b",
     "397b"
    ],
    "bytes": 5629109056,
    "projector": 921704448,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "ornith-ai/Ornith-1.5-9B-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "OBLITERATUS/Ornith-1.5-9B-OBLITERATED",
    "files": {
     "IQ4_XS": 5357874464,
     "Q2_K": 3914968352,
     "Q3_K_M": 4737608992,
     "Q4_K_M": 5780090144,
     "Q5_K_M": 6642543904,
     "Q6_K": 7558901024,
     "Q8_0": 9786060064,
     "BF16": 18407320864
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking"
   }
  },
  "intern-s2-397b": {
   "name": "Intern S2 397B",
   "repo": "internlm/Intern-S2-397B",
   "lab": "internlm",
   "params": 403.4,
   "released": "2026-09-13",
   "license": "apache-2.0",
   "hf": {
    "likes": 49,
    "downloads": 1207
   },
   "modelscope": "Shanghai_AI_Laboratory/Intern-S2-397B",
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/internlm/Intern-S2-397B",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "bartowski/Intern-S2-397B-GGUF",
    "files": {
     "IQ1_M": 101820668544,
     "IQ1_S": 91610454624,
     "IQ2_M": 146060352192,
     "IQ2_S": 131563920064,
     "IQ2_XS": 125159152352,
     "IQ2_XXS": 118837533280,
     "IQ3_M": 213189663712,
     "IQ3_XS": 181843139424,
     "IQ3_XXS": 173290298176,
     "IQ4_NL": 253287210016,
     "IQ4_XS": 223272770528,
     "Q2_K": 154496932576,
     "Q3_K_L": 203945417696,
     "Q3_K_M": 193694538592,
     "Q3_K_S": 183779203936,
     "Q4_0": 229169093600,
     "Q4_1": 252826672192,
     "Q4_K_M": 254579055680,
     "Q4_K_S": 237231414304,
     "Q5_K_M": 309356666048,
     "Q5_K_S": 286573206720,
     "Q6_K": 353547853120,
     "Q6_K_S": 336904854848,
     "Q8_0": 428617506016
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "clef": {
   "name": "Clef",
   "repo": "Cloudflare/clef",
   "lab": "cloudflare",
   "params": 27.4,
   "released": "2026-09-30",
   "license": "apache-2.0",
   "parent": "Qwen/Qwen3.8-27B",
   "hf": {
    "likes": 2331,
    "downloads": 44091
   },
   "ollama": {
    "name": "clef",
    "tag": "27b",
    "pulls": 60304,
    "sizes": [
     "27b"
    ],
    "bytes": 19232219200,
    "projector": 931146304,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/clef-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Cloudflare_clef-GGUF",
    "files": {
     "IQ3_M": 13776408640,
     "IQ4_NL": 16296206400,
     "IQ4_XS": 15558516800,
     "Q2_K": 11705942080,
     "Q3_K_L": 15152336960,
     "Q3_K_M": 14477971520,
     "Q3_K_S": 13593235520,
     "Q4_0": 16185450560,
     "Q4_1": 17710637120,
     "Q4_K_L": 18596048960,
     "Q4_K_M": 17652432960,
     "Q4_K_S": 16593739840,
     "Q5_K_M": 20641202240,
     "Q5_K_S": 19570057280,
     "Q6_K": 23344091200,
     "Q6_K_L": 23959924800,
     "Q8_0": 28801519680,
     "BF16": 54064664832
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "clef-flash": {
   "name": "Clef Flash",
   "repo": "Cloudflare/clef-flash",
   "lab": "cloudflare",
   "params": 9.4,
   "released": "2026-09-30",
   "license": "apache-2.0",
   "parent": "Qwen/Qwen3.5-9B",
   "hf": {
    "likes": 898,
    "downloads": 44656
   },
   "ollama": {
    "name": "clef-flash",
    "tag": "9b",
    "pulls": 50596,
    "sizes": [
     "9b"
    ],
    "bytes": 9657260192,
    "projector": 921704928,
    "quant": "Q8_0"
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/clef-flash-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Cloudflare_clef-flash-GGUF",
    "files": {
     "IQ3_M": 4852291744,
     "IQ4_NL": 5633824928,
     "IQ4_XS": 5403859104,
     "Q2_K": 4194031776,
     "Q3_K_L": 5240789152,
     "Q3_K_M": 5049948320,
     "Q3_K_S": 4799076512,
     "Q4_0": 5600008352,
     "Q4_1": 6074620064,
     "Q4_K_L": 6795434144,
     "Q4_K_M": 6040541344,
     "Q4_K_S": 5727934624,
     "Q5_K_M": 6982686880,
     "Q5_K_S": 6656186528,
     "Q6_K": 7830018208,
     "Q6_K_L": 8322685088,
     "Q8_0": 9675741344,
     "BF16": 18164488352
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking"
   }
  },
  "d1-3b": {
   "name": "d1 3B",
   "repo": "LiquidAI/d1-3B",
   "lab": "liquidai",
   "params": 3.1,
   "released": "2026-10-05",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 492,
    "downloads": 33299
   },
   "ollama": {
    "name": "d1",
    "tag": "3b",
    "pulls": 31803,
    "sizes": [
     "2b",
     "3b"
    ],
    "bytes": 2874781280,
    "projector": 855763168,
    "quant": "Q8_0"
   },
   "engines": {
    "arch": "Lfm2VlForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "LiquidAI/d1-3B-MLX-fp16"
   },
   "ggufFiles": {
    "repo": "NANI-Nithin/d1-3B-GGUF",
    "files": {
     "BF16": 5403160160,
     "IQ1_M": 731574144,
     "IQ1_S": 677040000,
     "IQ2_M": 981217152,
     "IQ2_S": 908504960,
     "IQ2_XS": 896225152,
     "IQ2_XXS": 822464384,
     "IQ3_M": 1284870016,
     "IQ3_S": 1270525824,
     "IQ3_XS": 1221078912,
     "IQ3_XXS": 1120530304,
     "IQ4_NL": 1593896832,
     "IQ4_XS": 1517809536,
     "Q2_0": 909111168,
     "Q2_K": 1094594432,
     "Q2_K_S": 1038724992,
     "Q3_K_L": 1451650944,
     "Q3_K_M": 1366847360,
     "Q3_K_S": 1270525824,
     "Q4_0": 1593896544,
     "Q4_1": 1746071136,
     "Q4_K_M": 1674456960,
     "Q4_K_S": 1602678656,
     "Q5_0": 1898245728,
     "Q5_1": 2050420320,
     "Q5_K_M": 1939746688,
     "Q5_K_S": 1898246016,
     "Q6_K": 2221616736,
     "Q8_0": 2874781280
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "NANI-Nithin/d1-3B-GGUF",
     "kv": "match",
     "ours": 16384,
     "theirs": 16384
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "thinking",
    "languages": [
     "ar",
     "zh",
     "en",
     "fr",
     "de",
     "hi",
     "id",
     "it",
     "ja",
     "ko",
     "pl",
     "pt",
     "ru",
     "es",
     "th",
     "vi"
    ],
    "papers": [
     {
      "id": "2511.23404",
      "title": "LFM2 Technical Report",
      "date": "2025-11-28"
     }
    ]
   }
  },
  "humanizer": {
   "name": "Humanizer",
   "repo": "jialinyyzz/humanizer",
   "lab": "jialinyyzz",
   "params": 12,
   "released": "2026-09-11",
   "license": "apache-2.0",
   "parent": "google/gemma-4-12B",
   "hf": {
    "likes": 2231,
    "downloads": 281010
   },
   "engines": {
    "arch": "Gemma4UnifiedForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/humanizer-12b-OptiQ-4bit"
   },
   "ggufFiles": {
    "repo": "mradermacher/humanizer-i1-GGUF",
    "files": {
     "IQ1_M": 3202831008,
     "IQ1_S": 2983674528,
     "IQ2_M": 4371788448,
     "IQ2_S": 4079579808,
     "IQ2_XS": 3887825568,
     "IQ2_XXS": 3568091808,
     "IQ3_M": 5733974688,
     "IQ3_S": 5528212128,
     "IQ3_XS": 5272375968,
     "IQ3_XXS": 4849177248,
     "IQ4_NL": 6975861408,
     "IQ4_XS": 6635238048,
     "Q2_K": 4830130848,
     "Q2_K_S": 4504130208,
     "Q3_K_L": 6566302368,
     "Q3_K_M": 6087070368,
     "Q3_K_S": 5528212128,
     "Q4_0": 6997979808,
     "Q4_1": 7657108128,
     "Q4_K_M": 7381365408,
     "Q4_K_S": 7024030368,
     "Q5_K_M": 8547250848,
     "Q5_K_S": 8338354848,
     "Q6_K": 9786004128
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 64
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "jev-27b-vl": {
   "name": "JEV 27B VL",
   "repo": "autotrust/JEV-27B-VL",
   "lab": "autotrust",
   "params": 27.8,
   "released": "2026-09-30",
   "license": "apache-2.0",
   "parent": "Qwen/Qwen3.8-27B",
   "hf": {
    "likes": 3067,
    "downloads": 2477391
   },
   "modelscope": "autotrust/JEV-27B-VL",
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/autotrust/JEV-27B-VL",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "Bayway/JEV-27B-VL-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "PALLER-NOVUS/JEV-27B-VL-GGUF",
    "files": {
     "IQ1_M": 7631086784,
     "IQ2_XS": 9090593984,
     "Q2_K": 10711667616,
     "Q3_K_M": 13301445536,
     "Q3_K_S": 12073956256,
     "Q4_K_M": 16547402656,
     "Q5_K_M": 19231101856,
     "Q6_K": 22082532256,
     "Q8_0": 28595766176,
     "TQ1_0": 6916129696
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    },
    "languages": [
     "en"
    ]
   }
  },
  "mellum2.1-12b-a2.5b": {
   "name": "Mellum2.1 12B-A2.5B",
   "repo": "JetBrains/Mellum2.1-12B-A2.5B-Thinking",
   "lab": "jetbrains",
   "params": 12.1,
   "released": "2026-09-20",
   "license": "apache-2.0",
   "hf": {
    "likes": 190,
    "downloads": 9417
   },
   "engines": {
    "arch": "MellumForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "randmaru/Mellum2.1-12B-A2.5B-Thinking-mlx-mxfp4"
   },
   "ggufFiles": {
    "repo": "bartowski/Mellum2.1-12B-A2.5B-Thinking-GGUF",
    "files": {
     "IQ2_M": 5399733984,
     "IQ3_M": 7243643616,
     "IQ3_XS": 6292921056,
     "IQ3_XXS": 6281861856,
     "IQ4_NL": 7663303392,
     "IQ4_XS": 6971366112,
     "Q2_K": 5532315360,
     "Q3_K_L": 7130102496,
     "Q3_K_M": 6702480096,
     "Q3_K_S": 6052706016,
     "Q4_0": 7002847968,
     "Q4_1": 7710636768,
     "Q4_K_L": 9226042080,
     "Q4_K_M": 8819358432,
     "Q4_K_S": 7861041888,
     "Q5_K_M": 9969220320,
     "Q5_K_S": 8963422944,
     "Q6_K": 11453512416,
     "Q6_K_L": 11805489888,
     "Q6_K_S": 11133532896,
     "Q8_0": 12925418208,
     "BF16": 24311970176
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2605.31268",
      "title": "Mellum2 Technical Report",
      "date": "2026-05-29"
     }
    ]
   }
  },
  "lightonocr-3-4b": {
   "name": "LightOnOCR-3 4B",
   "repo": "lightonai/LightOnOCR-3-4B",
   "lab": "lightonai",
   "params": 4.5,
   "released": "2026-10-06",
   "license": "apache-2.0",
   "hf": {
    "likes": 130,
    "downloads": 19097
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "prithivMLmods/LightOnOCR-3-4B-MLX"
   },
   "ggufFiles": {
    "repo": "prithivMLmods/LightOnOCR-3-4B-GGUF",
    "files": {
     "BF16": 8424393664,
     "Q3_K_L": 2421316544,
     "Q3_K_M": 2262064064,
     "Q4_K_M": 2708804544,
     "Q4_K_S": 2563888064,
     "Q5_K_M": 3074986944,
     "Q5_K_S": 2990035904,
     "Q6_K": 3464055744,
     "Q8_0": 4482403264
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "papers": [
     {
      "id": "2601.14251",
      "title": "LightOnOCR: A 1B End-to-End Multilingual Vision-Language Model for State-of-the-Art OCR",
      "date": "2026-01-20"
     }
    ]
   }
  },
  "spark-x2.5-4b": {
   "name": "Spark-X2.5 4B",
   "repo": "XHToken/Spark-X2.5-4B",
   "lab": "xhtoken",
   "params": 4.1,
   "released": "2026-08-24",
   "license": "apache-2.0",
   "hf": {
    "likes": 1438,
    "downloads": 30616
   },
   "modelscope": "XHToken/Spark-X2.5-4B",
   "engines": {
    "arch": "Spark2_5ForCausalLM",
    "vllm": false,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "abenzerps/Spark-X2.5-4B-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "abenzerps/Spark-X2.5-4B-GGUF",
    "files": {
     "Q4_0": 2405581632,
     "Q4_K_M": 2600223552,
     "Q5_K_M": 2977895232,
     "Q6_K": 3379171392,
     "Q8_0": 4375020352
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    }
   }
  },
  "agnes-3.0-qwen": {
   "name": "Agnes-3.0-Qwen",
   "repo": "Agnes-AI/Agnes-3.0-Qwen",
   "lab": "agnes-ai",
   "params": 180,
   "released": "2026-10-10",
   "license": "other",
   "licenseName": "qwen-community-1.0",
   "parent": "Qwen/Qwen3.8-Flash-Next",
   "hf": {
    "likes": 20,
    "downloads": 605
   },
   "engines": {
    "arch": "Qwen4ExpForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false
   },
   "ggufFiles": {
    "repo": "bartowski/Agnes-AI_Agnes-3.0-Qwen-GGUF",
    "files": {
     "IQ1_M": 76161530208,
     "IQ1_S": 73886606688,
     "IQ2_M": 86018963936,
     "IQ2_S": 82293621216,
     "IQ2_XS": 80523196896,
     "IQ3_M": 102535387616,
     "IQ3_XS": 95449307584,
     "IQ3_XXS": 93187086816,
     "IQ4_NL": 107432565216,
     "IQ4_XS": 101416360416,
     "Q2_K": 87130823136,
     "Q3_K_L": 101187803616,
     "Q3_K_M": 97568700896,
     "Q3_K_S": 92935182816,
     "Q4_0": 102064808384,
     "Q4_1": 112726097376,
     "Q4_K_M": 127090528864,
     "Q4_K_S": 116730106336,
     "Q5_K_M": 142604758592,
     "Q5_K_S": 131594710624,
     "Q6_K": 174497315648,
     "Q6_K_S": 171043568320,
     "Q8_0": 191036471840,
     "BF16": 359246950272
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "youtu-parsing-omni": {
   "name": "Youtu-Parsing-Omni",
   "repo": "tencent/Youtu-Parsing-Omni",
   "lab": "tencent",
   "params": 5.3,
   "released": "2026-10-09",
   "license": "other",
   "licenseName": "youtu-parsing",
   "hf": {
    "likes": 125,
    "downloads": 3161
   },
   "engines": {
    "arch": "YoutuVITAForCausalLM",
    "vllm": false,
    "llamacpp": false,
    "vllmCard": true,
    "sglang": false,
    "mlx": false,
    "mlxRepo": "cguldogan/Youtu-Parsing-Omni-mlx-bf16"
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "audio"
    ],
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    },
    "papers": [
     {
      "id": "2610.39301",
      "title": "Youtu-Parsing-Omni: One Encoder, One Schema, All Modalities",
      "date": "2026-10-29"
     },
     {
      "id": "2601.20430",
      "title": "Youtu-Parsing: Perception, Structuring and Recognition via High-Parallelism Decoding",
      "date": "2026-01-28"
     },
     {
      "id": "2601.19798",
      "title": "Youtu-VL: Unleashing Visual Potential via Unified Vision-Language Supervision",
      "date": "2026-01-27"
     }
    ]
   }
  },
  "agnes-3.0-flash": {
   "name": "Agnes-3.0-Flash",
   "repo": "Agnes-AI/Agnes-3.0-Flash",
   "lab": "agnes-ai",
   "params": 33.1,
   "released": "2026-09-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 252,
    "downloads": 622
   },
   "modelscope": "Agnes-AI/Agnes-3.0-Flash",
   "engines": {
    "arch": "AgnesForConditionalGeneration",
    "vllm": false,
    "llamacpp": false,
    "gguf": {
     "repo": "quimmedes/Agnes-3.0-Flash-XYZ-GGUF",
     "arch": "qwen35",
     "llamacpp": true
    },
    "sglang": false,
    "mlx": false,
    "mlxRepo": "hermitdave/Agnes-3.0-Flash-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "0xKitkat/Agnes-3.0-Flash-GGUF",
    "files": {
     "Q4_K_M": 19753867616,
     "Q5_K_M": 22994991456,
     "Q6_K": 26438685536,
     "Q8_0": 34237630560
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "mistral-7b-v0.3": {
   "name": "Mistral 7B v0.3",
   "repo": "mistralai/Mistral-7B-Instruct-v0.3",
   "lab": "mistralai",
   "params": 7.2,
   "released": "2024-05-22",
   "license": "apache-2.0",
   "hf": {
    "likes": 3829,
    "downloads": 1666623
   },
   "engines": {
    "arch": "MistralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "plawanrath/mistral-7b-instruct-v0.3-q8-mlx-cba"
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/Mistral-7B-Instruct-v0.3-GGUF",
    "files": {
     "IQ1_M": 1757663392,
     "IQ1_S": 1615319200,
     "IQ2_XS": 2201473184,
     "IQ3_XS": 3022770336,
     "IQ4_XS": 3911962784,
     "Q2_K": 2722877600,
     "Q3_K_L": 3825979552,
     "Q3_K_M": 3522941088,
     "Q3_K_S": 3168522400,
     "Q4_K_M": 4372811936,
     "Q4_K_S": 4144746656,
     "Q5_K_M": 5136175264,
     "Q5_K_S": 5002481824,
     "Q6_K": 5947248800,
     "Q8_0": 7702565024
    }
   },
   "eci": {
    "score": 109,
    "name": "Mistral 7B v0.3"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "MaziyarPanahi/Mistral-7B-Instruct-v0.3-GGUF",
     "kv": "match",
     "ours": 131072,
     "theirs": 131072
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true
   }
  },
  "mistral-small-3.1-24b": {
   "name": "Mistral Small 3.1 24B",
   "repo": "mistralai/Mistral-Small-3.1-24B-Instruct-2503",
   "lab": "mistralai",
   "params": 24,
   "released": "2025-03-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 1408,
    "downloads": 179513
   },
   "ollama": {
    "name": "mistral-small3.1",
    "tag": "24b",
    "pulls": 809207,
    "sizes": [
     "24b"
    ],
    "bytes": 15486896384,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Mistral3ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "luiscalisto/Mistral-Small-3.1-24B-Instruct-2503-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/mistralai_Mistral-Small-3.1-24B-Instruct-2503-GGUF",
    "files": {
     "IQ2_M": 8114052576,
     "IQ2_S": 7478353376,
     "IQ2_XS": 7207034336,
     "IQ2_XXS": 6545120736,
     "IQ3_M": 10650951136,
     "IQ3_XS": 9907117536,
     "IQ3_XXS": 9280593376,
     "IQ4_NL": 13468016096,
     "IQ4_XS": 12758916576,
     "Q2_K": 8890326496,
     "Q2_K_L": 9545686496,
     "Q3_K_L": 12400762336,
     "Q3_K_M": 11474083296,
     "Q3_K_S": 10400275936,
     "Q3_K_XL": 12987964896,
     "Q4_0": 13494230496,
     "Q4_1": 14873107936,
     "Q4_K_L": 14831984096,
     "Q4_K_M": 14333910496,
     "Q4_K_S": 13549280736,
     "Q5_K_L": 17178172896,
     "Q5_K_M": 16763985376,
     "Q5_K_S": 16304414176,
     "Q6_K": 19345939936,
     "Q6_K_L": 19670998496,
     "Q8_0": 25054780896,
     "BF16": 47153519776
    }
   },
   "eci": {
    "score": 128,
    "name": "Mistral Small 3.1"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/mistralai_Mistral-Small-3.1-24B-Instruct-2503-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "sampling": {
     "source": "openrouter",
     "temperature": 0.3
    },
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "pt",
     "it",
     "ja",
     "ko",
     "ru",
     "zh",
     "ar",
     "fa",
     "id",
     "ms",
     "ne",
     "pl",
     "ro",
     "sr",
     "sv",
     "tr",
     "uk",
     "vi",
     "hi",
     "bn"
    ],
    "cutoff": "2023-10-31",
    "cutoffFrom": "openrouter"
   }
  },
  "mistral-nemo": {
   "name": "Mistral Nemo",
   "repo": "mistralai/Mistral-Nemo-Instruct-2407",
   "lab": "mistralai",
   "params": 12.2,
   "released": "2024-07-17",
   "license": "apache-2.0",
   "hf": {
    "likes": 1740,
    "downloads": 125772
   },
   "ollama": {
    "name": "mistral-nemo",
    "tag": "12b",
    "pulls": 5768794,
    "sizes": [
     "12b"
    ],
    "bytes": 7071700672,
    "quant": "Q4_0"
   },
   "engines": {
    "arch": "MistralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Mistral-Nemo-Instruct-2407-3bit"
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/Mistral-Nemo-Instruct-2407-GGUF",
    "files": {
     "Q2_K": 4791048128,
     "Q3_K_L": 6561503168,
     "Q3_K_M": 6083090368,
     "Q3_K_S": 5534226368,
     "Q4_K_M": 7477204928,
     "Q4_K_S": 7120197568,
     "Q5_K_M": 8727631808,
     "Q5_K_S": 8518735808,
     "Q6_K": 10056210368,
     "Q8_0": 13022369728
    }
   },
   "eci": {
    "score": 119,
    "name": "Mistral NeMo"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "MaziyarPanahi/Mistral-Nemo-Instruct-2407-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "openrouter",
     "temperature": 0.3
    },
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "it",
     "pt",
     "ru",
     "zh",
     "ja"
    ],
    "cutoff": "2024-04-30",
    "cutoffFrom": "openrouter"
   }
  },
  "ministral-8b": {
   "name": "Ministral 8B",
   "repo": "mistralai/Ministral-8B-Instruct-2410",
   "lab": "mistralai",
   "params": 8,
   "released": "2024-10-15",
   "license": "other",
   "licenseName": "mrl",
   "hf": {
    "likes": 602,
    "downloads": 45602
   },
   "engines": {
    "arch": "MistralForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install --upgrade vllm",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "alexgusevski/Ministral-8B-Instruct-2410-q3-mlx"
   },
   "ggufFiles": {
    "repo": "bartowski/Ministral-8B-Instruct-2410-GGUF",
    "files": {
     "IQ2_M": 2958330688,
     "IQ3_M": 3791686464,
     "IQ3_XS": 3521940288,
     "IQ4_XS": 4448226112,
     "Q2_K": 3185478464,
     "Q2_K_L": 3709766464,
     "Q3_K_L": 4326460224,
     "Q3_K_M": 4019227456,
     "Q3_K_S": 3664677696,
     "Q3_K_XL": 4796222272,
     "Q4_0": 4671048512,
     "Q4_0_4_4": 4658465600,
     "Q4_0_4_8": 4658465600,
     "Q4_0_8_8": 4658465600,
     "Q4_K_L": 5309958976,
     "Q4_K_M": 4911500096,
     "Q4_K_S": 4685728576,
     "Q5_K_L": 6055496512,
     "Q5_K_M": 5724146496,
     "Q5_K_S": 5593795392,
     "Q6_K": 6587583296,
     "Q6_K_L": 6847630144,
     "Q8_0": 8529808192,
     "F16": 16048097824
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "languages": [
     "en",
     "fr",
     "de",
     "es",
     "it",
     "pt",
     "zh",
     "ja",
     "ru",
     "ko"
    ]
   }
  },
  "deepseek-v3": {
   "name": "DeepSeek V3",
   "repo": "deepseek-ai/DeepSeek-V3",
   "lab": "deepseek-ai",
   "params": 684.5,
   "released": "2024-12-25",
   "license": "mit",
   "hf": {
    "likes": 4462,
    "downloads": 1614390
   },
   "ollama": {
    "name": "deepseek-v3",
    "tag": "671b",
    "pulls": 3854658,
    "sizes": [
     "671b"
    ],
    "bytes": 404430186016,
    "quant": "Q4_K_M"
   },
   "modelscope": "deepseek-ai/DeepSeek-V3",
   "engines": {
    "arch": "DeepseekV3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/deepseek-ai/DeepSeek-V3",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/DeepSeek-V3-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/DeepSeek-V3-GGUF",
    "files": {
     "Q2_K_L": 244245533792,
     "Q2_K_XS": 221253686368,
     "Q3_K_M": 319198395296,
     "Q4_K_M": 404430187072,
     "Q5_K_M": 475396557600,
     "Q6_K": 550798326368,
     "Q8_0": 713286514080
    }
   },
   "eci": {
    "score": 132,
    "name": "DeepSeek-V3"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.32,
      "output": 0.89,
      "tps": 18,
      "ttftMs": 481,
      "context": 163840
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "papers": [
     {
      "id": "2412.19437",
      "title": "DeepSeek-V3 Technical Report",
      "date": "2024-12-27"
     }
    ],
    "cutoff": "2024-07-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "DeepSeek-V3",
     "flop": 3.3e+24,
     "tokens": 14800000000000,
     "hardware": "NVIDIA H800 SXM5",
     "chips": 2048,
     "confidence": "Confident"
    }
   }
  },
  "deepseek-coder-7b-v1.5": {
   "name": "DeepSeek Coder 7B v1.5",
   "repo": "deepseek-ai/deepseek-coder-7b-instruct-v1.5",
   "lab": "deepseek-ai",
   "params": 6.9,
   "released": "2024-01-25",
   "license": "other",
   "licenseName": "deepseek",
   "hf": {
    "likes": 193,
    "downloads": 249524
   },
   "engines": {
    "arch": "LlamaForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "Edmon02/deepseek-coder-7b-instruct-v1.5-GGUF",
    "files": {
     "IQ3_M": 3289676672,
     "IQ3_S": 3138018176,
     "IQ3_XS": 2993609600,
     "IQ4_XS": 3818363776,
     "Q2_K": 2718423936,
     "Q3_K_L": 3746274176,
     "Q3_K_M": 3461192576,
     "Q3_K_S": 3138018176,
     "Q4_K_M": 4223359872,
     "Q4_K_S": 4025359232,
     "Q5_K_M": 4926430080,
     "Q5_K_S": 4811398016,
     "Q6_K": 5673442176,
     "Q8_0": 7345719776
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Edmon02/deepseek-coder-7b-instruct-v1.5-GGUF",
     "kv": "match",
     "ours": 491520,
     "theirs": 491520
    }
   }
  },
  "deepseek-r1-qwen3-8b": {
   "name": "DeepSeek R1 Qwen3 8B",
   "repo": "deepseek-ai/DeepSeek-R1-0528-Qwen3-8B",
   "lab": "deepseek-ai",
   "params": 8.2,
   "released": "2025-05-29",
   "license": "mit",
   "hf": {
    "likes": 1126,
    "downloads": 359894
   },
   "modelscope": "deepseek-ai/DeepSeek-R1-0528-Qwen3-8B",
   "engines": {
    "arch": "Qwen3ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/DeepSeek-R1-0528-Qwen3-8B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/DeepSeek-R1-0528-Qwen3-8B-GGUF",
    "files": {
     "BF16": 16388045056,
     "IQ4_NL": 4793625088,
     "IQ4_XS": 4581288448,
     "Q2_K": 3281734144,
     "Q2_K_L": 3427592704,
     "Q3_K_M": 4124162560,
     "Q3_K_S": 3769612800,
     "Q4_0": 4787333632,
     "Q4_1": 5247756800,
     "Q4_K_M": 5027785216,
     "Q4_K_S": 4802013696,
     "Q5_K_M": 5851113984,
     "Q5_K_S": 5720762880,
     "Q6_K": 6725900800,
     "Q8_0": 8709519872,
     "UD-IQ1_M": 2390985216,
     "UD-IQ1_S": 2268695040,
     "UD-IQ2_M": 3110504960,
     "UD-IQ2_XXS": 2601683456,
     "UD-IQ3_XXS": 3410266624,
     "UD-Q2_K_XL": 3501976064,
     "UD-Q3_K_XL": 4313737728,
     "UD-Q4_K_XL": 5122746880,
     "UD-Q5_K_XL": 5883587072,
     "UD-Q6_K_XL": 7490550272,
     "UD-Q8_K_XL": 10824038912
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/DeepSeek-R1-0528-Qwen3-8B-GGUF",
     "kv": "match",
     "ours": 147456,
     "theirs": 147456
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "card",
     "temperature": 0.6,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2501.12948",
      "title": "DeepSeek-R1: Incentivizing Reasoning Capability in LLMs via Reinforcement Learning",
      "date": "2025-01-22"
     }
    ]
   }
  },
  "deepseek-r1-distill-qwen-32b": {
   "name": "DeepSeek R1 Distill Qwen 32B",
   "repo": "deepseek-ai/DeepSeek-R1-Distill-Qwen-32B",
   "lab": "deepseek-ai",
   "params": 32.8,
   "released": "2025-01-20",
   "license": "mit",
   "hf": {
    "likes": 1667,
    "downloads": 347183
   },
   "modelscope": "deepseek-ai/DeepSeek-R1-Distill-Qwen-32B",
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/DeepSeek-R1-Distill-Qwen-32B-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/DeepSeek-R1-Distill-Qwen-32B-GGUF",
    "files": {
     "IQ2_M": 11264440480,
     "IQ2_S": 10387568800,
     "IQ2_XS": 9957550240,
     "IQ2_XXS": 9028249760,
     "IQ3_M": 14810122400,
     "IQ3_XS": 13705513120,
     "IQ4_NL": 18682173600,
     "IQ4_XS": 17693153440,
     "Q2_K": 12313098400,
     "Q2_K_L": 13073418400,
     "Q3_K_L": 17247078560,
     "Q3_K_M": 15935047840,
     "Q3_K_S": 14392330400,
     "Q3_K_XL": 17928325280,
     "Q4_0": 18711009440,
     "Q4_1": 20639242400,
     "Q4_K_L": 20429179040,
     "Q4_K_M": 19851335840,
     "Q4_K_S": 18784409760,
     "Q5_K_L": 23742679200,
     "Q5_K_M": 23262156960,
     "Q5_K_S": 22638254240,
     "Q6_K": 26886154400,
     "Q6_K_L": 27263273120,
     "Q8_0": 34820884352,
     "BF16": 65535969344
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/DeepSeek-R1-Distill-Qwen-32B-GGUF",
     "kv": "match",
     "ours": 262144,
     "theirs": 262144
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2501.12948",
      "title": "DeepSeek-R1: Incentivizing Reasoning Capability in LLMs via Reinforcement Learning",
      "date": "2025-01-22"
     }
    ]
   }
  },
  "deepseek-v3.1": {
   "name": "DeepSeek V3.1",
   "repo": "deepseek-ai/DeepSeek-V3.1",
   "lab": "deepseek-ai",
   "params": 684.5,
   "released": "2025-08-21",
   "license": "mit",
   "hf": {
    "likes": 864,
    "downloads": 268950
   },
   "ollama": {
    "name": "deepseek-v3.1",
    "tag": "671b",
    "pulls": 747398,
    "sizes": [
     "671b"
    ],
    "bytes": 404494154496,
    "quant": "Q4_K_M"
   },
   "modelscope": "deepseek-ai/DeepSeek-V3.1",
   "engines": {
    "arch": "DeepseekV3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/deepseek-ai/DeepSeek-V3.1",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/DeepSeek-V3.1-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/DeepSeek-V3.1-GGUF",
    "files": {
     "BF16": 1342273053984,
     "UD-TQ1_0": 170499768256,
     "IQ4_NL": 379135951680,
     "IQ4_XS": 358347326240,
     "Q2_K": 245696582144,
     "Q2_K_L": 245913772544,
     "Q3_K_M": 320451083008,
     "Q3_K_S": 290448357952,
     "Q4_0": 380100248384,
     "Q4_1": 420771120128,
     "Q4_K_M": 405398012928,
     "Q4_K_S": 381064545088,
     "Q5_K_M": 476161393760,
     "Q5_K_S": 462632453184,
     "Q6_K": 551313395136,
     "Q8_0": 713286520224,
     "UD-IQ1_M": 206824653344,
     "UD-IQ1_S": 192314343808,
     "UD-IQ2_M": 235509252576,
     "UD-IQ2_XXS": 225879130592,
     "UD-IQ3_XXS": 279696491104,
     "UD-Q2_K_XL": 255725077088,
     "UD-Q3_K_XL": 300024709856,
     "UD-Q4_K_XL": 386913043296,
     "UD-Q5_K_XL": 484582147136,
     "UD-Q6_K_XL": 574468492704,
     "UD-Q8_K_XL": 780571185056
    }
   },
   "eci": {
    "score": 140,
    "name": "DeepSeek-V3.1"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.25,
      "output": 0.95,
      "tps": 27,
      "ttftMs": 534,
      "context": 163840
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2412.19437",
      "title": "DeepSeek-V3 Technical Report",
      "date": "2024-12-27"
     }
    ],
    "cutoff": "2025-03-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "DeepSeek-V3.1",
     "flop": 3.594058e+24,
     "tokens": 840000000000,
     "confidence": "Confident"
    }
   }
  },
  "deepseek-r1-distill-qwen-14b": {
   "name": "DeepSeek R1 Distill Qwen 14B",
   "repo": "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
   "lab": "deepseek-ai",
   "params": 14.8,
   "released": "2025-01-20",
   "license": "mit",
   "hf": {
    "likes": 734,
    "downloads": 244955
   },
   "modelscope": "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/DeepSeek-R1-Distill-Qwen-14B-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/DeepSeek-R1-Distill-Qwen-14B-GGUF",
    "files": {
     "IQ2_M": 5356146080,
     "IQ2_S": 5003726240,
     "IQ2_XS": 4704574880,
     "IQ3_M": 6916537760,
     "IQ3_XS": 6383361440,
     "IQ4_NL": 8549182880,
     "IQ4_XS": 8119840160,
     "Q2_K": 5770497440,
     "Q2_K_L": 6530817440,
     "Q3_K_L": 7924768160,
     "Q3_K_M": 7339204000,
     "Q3_K_S": 6659595680,
     "Q3_K_XL": 8606014880,
     "Q4_0": 8544267680,
     "Q4_1": 9392139680,
     "Q4_K_L": 9565953440,
     "Q4_K_M": 8988110240,
     "Q4_K_S": 8573431200,
     "Q5_K_L": 10989395360,
     "Q5_K_M": 10508873120,
     "Q5_K_S": 10266553760,
     "Q6_K": 12124683680,
     "Q6_K_L": 12501802400,
     "Q8_0": 15701597600,
     "F16": 29547716000,
     "F32": 59086101824
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.2,
      "output": 0.2,
      "tps": 85,
      "ttftMs": 446,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/DeepSeek-R1-Distill-Qwen-14B-GGUF",
     "kv": "match",
     "ours": 196608,
     "theirs": 196608
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2501.12948",
      "title": "DeepSeek-R1: Incentivizing Reasoning Capability in LLMs via Reinforcement Learning",
      "date": "2025-01-22"
     }
    ],
    "training": {
     "name": "DeepSeek-R1-Distill-Qwen-14B",
     "tokens": 24000000000,
     "confidence": "Speculative"
    }
   }
  },
  "deepseek-r1-distill-qwen-7b": {
   "name": "DeepSeek R1 Distill Qwen 7B",
   "repo": "deepseek-ai/DeepSeek-R1-Distill-Qwen-7B",
   "lab": "deepseek-ai",
   "params": 7.6,
   "released": "2025-01-20",
   "license": "mit",
   "hf": {
    "likes": 950,
    "downloads": 315654
   },
   "modelscope": "deepseek-ai/DeepSeek-R1-Distill-Qwen-7B",
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/DeepSeek-R1-Distill-Qwen-7B-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/DeepSeek-R1-Distill-Qwen-7B-GGUF",
    "files": {
     "IQ2_M": 2780342240,
     "IQ3_M": 3574011872,
     "IQ3_XS": 3346255840,
     "IQ4_NL": 4437813216,
     "IQ4_XS": 4218472416,
     "Q2_K": 3015940064,
     "Q2_K_L": 3548164064,
     "Q3_K_L": 4088459232,
     "Q3_K_M": 3808391136,
     "Q3_K_S": 3492368352,
     "Q3_K_XL": 4565331936,
     "Q4_0": 4444121056,
     "Q4_1": 4873283552,
     "Q4_K_L": 5087563744,
     "Q4_K_M": 4683073504,
     "Q4_K_S": 4457768928,
     "Q5_K_L": 5781196768,
     "Q5_K_M": 5444831200,
     "Q5_K_S": 5315176416,
     "Q6_K": 6254198752,
     "Q6_K_L": 6518181856,
     "Q8_0": 8098525152,
     "F16": 15237853152,
     "F32": 30468419264
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.15,
      "output": 0.15,
      "tps": 149,
      "ttftMs": 314,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/DeepSeek-R1-Distill-Qwen-7B-GGUF",
     "kv": "match",
     "ours": 57344,
     "theirs": 57344
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2501.12948",
      "title": "DeepSeek-R1: Incentivizing Reasoning Capability in LLMs via Reinforcement Learning",
      "date": "2025-01-22"
     }
    ]
   }
  },
  "deepseek-r1-distill-llama-8b": {
   "name": "DeepSeek R1 Distill Llama 8B",
   "repo": "deepseek-ai/DeepSeek-R1-Distill-Llama-8B",
   "lab": "deepseek-ai",
   "params": 8,
   "released": "2025-01-20",
   "license": "mit",
   "hf": {
    "likes": 915,
    "downloads": 78286
   },
   "engines": {
    "arch": "LlamaForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/DeepSeek-R1-Distill-Llama-8B-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/DeepSeek-R1-Distill-Llama-8B-GGUF",
    "files": {
     "BF16": 16068893856,
     "F16": 16068893408,
     "IQ4_NL": 4677991872,
     "IQ4_XS": 4464082368,
     "Q2_K": 3179134400,
     "Q2_K_L": 3302260160,
     "Q3_K_M": 4018920896,
     "Q3_K_S": 3664502208,
     "Q4_0": 4675894720,
     "Q4_1": 5130255808,
     "Q4_K_M": 4920737216,
     "Q4_K_S": 4692671936,
     "Q5_K_M": 5732990400,
     "Q5_K_S": 5599296960,
     "Q6_K": 6596009408,
     "Q8_0": 8540773088,
     "UD-IQ1_M": 2292202944,
     "UD-IQ1_S": 2164669888,
     "UD-IQ2_M": 3003268544,
     "UD-IQ2_XXS": 2504867264,
     "UD-IQ3_XXS": 3321773504,
     "UD-Q2_K_XL": 3388767680,
     "UD-Q3_K_XL": 4199611840,
     "UD-Q4_K_XL": 4994203072,
     "UD-Q5_K_XL": 5738134976,
     "UD-Q6_K_XL": 7329930688,
     "UD-Q8_K_XL": 10575666624
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.05,
      "output": 0.05,
      "tps": 135,
      "ttftMs": 428,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/DeepSeek-R1-Distill-Llama-8B-GGUF",
     "kv": "match",
     "ours": 131072,
     "theirs": 131072
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95
    },
    "papers": [
     {
      "id": "2501.12948",
      "title": "DeepSeek-R1: Incentivizing Reasoning Capability in LLMs via Reinforcement Learning",
      "date": "2025-01-22"
     }
    ]
   }
  },
  "qwen3-4b": {
   "name": "Qwen3 4B",
   "repo": "Qwen/Qwen3-4B",
   "lab": "qwen",
   "params": 4,
   "released": "2025-04-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 780,
    "downloads": 8417695
   },
   "ollama": {
    "name": "qwen3",
    "tag": "4b",
    "pulls": 42279328,
    "sizes": [
     "0.6b",
     "1.7b",
     "4b",
     "8b",
     "14b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 2497280480,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3-4B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen3-4B-GGUF",
    "files": {
     "Q4_K_M": 2497280256,
     "Q5_0": 2823710976,
     "Q5_K_M": 2889513184,
     "Q6_K": 3306260704,
     "Q8_0": 4280404704
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen3-4B-GGUF",
     "kv": "match",
     "ours": 147456,
     "theirs": 147456
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "training": {
     "name": "Qwen3-4B",
     "flop": 8.64e+23,
     "confidence": "Confident"
    }
   }
  },
  "qwen3-8b": {
   "name": "Qwen3 8B",
   "repo": "Qwen/Qwen3-8B",
   "lab": "qwen",
   "params": 8.2,
   "released": "2025-04-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 2165,
    "downloads": 7540663
   },
   "ollama": {
    "name": "qwen3",
    "tag": "8b",
    "pulls": 42279328,
    "sizes": [
     "0.6b",
     "1.7b",
     "4b",
     "8b",
     "14b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 5225374496,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3-8B",
   "engines": {
    "arch": "Qwen3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3-8B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Qwen3-8B-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen3-8B-GGUF",
    "files": {
     "Q4_K_M": 5027783488,
     "Q5_0": 5720761152,
     "Q5_K_M": 5851112224,
     "Q6_K": 6725899040,
     "Q8_0": 8709518112
    }
   },
   "eci": {
    "score": 136,
    "name": "Qwen3-8B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.07,
      "output": 0.18,
      "tps": 127,
      "ttftMs": 465,
      "context": 40960
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen3-8B-GGUF",
     "kv": "match",
     "ours": 147456,
     "theirs": 147456
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "training": {
     "name": "Qwen3-8B",
     "flop": 1.7712e+24,
     "confidence": "Confident"
    }
   }
  },
  "qwen2.5-7b": {
   "name": "Qwen2.5 7B",
   "repo": "Qwen/Qwen2.5-7B-Instruct",
   "lab": "qwen",
   "params": 7.6,
   "released": "2024-09-16",
   "license": "apache-2.0",
   "hf": {
    "likes": 2485,
    "downloads": 5896682
   },
   "ollama": {
    "name": "qwen2.5",
    "tag": "7b",
    "pulls": 44488258,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b",
     "72b"
    ],
    "bytes": 4683073952,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen2.5-7B-Instruct",
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-7B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-7B-Instruct-GGUF",
    "files": {
     "Q2_K": 3015940000,
     "Q3_K_M": 3808391072,
     "Q4_0": 4431390848,
     "Q4_K_M": 4683073632,
     "Q5_0": 5315176576,
     "Q5_K_M": 5444831360,
     "Q6_K": 6254198880,
     "Q8_0": 8098525408
    }
   },
   "eci": {
    "score": 118,
    "name": "Qwen2.5-7B"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-7B-Instruct-GGUF",
     "kv": "match",
     "ours": 57344,
     "theirs": 57344
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ],
    "cutoff": "2024-06-30",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Qwen2.5-7B",
     "flop": 8.2188e+23,
     "confidence": "Confident"
    }
   }
  },
  "qwen3-14b": {
   "name": "Qwen3 14B",
   "repo": "Qwen/Qwen3-14B",
   "lab": "qwen",
   "params": 14.8,
   "released": "2025-04-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 531,
    "downloads": 12988834
   },
   "ollama": {
    "name": "qwen3",
    "tag": "14b",
    "pulls": 42279328,
    "sizes": [
     "0.6b",
     "1.7b",
     "4b",
     "8b",
     "14b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 9276184896,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3-14B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "Qwen/Qwen3-14B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3-14B-GGUF",
    "files": {
     "BF16": 29543424160,
     "IQ4_NL": 8541363584,
     "IQ4_XS": 8135040384,
     "Q2_K": 5753984384,
     "Q2_K_L": 5936307584,
     "Q3_K_M": 7321313664,
     "Q3_K_S": 6657106304,
     "Q4_0": 8543001984,
     "Q4_1": 9389522304,
     "Q4_K_M": 9001753984,
     "Q4_K_S": 8573476224,
     "Q5_K_M": 10514570624,
     "Q5_K_S": 10263895424,
     "Q6_K": 12121938304,
     "Q8_0": 15698534784,
     "UD-IQ1_M": 4064814464,
     "UD-IQ1_S": 3827369344,
     "UD-IQ2_M": 5425956224,
     "UD-IQ2_XXS": 4470113664,
     "UD-IQ3_XXS": 6013732224,
     "UD-Q2_K_XL": 6067584384,
     "UD-Q3_K_XL": 7593917824,
     "UD-Q4_K_XL": 9159818624,
     "UD-Q5_K_XL": 10546437504,
     "UD-Q6_K_XL": 13285990784,
     "UD-Q8_K_XL": 18754560384
    }
   },
   "eci": {
    "score": 138,
    "name": "Qwen3-14B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.07,
      "output": 0.2,
      "tps": 91,
      "ttftMs": 402,
      "context": 40960
     },
     {
      "name": "DeepInfra",
      "input": 0.12,
      "output": 0.24,
      "tps": 95,
      "ttftMs": 190,
      "context": 40960
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen3-14B-GGUF",
     "kv": "match",
     "ours": 163840,
     "theirs": 163840
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "cutoff": "2025-03-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Qwen3-14B",
     "flop": 3.1968e+24,
     "confidence": "Confident"
    }
   }
  },
  "qwen2.5-3b": {
   "name": "Qwen2.5 3B",
   "repo": "Qwen/Qwen2.5-3B-Instruct",
   "lab": "qwen",
   "params": 3.1,
   "released": "2024-09-17",
   "license": "other",
   "licenseName": "qwen-research",
   "hf": {
    "likes": 631,
    "downloads": 3062441
   },
   "ollama": {
    "name": "qwen2.5",
    "tag": "3b",
    "pulls": 44488258,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b",
     "72b"
    ],
    "bytes": 1929903008,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-3B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-3B-Instruct-GGUF",
    "files": {
     "Q2_K": 1376856480,
     "Q3_K_M": 1724178848,
     "Q4_0": 1997879712,
     "Q4_K_M": 2104932768,
     "Q5_0": 2383591840,
     "Q5_K_M": 2438740384,
     "Q6_K": 2793410976,
     "Q8_0": 3616088480
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-3B-Instruct-GGUF",
     "kv": "match",
     "ours": 36864,
     "theirs": 36864
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ],
    "training": {
     "name": "Qwen2.5-3B",
     "flop": 3.3372e+23,
     "confidence": "Confident"
    }
   }
  },
  "qwen3.6-27b": {
   "name": "Qwen3.6 27B",
   "repo": "Qwen/Qwen3.6-27B",
   "lab": "qwen",
   "params": 27.8,
   "released": "2026-04-21",
   "license": "apache-2.0",
   "hf": {
    "likes": 2343,
    "downloads": 2263609
   },
   "ollama": {
    "name": "qwen3.6",
    "tag": "27b",
    "pulls": 7449367,
    "sizes": [
     "27b",
     "35b"
    ],
    "bytes": 16837919680,
    "projector": 931145568,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3.6-27B",
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.6-27B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3.6-27B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.6-27B-GGUF",
    "files": {
     "BF16": 53808281760,
     "IQ4_NL": 16071772384,
     "IQ4_XS": 15440005344,
     "Q3_K_M": 13586217184,
     "Q3_K_S": 12358727904,
     "Q4_0": 15791278304,
     "Q4_1": 17252239584,
     "Q4_K_M": 16817244384,
     "Q4_K_S": 15856158944,
     "Q5_K_M": 19509790944,
     "Q5_K_S": 18958305504,
     "Q6_K": 22523238624,
     "Q8_0": 28595763424,
     "UD-IQ2_M": 10846136544,
     "UD-IQ2_XXS": 9388779744,
     "UD-IQ3_XXS": 11994777824,
     "UD-Q2_K_XL": 11849779424,
     "UD-Q3_K_XL": 14473431264,
     "UD-Q4_K_XL": 17612564704,
     "UD-Q5_K_XL": 20038256864,
     "UD-Q6_K_XL": 25636485344,
     "UD-Q8_K_XL": 35325163744
    }
   },
   "eci": {
    "score": 146,
    "name": "Qwen3.6 27B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "OVHcloud",
      "input": 0.47,
      "output": 3.19,
      "tps": 55,
      "ttftMs": 578,
      "context": 262144
     },
     {
      "name": "DeepInfra",
      "input": 0.32,
      "output": 3.2,
      "tps": 65,
      "ttftMs": 281,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "qwen3.5-27b": {
   "name": "Qwen3.5 27B",
   "repo": "Qwen/Qwen3.5-27B",
   "lab": "qwen",
   "params": 27.8,
   "released": "2026-02-24",
   "license": "apache-2.0",
   "hf": {
    "likes": 1082,
    "downloads": 1792337
   },
   "ollama": {
    "name": "qwen3.5",
    "tag": "27b",
    "pulls": 24161275,
    "sizes": [
     "0.8b",
     "2b",
     "4b",
     "9b",
     "27b",
     "35b",
     "122b"
    ],
    "bytes": 16547399008,
    "projector": 931145984,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.5-27B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto --extra-index-url https://wheels.vllm.ai/nightly",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Qwen3.5-27B-OptiQ-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.5-27B-GGUF",
    "files": {
     "BF16": 53808281472,
     "IQ4_NL": 15687894944,
     "IQ4_XS": 14977484704,
     "Q3_K_M": 13505116064,
     "Q3_K_S": 12289423264,
     "Q4_0": 15721973664,
     "Q4_1": 17182934944,
     "Q4_K_M": 16740812704,
     "Q4_K_S": 15769159584,
     "Q5_K_M": 19608995744,
     "Q5_K_S": 18889000864,
     "Q6_K": 22453933984,
     "Q8_0": 28595763104,
     "UD-IQ2_M": 10188072864,
     "UD-IQ2_XXS": 8573593504,
     "UD-IQ3_XXS": 11506493344,
     "UD-Q2_K_XL": 11213752224,
     "UD-Q3_K_XL": 14438533024,
     "UD-Q4_K_XL": 17621125024,
     "UD-Q5_K_XL": 20171253664,
     "UD-Q6_K_XL": 25675642784,
     "UD-Q8_K_XL": 35528652704
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.3,
      "output": 2.4,
      "tps": 66,
      "ttftMs": 1123,
      "context": 262144
     },
     {
      "name": "DeepInfra",
      "input": 0.26,
      "output": 2.6,
      "tps": 68,
      "ttftMs": 318,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "qwen2.5-coder-7b": {
   "name": "Qwen2.5-Coder 7B",
   "repo": "Qwen/Qwen2.5-Coder-7B-Instruct",
   "lab": "qwen",
   "params": 7.6,
   "released": "2024-09-17",
   "license": "apache-2.0",
   "hf": {
    "likes": 858,
    "downloads": 1393797
   },
   "ollama": {
    "name": "qwen2.5-coder",
    "tag": "7b",
    "pulls": 23252674,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b"
    ],
    "bytes": 4683074048,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-Coder-7B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-Coder-7B-Instruct-GGUF",
    "files": {
     "Q2_K": 3015940032,
     "Q3_K_M": 3808391104,
     "Q4_0": 4431390720,
     "Q4_K_M": 4683073536,
     "Q5_0": 5315176576,
     "Q5_K_M": 5444831232,
     "Q6_K": 6254198784,
     "Q8_0": 8098525184
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.01,
      "output": 0.03,
      "tps": 141,
      "ttftMs": 317,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-Coder-7B-Instruct-GGUF",
     "kv": "match",
     "ours": 57344,
     "theirs": 57344
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.1
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2409.12186",
      "title": "Qwen2.5-Coder Technical Report",
      "date": "2024-09-18"
     },
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ]
   }
  },
  "qwen2.5-32b": {
   "name": "Qwen2.5 32B",
   "repo": "Qwen/Qwen2.5-32B-Instruct",
   "lab": "qwen",
   "params": 32.8,
   "released": "2024-09-17",
   "license": "apache-2.0",
   "hf": {
    "likes": 375,
    "downloads": 965420
   },
   "ollama": {
    "name": "qwen2.5",
    "tag": "32b",
    "pulls": 44488258,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b",
     "72b"
    ],
    "bytes": 19851336288,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-32B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-Coder-32B-Instruct-GGUF",
    "files": {
     "Q2_K": 12313098432,
     "Q3_K_M": 15935047872,
     "Q4_0": 18640230592,
     "Q4_K_M": 19851335872,
     "Q5_0": 22638254272,
     "Q5_K_M": 23262156992,
     "Q6_K": 26886154432,
     "Q8_0": 34820884672
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-Coder-32B-Instruct-GGUF",
     "kv": "match",
     "ours": 262144,
     "theirs": 262144
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ],
    "training": {
     "name": "Qwen2.5-32B",
     "flop": 3.51e+24,
     "tokens": 18000000000000,
     "confidence": "Confident"
    }
   }
  },
  "qwen2.5-coder-14b": {
   "name": "Qwen2.5-Coder 14B",
   "repo": "Qwen/Qwen2.5-Coder-14B-Instruct",
   "lab": "qwen",
   "params": 14.8,
   "released": "2024-11-06",
   "license": "apache-2.0",
   "hf": {
    "likes": 210,
    "downloads": 1974442
   },
   "ollama": {
    "name": "qwen2.5-coder",
    "tag": "14b",
    "pulls": 23252674,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b"
    ],
    "bytes": 8988110784,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-Coder-14B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-Coder-14B-Instruct-GGUF",
    "files": {
     "Q2_K": 5770497408,
     "Q3_K_M": 7339203968,
     "Q4_0": 8517725568,
     "Q4_K_M": 8988110272,
     "Q5_0": 10266553792,
     "Q5_K_M": 10508873152,
     "Q6_K": 12124683712,
     "Q8_0": 15701597632
    }
   },
   "eci": {
    "score": 116,
    "name": "Qwen2.5-Coder-14B"
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-Coder-14B-Instruct-GGUF",
     "kv": "match",
     "ours": 196608,
     "theirs": 196608
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2409.12186",
      "title": "Qwen2.5-Coder Technical Report",
      "date": "2024-09-18"
     },
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ]
   }
  },
  "qwen3.5-35b-a3b": {
   "name": "Qwen3.5 35B-A3B",
   "repo": "Qwen/Qwen3.5-35B-A3B",
   "lab": "qwen",
   "params": 36,
   "released": "2026-02-24",
   "license": "apache-2.0",
   "hf": {
    "likes": 1550,
    "downloads": 1691828
   },
   "ollama": {
    "name": "qwen3.5",
    "tag": "35b",
    "pulls": 24161275,
    "sizes": [
     "0.8b",
     "2b",
     "4b",
     "9b",
     "27b",
     "35b",
     "122b"
    ],
    "bytes": 21166758176,
    "projector": 902822400,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3.5-35B-A3B",
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.5-35B-A3B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto --extra-index-url https://wheels.vllm.ai/nightly",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Qwen3.5-35B-A3B-OptiQ-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.5-35B-A3B-GGUF",
    "files": {
     "BF16": 69376637824,
     "MXFP4_MOE": 21587638912,
     "Q3_K_M": 16356375168,
     "Q3_K_S": 15265856128,
     "Q4_K_M": 22016023168,
     "Q4_K_S": 20673845888,
     "Q5_K_M": 26249607808,
     "Q5_K_S": 24823544448,
     "Q6_K": 28852861568,
     "Q8_0": 36903139968,
     "UD-IQ2_M": 11391613568,
     "UD-IQ2_XXS": 10656955008,
     "UD-IQ3_S": 13583383168,
     "UD-IQ3_XXS": 13080066688,
     "UD-IQ4_NL": 17821719168,
     "UD-IQ4_XS": 17486174848,
     "UD-Q2_K_XL": 12156754560,
     "UD-Q3_K_XL": 16601176704,
     "UD-Q4_K_L": 20205632160,
     "UD-Q4_K_XL": 22241950336,
     "UD-Q5_K_XL": 26385922688,
     "UD-Q6_K_S": 28515105440,
     "UD-Q6_K_XL": 32071842432,
     "UD-Q8_K_XL": 48688560768
    }
   },
   "eci": {
    "score": 143,
    "name": "Qwen3.5-35B-A3B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.14,
      "output": 1,
      "tps": 19,
      "ttftMs": 630,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.25,
      "output": 2,
      "tps": 67,
      "ttftMs": 1072,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "qwen3-30b-a3b": {
   "name": "Qwen3 30B-A3B",
   "repo": "Qwen/Qwen3-30B-A3B",
   "lab": "qwen",
   "params": 30.5,
   "released": "2025-04-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 980,
    "downloads": 1040763
   },
   "ollama": {
    "name": "qwen3",
    "tag": "30b",
    "pulls": 42279328,
    "sizes": [
     "0.6b",
     "1.7b",
     "4b",
     "8b",
     "14b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 18556685856,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3MoeForCausalLM",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3-30B-A3B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "Qwen/Qwen3-30B-A3B-MLX-bf16"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen3-30B-A3B-GGUF",
    "files": {
     "Q4_K_M": 18556685824,
     "Q5_0": 21080509952,
     "Q5_K_M": 21725580800,
     "Q6_K": 25092531712,
     "Q8_0": 32483931648
    }
   },
   "eci": {
    "score": 136,
    "name": "Qwen3-30B-A3B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.12,
      "output": 0.5,
      "tps": 150,
      "ttftMs": 138,
      "context": 40960
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen3-30B-A3B-GGUF",
     "kv": "match",
     "ours": 98304,
     "theirs": 98304
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "cutoff": "2025-03-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Qwen3-30B-A3B",
     "flop": 6.48e+23,
     "confidence": "Likely"
    }
   }
  },
  "qwen2.5-14b": {
   "name": "Qwen2.5 14B",
   "repo": "Qwen/Qwen2.5-14B-Instruct",
   "lab": "qwen",
   "params": 14.8,
   "released": "2024-09-16",
   "license": "apache-2.0",
   "hf": {
    "likes": 380,
    "downloads": 768999
   },
   "ollama": {
    "name": "qwen2.5",
    "tag": "14b",
    "pulls": 44488258,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b",
     "72b"
    ],
    "bytes": 8988110688,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-14B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-Coder-14B-Instruct-GGUF",
    "files": {
     "Q2_K": 5770497408,
     "Q3_K_M": 7339203968,
     "Q4_0": 8517725568,
     "Q4_K_M": 8988110272,
     "Q5_0": 10266553792,
     "Q5_K_M": 10508873152,
     "Q6_K": 12124683712,
     "Q8_0": 15701597632
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-Coder-14B-Instruct-GGUF",
     "kv": "match",
     "ours": 196608,
     "theirs": 196608
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ],
    "training": {
     "name": "Qwen2.5-14B",
     "flop": 1.58760000000001e+24,
     "confidence": "Confident"
    }
   }
  },
  "qwen2.5-coder-32b": {
   "name": "Qwen2.5-Coder 32B",
   "repo": "Qwen/Qwen2.5-Coder-32B-Instruct",
   "lab": "qwen",
   "params": 32.8,
   "released": "2024-11-06",
   "license": "apache-2.0",
   "hf": {
    "likes": 2203,
    "downloads": 532496
   },
   "ollama": {
    "name": "qwen2.5-coder",
    "tag": "32b",
    "pulls": 23252674,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b"
    ],
    "bytes": 19851336384,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-Coder-32B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-Coder-32B-Instruct-GGUF",
    "files": {
     "Q2_K": 12313098432,
     "Q3_K_M": 15935047872,
     "Q4_0": 18640230592,
     "Q4_K_M": 19851335872,
     "Q5_0": 22638254272,
     "Q5_K_M": 23262156992,
     "Q6_K": 26886154432,
     "Q8_0": 34820884672
    }
   },
   "eci": {
    "score": 119,
    "name": "Qwen2.5-Coder-32B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.06,
      "output": 0.2,
      "tps": 47,
      "ttftMs": 384,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-Coder-32B-Instruct-GGUF",
     "kv": "match",
     "ours": 262144,
     "theirs": 262144
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2409.12186",
      "title": "Qwen2.5-Coder Technical Report",
      "date": "2024-09-18"
     },
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ],
    "cutoff": "2024-06-30",
    "cutoffFrom": "openrouter"
   }
  },
  "kimi-k2.7-code": {
   "name": "Kimi K2.7 Code",
   "repo": "moonshotai/Kimi-K2.7-Code",
   "lab": "moonshotai",
   "params": 1026.9,
   "released": "2026-06-11",
   "license": "other",
   "licenseName": "modified-mit",
   "hf": {
    "likes": 1428,
    "downloads": 79127
   },
   "modelscope": "moonshotai/Kimi-K2.7-Code",
   "engines": {
    "arch": "KimiK25ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/moonshotai/Kimi-K2.7-Code",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Kimi-K2.7-Code-mlx-DQ3_K_M-q8"
   },
   "ggufFiles": {
    "repo": "DevQuasar/moonshotai.Kimi-K2.7-Code-GGUF",
    "files": {
     "IQ2_XS": 298571046624,
     "Q2_K": 372863389408,
     "Q3_K_M": 489088545312,
     "Q4_K_M": 620557904448,
     "Q6_K": 842572859328
    }
   },
   "eci": {
    "score": 150,
    "name": "Kimi K2.7 Code"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.68,
      "output": 3.4,
      "tps": 7,
      "ttftMs": 1198,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.95,
      "output": 4,
      "tps": 37,
      "ttftMs": 1527,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    }
   }
  },
  "kimi-k2.5": {
   "name": "Kimi K2.5",
   "repo": "moonshotai/Kimi-K2.5",
   "lab": "moonshotai",
   "params": 1026.9,
   "released": "2026-01-01",
   "license": "other",
   "licenseName": "modified-mit",
   "hf": {
    "likes": 2898,
    "downloads": 407890
   },
   "modelscope": "moonshotai/Kimi-K2.5",
   "engines": {
    "arch": "KimiK25ForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/moonshotai/Kimi-K2.5",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Kimi-K2.5"
   },
   "ggufFiles": {
    "repo": "unsloth/Kimi-K2.5-GGUF",
    "files": {
     "BF16": 2053155814752,
     "IQ4_NL": 579064700704,
     "IQ4_XS": 547174473344,
     "Q2_K": 373777038496,
     "Q2_K_L": 374052289696,
     "Q3_K_M": 489771716096,
     "Q3_K_S": 443155058112,
     "Q4_0": 581169684384,
     "Q4_1": 642918555392,
     "Q4_K_M": 621245226816,
     "Q4_K_S": 583297376128,
     "Q5_K_M": 728735735936,
     "Q5_K_S": 707006373920,
     "Q6_K": 842909135232,
     "Q8_0": 1091053888000,
     "UD-IQ1_M": 300581903456,
     "UD-IQ1_S": 275914841088,
     "UD-IQ2_M": 345247374432,
     "UD-IQ2_XXS": 326739713088,
     "UD-IQ3_XXS": 414812757344,
     "UD-Q2_K_XL": 374764330144,
     "UD-Q3_K_XL": 490447478272,
     "UD-Q4_K_XL": 622005231424,
     "UD-Q5_K_XL": 731286446240,
     "UD-Q6_K_XL": 877644833216,
     "UD-Q8_K_XL": 1189741274336,
     "UD-TQ1_0": 239537642336
    }
   },
   "eci": {
    "score": 148,
    "name": "Kimi K2.5"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.45,
      "output": 2.25,
      "tps": 10,
      "ttftMs": 1408,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.6,
      "output": 3,
      "tps": 70,
      "ttftMs": 1206,
      "context": 262144
     }
    ]
   },
   "verified": {
    "inferencex": {
     "model": "Kimi-K2.5",
     "runs": [
      {
       "id": "439001",
       "day": "2026-08-07",
       "gpu": "b200",
       "gpus": 4,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 139.81,
       "kvGiB": 17.2,
       "kvTokens": 525568,
       "utilization": 0.9,
       "tps": 153.9,
       "ttft": 0.191,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/31147925932/attempts/1"
      },
      {
       "id": "439014",
       "day": "2026-08-07",
       "gpu": "b200",
       "gpus": 8,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 71.3,
       "kvGiB": 85.83,
       "kvTokens": 2622816,
       "utilization": 0.9,
       "tps": 170.6,
       "ttft": 0.164,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/31147925932/attempts/1"
      },
      {
       "id": "439129",
       "day": "2026-08-07",
       "gpu": "b300",
       "gpus": 4,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 139.81,
       "kvGiB": 97.53,
       "kvTokens": 2980448,
       "utilization": 0.9,
       "tps": 154.2,
       "ttft": 0.168,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/31148296509/attempts/1"
      },
      {
       "id": "439123",
       "day": "2026-08-07",
       "gpu": "b300",
       "gpus": 8,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 71.3,
       "kvGiB": 165.69,
       "kvTokens": 5063456,
       "utilization": 0.9,
       "tps": 173.3,
       "ttft": 0.152,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/31148296509/attempts/1"
      },
      {
       "id": "438158",
       "day": "2026-07-30",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "vllm",
       "format": "mxfp4",
       "version": "nightly",
       "weightsGiB": 132.48,
       "kvGiB": 99.13,
       "kvTokens": 3026400,
       "utilization": 0.85,
       "tps": 114.8,
       "ttft": 0.239,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/29953041481/attempts/1"
      },
      {
       "id": "438154",
       "day": "2026-07-30",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "vllm",
       "format": "mxfp4",
       "version": "nightly",
       "weightsGiB": 67.74,
       "kvGiB": 161.8,
       "kvTokens": 4944128,
       "utilization": 0.85,
       "tps": 116.2,
       "ttft": 0.209,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/29953041481/attempts/1"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text",
     "image"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "thinking",
    "papers": [
     {
      "id": "2602.02276",
      "title": "Kimi K2.5: Visual Agentic Intelligence",
      "date": "2026-02-02"
     }
    ],
    "training": {
     "name": "Kimi K2.5",
     "flop": 5.8e+24,
     "hardware": "NVIDIA H800 SXM5",
     "confidence": "Likely"
    }
   }
  },
  "kimi-k2": {
   "name": "Kimi K2",
   "repo": "moonshotai/Kimi-K2-Instruct",
   "lab": "moonshotai",
   "params": 1026.4,
   "released": "2025-07-11",
   "license": "other",
   "licenseName": "modified-mit",
   "hf": {
    "likes": 3008,
    "downloads": 313181
   },
   "modelscope": "moonshotai/Kimi-K2-Instruct",
   "engines": {
    "arch": "DeepseekV3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/moonshotai/Kimi-K2-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Kimi-K2-Instruct-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Kimi-K2-Instruct-GGUF",
    "files": {
     "BF16": 2053155812768,
     "IQ4_NL": 578491487968,
     "IQ4_XS": 546510814816,
     "Q2_K": 373179203680,
     "Q2_K_L": 373454454880,
     "Q3_K_M": 489378373568,
     "Q3_K_S": 442417651616,
     "Q4_0": 580619179872,
     "Q4_1": 642526234336,
     "Q4_K_M": 620781770528,
     "Q4_K_S": 582746871648,
     "Q5_K_M": 728346884160,
     "Q5_K_S": 706560980992,
     "Q6_K": 842634817376,
     "Q8_0": 1091053886208,
     "UD-IQ1_M": 304231648288,
     "UD-IQ1_S": 280113603520,
     "UD-IQ2_M": 347105195200,
     "UD-IQ2_XXS": 328784475200,
     "UD-IQ3_XXS": 416622218560,
     "UD-Q2_K_XL": 381861323872,
     "UD-Q3_K_XL": 452078601632,
     "UD-Q4_K_XL": 587106516288,
     "UD-Q5_K_XL": 730578835520,
     "UD-Q6_K_XL": 879052986816,
     "UD-Q8_K_XL": 1190059777216,
     "UD-TQ1_0": 243604284224
    }
   },
   "eci": {
    "score": 140,
    "name": "Kimi K2 (Jul 2025)"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.57,
      "output": 2.3,
      "tps": 85,
      "ttftMs": 1007,
      "context": 131072
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "card",
     "temperature": 0.6
    },
    "cutoff": "2024-12-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Kimi K2",
     "flop": 2.976e+24,
     "tokens": 15500000000000,
     "hardware": "NVIDIA H800 SXM5",
     "confidence": "Confident"
    }
   }
  },
  "glm-5.2": {
   "name": "GLM-5.2",
   "repo": "zai-org/GLM-5.2",
   "lab": "zai-org",
   "params": 753.3,
   "released": "2026-06-16",
   "license": "mit",
   "hf": {
    "likes": 5197,
    "downloads": 268708
   },
   "modelscope": "ZhipuAI/GLM-5.2",
   "engines": {
    "arch": "GlmMoeDsaForCausalLM",
    "recipe": "https://recipes.vllm.ai/zai-org/GLM-5.2",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/GLM-5.2-DQ4plus-q8"
   },
   "ggufFiles": {
    "repo": "DevQuasar/zai-org.GLM-5.2-GGUF",
    "files": {
     "Q2_K": 274015801760,
     "Q3_K_M": 358734908416,
     "Q4_K_M": 454552364896,
     "Q5_K_M": 533973052256,
     "Q6_K": 618479847264,
     "Q8_0": 800777323808
    }
   },
   "eci": {
    "score": 152,
    "name": "GLM-5.2"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.75,
      "output": 2.4,
      "tps": 15,
      "ttftMs": 585,
      "context": 1048576
     },
     {
      "name": "Novita",
      "input": 1.4,
      "output": 4.4,
      "tps": 63,
      "ttftMs": 1434,
      "context": 1048576
     },
     {
      "name": "Baseten",
      "input": 1.4,
      "output": 4.4,
      "tps": 48,
      "ttftMs": 1417,
      "context": 1048576
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2603.12201",
      "title": "IndexCache: Accelerating Sparse Attention via Cross-Layer Index Reuse",
      "date": "2026-03-12"
     },
     {
      "id": "2602.15763",
      "title": "GLM-5: from Vibe Coding to Agentic Engineering",
      "date": "2026-02-17"
     }
    ]
   }
  },
  "glm-5.1": {
   "name": "GLM-5.1",
   "repo": "zai-org/GLM-5.1",
   "lab": "zai-org",
   "params": 753.9,
   "released": "2026-04-03",
   "license": "mit",
   "hf": {
    "likes": 1851,
    "downloads": 967007
   },
   "modelscope": "ZhipuAI/GLM-5.1",
   "engines": {
    "arch": "GlmMoeDsaForCausalLM",
    "recipe": "https://recipes.vllm.ai/zai-org/GLM-5.1",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/GLM-5.1-DQ4plus-q8"
   },
   "ggufFiles": {
    "repo": "bartowski/zai-org_GLM-5.1-GGUF",
    "files": {
     "IQ1_M": 176020432352,
     "IQ1_S": 158162527552,
     "IQ2_M": 254907209376,
     "IQ2_S": 231381882464,
     "IQ2_XS": 226599413280,
     "IQ2_XXS": 203929724480,
     "IQ3_M": 360261996032,
     "IQ3_XS": 343937043776,
     "IQ3_XXS": 314973771712,
     "IQ4_NL": 426600740992,
     "IQ4_XS": 403395547264,
     "Q2_K": 265814742720,
     "Q2_K_L": 266753325760,
     "Q3_K_L": 358874992128,
     "Q3_K_M": 344630349120,
     "Q3_K_S": 328314834240,
     "Q3_K_XL": 359707627008,
     "Q4_0": 427612092544,
     "Q4_1": 472724474240,
     "Q4_K_L": 460382980416,
     "Q4_K_M": 459676727616,
     "Q4_K_S": 441415416064,
     "Q5_K_M": 538612685280,
     "Q5_K_S": 520080579072,
     "Q6_K": 652470732128,
     "Q8_0": 801344965920
    }
   },
   "eci": {
    "score": 150,
    "name": "GLM-5.1"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 1.05,
      "output": 3.5,
      "tps": 20,
      "ttftMs": 2561,
      "context": 202752
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2602.15763",
      "title": "GLM-5: from Vibe Coding to Agentic Engineering",
      "date": "2026-02-17"
     }
    ]
   }
  },
  "glm-5": {
   "name": "GLM-5",
   "repo": "zai-org/GLM-5",
   "lab": "zai-org",
   "params": 753.9,
   "released": "2026-02-11",
   "license": "mit",
   "hf": {
    "likes": 2141,
    "downloads": 1567043
   },
   "modelscope": "ZhipuAI/GLM-5",
   "engines": {
    "arch": "GlmMoeDsaForCausalLM",
    "recipe": "https://recipes.vllm.ai/zai-org/GLM-5",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "unsloth/GLM-5-GGUF",
    "files": {
     "BF16": 1507979369824,
     "UD-TQ1_0": 176142433184,
     "IQ4_NL": 425923884032,
     "IQ4_XS": 402895582272,
     "MXFP4_MOE": 410557924192,
     "Q2_K": 275953473216,
     "Q2_K_L": 276176500448,
     "Q3_K_M": 360308302304,
     "Q3_K_S": 326276833568,
     "Q4_0": 427145999360,
     "Q4_1": 472704107744,
     "Q4_K_M": 455879275712,
     "Q4_K_S": 428368114688,
     "Q5_K_M": 535169914112,
     "Q5_K_S": 519738348800,
     "Q6_K": 619377928352,
     "Q8_0": 801344964608,
     "UD-IQ1_M": 223855224416,
     "UD-IQ1_S": 203699011168,
     "UD-IQ2_M": 254763378336,
     "UD-IQ2_XXS": 241073170016,
     "UD-IQ3_XXS": 304536467744,
     "UD-Q2_K_XL": 281382790880,
     "UD-Q3_K_XL": 332461357376,
     "UD-Q4_K_XL": 430704800768,
     "UD-Q5_K_XL": 536222946560,
     "UD-Q6_K_XL": 645157970208,
     "UD-Q8_K_XL": 868774627424
    }
   },
   "eci": {
    "score": 146,
    "name": "GLM-5"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.6,
      "output": 2.08,
      "tps": 50,
      "ttftMs": 434,
      "context": 202752
     },
     {
      "name": "Novita",
      "input": 1,
      "output": 3.2,
      "tps": 37,
      "ttftMs": 1601,
      "context": 202800
     }
    ]
   },
   "verified": {
    "inferencex": {
     "model": "GLM-5",
     "runs": [
      {
       "id": "413439",
       "day": "2026-05-19",
       "gpu": "h200",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.12",
       "weightsGiB": 89.24,
       "kvGiB": 28.03,
       "kvTokens": 300416,
       "utilization": 0.85,
       "tps": 60.5,
       "ttft": 0.237,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26118912054/attempts/1"
      },
      {
       "id": "422381",
       "day": "2026-06-12",
       "gpu": "b200",
       "gpus": 4,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 106.43,
       "utilization": 0.9,
       "tps": 84.4,
       "ttft": 0.162,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/27431570825/attempts/3"
      },
      {
       "id": "422396",
       "day": "2026-06-12",
       "gpu": "b200",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "nightly",
       "weightsGiB": 89.33,
       "utilization": 0.85,
       "tps": 77.7,
       "ttft": 0.101,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/27431570825/attempts/3"
      },
      {
       "id": "422385",
       "day": "2026-06-12",
       "gpu": "b200",
       "gpus": 8,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "nightly",
       "weightsGiB": 55.3,
       "utilization": 0.9,
       "tps": 92.2,
       "ttft": 0.15,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/27431570825/attempts/3"
      },
      {
       "id": "415669",
       "day": "2026-05-25",
       "gpu": "b300",
       "gpus": 4,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.12",
       "weightsGiB": 106.35,
       "kvGiB": 132.48,
       "kvTokens": 2575744,
       "utilization": 0.9,
       "tps": 84,
       "ttft": 0.167,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26381101926/attempts/1"
      },
      {
       "id": "411127",
       "day": "2026-05-18",
       "gpu": "b300",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.12",
       "weightsGiB": 89.17,
       "kvGiB": 136.39,
       "kvTokens": 2651904,
       "utilization": 0.85,
       "tps": 75,
       "ttft": 0.101,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26008965342/attempts/1"
      },
      {
       "id": "415672",
       "day": "2026-05-25",
       "gpu": "b300",
       "gpus": 8,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.12",
       "weightsGiB": 55.27,
       "kvGiB": 183.56,
       "kvTokens": 3568960,
       "utilization": 0.9,
       "tps": 92.2,
       "ttft": 0.162,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26381101926/attempts/1"
      },
      {
       "id": "413692",
       "day": "2026-05-20",
       "gpu": "mi325x",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.12",
       "weightsGiB": 89.17,
       "kvGiB": 106.72,
       "kvTokens": 2074880,
       "utilization": 0.8,
       "tps": 34.5,
       "ttft": 0.754,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26130045148/attempts/1"
      },
      {
       "id": "431443",
       "day": "2026-07-02",
       "gpu": "mi355x",
       "gpus": 2,
       "engine": "sglang",
       "format": "mxfp4",
       "version": "v0.5.13",
       "weightsGiB": 199.52,
       "utilization": 0.85,
       "tps": 53.3,
       "ttft": 0.179,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28571158239/attempts/1"
      },
      {
       "id": "431439",
       "day": "2026-07-02",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "sglang",
       "format": "mxfp4",
       "version": "v0.5.13",
       "weightsGiB": 101.93,
       "utilization": 0.85,
       "tps": 62.8,
       "ttft": 0.155,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28571158239/attempts/1"
      },
      {
       "id": "413057",
       "day": "2026-05-19",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.12",
       "weightsGiB": 175.81,
       "kvGiB": 60.8,
       "kvTokens": 1182016,
       "utilization": 0.85,
       "tps": 48.2,
       "ttft": 0.149,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26046385161/attempts/1"
      },
      {
       "id": "95857",
       "day": "2026-03-07",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.8",
       "weightsGiB": 89.58,
       "kvGiB": 151.37,
       "kvTokens": 1622818,
       "utilization": 0.85,
       "tps": 18,
       "ttft": 0.242,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/22792161490/attempts/5"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2602.15763",
      "title": "GLM-5: from Vibe Coding to Agentic Engineering",
      "date": "2026-02-17"
     }
    ],
    "training": {
     "name": "GLM-5",
     "flop": 6.84e+24,
     "hardware": "Huawei Ascend 910C",
     "confidence": "Likely"
    }
   }
  },
  "minimax-m2.5": {
   "name": "MiniMax M2.5",
   "repo": "MiniMaxAI/MiniMax-M2.5",
   "lab": "minimaxai",
   "params": 228.7,
   "released": "2026-02-12",
   "license": "other",
   "licenseName": "modified-mit",
   "hf": {
    "likes": 1529,
    "downloads": 1321309
   },
   "modelscope": "MiniMax/MiniMax-M2.5",
   "engines": {
    "arch": "MiniMaxM2ForCausalLM",
    "recipe": "https://recipes.vllm.ai/MiniMaxAI/MiniMax-M2.5",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/MiniMax-M2.5-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "unsloth/MiniMax-M2.5-GGUF",
    "files": {
     "BF16": 457487025216,
     "IQ4_NL": 128999622208,
     "IQ4_XS": 121899124320,
     "MXFP4_MOE": 123775369568,
     "UD-TQ1_0": 55765943424,
     "Q2_K": 83302682080,
     "Q2_K_L": 83446728128,
     "Q3_K_M": 109272482368,
     "Q3_K_S": 98690597344,
     "Q4_0": 129503725120,
     "Q4_1": 143226840672,
     "Q4_K_M": 138342385216,
     "Q4_K_S": 130033780320,
     "Q5_K_M": 162303936224,
     "Q5_K_S": 157478438592,
     "Q6_K": 187763083968,
     "Q8_0": 243136873280,
     "UD-IQ1_M": 68439344608,
     "UD-IQ1_S": 63202444768,
     "UD-IQ2_M": 78199948736,
     "UD-IQ2_XXS": 74123085280,
     "UD-IQ3_XXS": 93315761632,
     "UD-Q2_K_XL": 85917992416,
     "UD-Q3_K_XL": 101296670304,
     "UD-Q4_K_XL": 131321857632,
     "UD-Q5_K_XL": 161768720096,
     "UD-Q6_K_XL": 194289713856,
     "UD-Q8_K_XL": 261379392480
    }
   },
   "eci": {
    "score": 147,
    "name": "MiniMax-M2.5"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.3,
      "output": 1.2,
      "tps": 45,
      "ttftMs": 1096,
      "context": 204800
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/MiniMax-M2.5-GGUF",
     "kv": "match",
     "ours": 253952,
     "theirs": 253952
    },
    "inferencex": {
     "model": "MiniMax-M2.5",
     "runs": [
      {
       "id": "194740",
       "day": "2026-03-28",
       "gpu": "h100",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.18.0",
       "weightsGiB": 53.78,
       "kvGiB": 13.62,
       "kvTokens": 229472,
       "tps": 97.3,
       "ttft": 0.087,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/23675296196/attempts/3"
      },
      {
       "id": "419559",
       "day": "2026-06-04",
       "gpu": "h100",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 27.06,
       "kvGiB": 38.87,
       "kvTokens": 1313104,
       "utilization": 0.9,
       "tps": 117.3,
       "ttft": 0.096,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "419850",
       "day": "2026-06-05",
       "gpu": "h200",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 53.75,
       "kvGiB": 73.13,
       "kvTokens": 2473760,
       "utilization": 0.95,
       "tps": 134.4,
       "ttft": 0.1,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26986223642/attempts/2"
      },
      {
       "id": "194837",
       "day": "2026-03-28",
       "gpu": "h200",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.18.0",
       "weightsGiB": 27.01,
       "kvGiB": 100.72,
       "kvTokens": 3406688,
       "utilization": 0.95,
       "tps": 125.2,
       "ttft": 0.103,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/23675296196/attempts/3"
      },
      {
       "id": "419542",
       "day": "2026-06-04",
       "gpu": "b200",
       "gpus": 1,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.22.0",
       "weightsGiB": 125.29,
       "kvGiB": 28.64,
       "kvTokens": 242192,
       "utilization": 0.9,
       "tps": 145.2,
       "ttft": 0.051,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "417613",
       "day": "2026-05-31",
       "gpu": "b200",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 107.44,
       "kvGiB": 45.88,
       "kvTokens": 773216,
       "utilization": 0.9,
       "tps": 21.3,
       "ttft": 0.976,
       "conc": 512,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696233215/attempts/1"
      },
      {
       "id": "419568",
       "day": "2026-06-04",
       "gpu": "b200",
       "gpus": 2,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.22.0",
       "weightsGiB": 62.76,
       "kvGiB": 90.63,
       "kvTokens": 1532816,
       "utilization": 0.9,
       "tps": 115.7,
       "ttft": 0.049,
       "conc": 16,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "417624",
       "day": "2026-05-31",
       "gpu": "b200",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 53.86,
       "kvGiB": 99.41,
       "kvTokens": 3362656,
       "utilization": 0.9,
       "tps": 140.5,
       "ttft": 0.047,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696233215/attempts/1"
      },
      {
       "id": "419613",
       "day": "2026-06-04",
       "gpu": "b200",
       "gpus": 4,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.22.0",
       "weightsGiB": 31.49,
       "kvGiB": 121.81,
       "kvTokens": 4120176,
       "utilization": 0.9,
       "tps": 190.7,
       "ttft": 0.038,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "419527",
       "day": "2026-06-04",
       "gpu": "b200",
       "gpus": 8,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.22.0",
       "weightsGiB": 15.87,
       "kvGiB": 137.42,
       "kvTokens": 9296240,
       "utilization": 0.9,
       "tps": 197.9,
       "ttft": 0.033,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "419569",
       "day": "2026-06-04",
       "gpu": "b300",
       "gpus": 1,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.21.0",
       "weightsGiB": 125.29,
       "kvGiB": 109.03,
       "kvTokens": 921968,
       "utilization": 0.9,
       "tps": 145.4,
       "ttft": 0.054,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "411035",
       "day": "2026-05-18",
       "gpu": "b300",
       "gpus": 1,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 214.41,
       "kvGiB": 19.85,
       "kvTokens": 167872,
       "utilization": 0.9,
       "tps": 98.6,
       "ttft": 0.256,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26006186869/attempts/1"
      },
      {
       "id": "419611",
       "day": "2026-06-04",
       "gpu": "b300",
       "gpus": 2,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.21.0",
       "weightsGiB": 62.76,
       "kvGiB": 169.06,
       "kvTokens": 2859248,
       "utilization": 0.9,
       "tps": 59.5,
       "ttft": 0.065,
       "conc": 128,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "411042",
       "day": "2026-05-18",
       "gpu": "b300",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 107.33,
       "kvGiB": 124.43,
       "kvTokens": 2104288,
       "utilization": 0.9,
       "tps": 22.8,
       "ttft": 0.196,
       "conc": 512,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26006186869/attempts/1"
      },
      {
       "id": "419556",
       "day": "2026-06-04",
       "gpu": "b300",
       "gpus": 4,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.21.0",
       "weightsGiB": 31.49,
       "kvGiB": 200.34,
       "kvTokens": 6776480,
       "utilization": 0.9,
       "tps": 165,
       "ttft": 0.04,
       "conc": 8,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "411044",
       "day": "2026-05-18",
       "gpu": "b300",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 53.81,
       "kvGiB": 178,
       "kvTokens": 6020672,
       "utilization": 0.9,
       "tps": 142.2,
       "ttft": 0.045,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26006186869/attempts/1"
      },
      {
       "id": "419604",
       "day": "2026-06-04",
       "gpu": "b300",
       "gpus": 8,
       "engine": "vllm",
       "format": "nvfp4",
       "version": "v0.21.0",
       "weightsGiB": 15.87,
       "kvGiB": 215.79,
       "kvTokens": 14597872,
       "utilization": 0.9,
       "tps": 198.7,
       "ttft": 0.033,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26980953103/attempts/2"
      },
      {
       "id": "410286",
       "day": "2026-05-18",
       "gpu": "mi300x",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 107.38,
       "kvGiB": 67.86,
       "kvTokens": 573856,
       "utilization": 0.95,
       "tps": 79.7,
       "ttft": 0.133,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/25984514925/attempts/4"
      },
      {
       "id": "410284",
       "day": "2026-05-18",
       "gpu": "mi300x",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.21.0",
       "weightsGiB": 53.85,
       "kvGiB": 121.37,
       "kvTokens": 2052320,
       "utilization": 0.95,
       "tps": 95.7,
       "ttft": 0.122,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/25984514925/attempts/4"
      },
      {
       "id": "417043",
       "day": "2026-05-30",
       "gpu": "mi325x",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 107.38,
       "kvGiB": 128.66,
       "kvTokens": 1088000,
       "utilization": 0.95,
       "tps": 83.4,
       "ttft": 0.099,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696258504/attempts/1"
      },
      {
       "id": "194753",
       "day": "2026-03-28",
       "gpu": "mi325x",
       "gpus": 4,
       "engine": "vllm",
       "format": "native",
       "version": "v0.16.0",
       "weightsGiB": 54.96,
       "kvGiB": 179.58,
       "kvTokens": 3036800,
       "utilization": 0.95,
       "tps": 50.7,
       "ttft": 0.103,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/23675296196/attempts/3"
      },
      {
       "id": "417039",
       "day": "2026-05-30",
       "gpu": "mi325x",
       "gpus": 8,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 27,
       "kvGiB": 207.92,
       "kvTokens": 7025984,
       "utilization": 0.95,
       "tps": 104.9,
       "ttft": 0.07,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696258504/attempts/1"
      },
      {
       "id": "420257",
       "day": "2026-06-08",
       "gpu": "mi355x",
       "gpus": 1,
       "engine": "vllm",
       "format": "mxfp4",
       "version": "v0.22.0",
       "weightsGiB": 118.75,
       "kvGiB": 150.74,
       "kvTokens": 1274720,
       "utilization": 0.95,
       "tps": 105.9,
       "ttft": 0.074,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26846427905/attempts/3"
      },
      {
       "id": "417309",
       "day": "2026-05-31",
       "gpu": "mi355x",
       "gpus": 2,
       "engine": "vllm",
       "format": "native",
       "version": "v0.22.0",
       "weightsGiB": 107.38,
       "kvGiB": 158.68,
       "kvTokens": 2683584,
       "utilization": 0.95,
       "tps": 119.3,
       "ttft": 0.082,
       "conc": 2,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26696254552/attempts/1"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 40
    }
   }
  },
  "minimax-m2": {
   "name": "MiniMax M2",
   "repo": "MiniMaxAI/MiniMax-M2",
   "lab": "minimaxai",
   "params": 228.7,
   "released": "2025-10-22",
   "license": "other",
   "licenseName": "modified-mit",
   "hf": {
    "likes": 1514,
    "downloads": 97486
   },
   "modelscope": "MiniMax/MiniMax-M2",
   "engines": {
    "arch": "MiniMaxM2ForCausalLM",
    "recipe": "https://recipes.vllm.ai/MiniMaxAI/MiniMax-M2",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/MiniMax-M2-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "unsloth/MiniMax-M2-GGUF",
    "files": {
     "BF16": 457487025248,
     "IQ4_NL": 128999622144,
     "IQ4_XS": 121899124224,
     "UD-TQ1_0": 56369923264,
     "Q2_K": 83302681984,
     "Q2_K_L": 83446728064,
     "Q3_K_M": 109272482272,
     "Q3_K_S": 98690597248,
     "Q4_0": 129503725056,
     "Q4_1": 143226840576,
     "Q4_K_M": 138342385120,
     "Q4_K_S": 130033780224,
     "Q5_K_M": 162303936128,
     "Q5_K_S": 157478438496,
     "Q6_K": 187763083904,
     "Q8_0": 243136873184,
     "UD-IQ1_M": 68731897216,
     "UD-IQ1_S": 63976293760,
     "UD-IQ2_M": 78077265280,
     "UD-IQ2_XXS": 74000401792,
     "UD-IQ3_XXS": 93608314240,
     "UD-Q2_K_XL": 85757560192,
     "UD-Q3_K_XL": 101457102336,
     "UD-Q4_K_XL": 131623847424,
     "UD-Q5_K_XL": 162089584256,
     "UD-Q6_K_XL": 194289713760,
     "UD-Q8_K_XL": 261379392384
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/MiniMax-M2-GGUF",
     "kv": "match",
     "ours": 253952,
     "theirs": 253952
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "always",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 40
    }
   }
  },
  "mimo-v2.5": {
   "name": "MiMo-V2.5",
   "repo": "XiaomiMiMo/MiMo-V2.5",
   "lab": "xiaomimimo",
   "params": 310.8,
   "released": "2026-04-27",
   "license": "mit",
   "hf": {
    "likes": 433,
    "downloads": 102886
   },
   "engines": {
    "arch": "MiMoV2ForCausalLM",
    "recipe": "https://recipes.vllm.ai/XiaomiMiMo/MiMo-V2.5",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "dawncr0w/MiMo-V2.5-oQ4-MLX"
   },
   "ggufFiles": {
    "repo": "bartowski/MiMo-V2.5-GGUF",
    "files": {
     "IQ1_M": 71949359840,
     "IQ1_S": 64517053152,
     "IQ2_M": 104476744544,
     "IQ2_S": 94678850368,
     "IQ2_XS": 93071874912,
     "IQ2_XXS": 83609525088,
     "IQ3_M": 148339375072,
     "IQ3_XS": 142223555552,
     "IQ3_XXS": 130252848064,
     "IQ4_NL": 175277063200,
     "IQ4_XS": 165699140672,
     "Q2_K": 108937657184,
     "Q2_K_L": 109547961184,
     "Q3_K_L": 147932527584,
     "Q3_K_M": 142240857056,
     "Q3_K_S": 135110015968,
     "Q3_K_XL": 148479360000,
     "Q4_0": 175751019552,
     "Q4_1": 194332245088,
     "Q4_K_L": 189232553024,
     "Q4_K_M": 188768721984,
     "Q4_K_S": 181902359616,
     "Q5_K_M": 221448486048,
     "Q5_K_S": 214255410368,
     "Q6_K": 267556633888,
     "Q8_0": 329279159872
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.14,
      "output": 0.28,
      "tps": 16,
      "ttftMs": 921,
      "context": 262144
     }
    ]
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "ornith-1.0-397b": {
   "name": "Ornith-1.0 397B",
   "repo": "ornith-ai/Ornith-1.0-397B",
   "lab": "ornith-ai",
   "params": 396.8,
   "released": "2026-06-23",
   "license": "mit",
   "hf": {
    "likes": 261,
    "downloads": 183585
   },
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "pipenetwork/Ornith-1.0-397B-mlx-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Ornith-1.0-397B-GGUF",
    "files": {
     "BF16": 792961318784,
     "MXFP4_MOE": 237882931680,
     "Q8_0": 421507365824,
     "UD-IQ1_M": 118934501568,
     "UD-IQ1_S": 112693377216,
     "UD-IQ2_M": 124372056256,
     "UD-IQ2_XXS": 124236101824,
     "UD-IQ3_S": 161889483040,
     "UD-IQ3_XXS": 147595294912,
     "UD-IQ4_NL": 196062656864,
     "UD-IQ4_XS": 192103233856,
     "UD-Q2_K_XL": 132559337664,
     "UD-Q3_K_M": 179978631520,
     "UD-Q3_K_XL": 180224964928,
     "UD-Q4_K_M": 245018573248,
     "UD-Q4_K_S": 229717752224,
     "UD-Q4_K_XL": 245801777600,
     "UD-Q5_K_M": 295294565024,
     "UD-Q5_K_S": 277477161504,
     "UD-Q5_K_XL": 295864990368,
     "UD-Q6_K": 329520085664,
     "UD-Q6_K_XL": 360205613856,
     "UD-Q8_K_XL": 431753100224
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "qwen2.5-coder-3b": {
   "name": "Qwen2.5-Coder 3B",
   "repo": "Qwen/Qwen2.5-Coder-3B-Instruct",
   "lab": "qwen",
   "params": 3.1,
   "released": "2024-11-06",
   "license": "other",
   "licenseName": "qwen-research",
   "hf": {
    "likes": 153,
    "downloads": 430025
   },
   "ollama": {
    "name": "qwen2.5-coder",
    "tag": "3b",
    "pulls": 23252674,
    "sizes": [
     "0.5b",
     "1.5b",
     "3b",
     "7b",
     "14b",
     "32b"
    ],
    "bytes": 1929903072,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen2.5-Coder-3B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen2.5-Coder-3B-Instruct-GGUF",
    "files": {
     "Q2_K": 1376856512,
     "Q3_K_M": 1724178880,
     "Q4_0": 1997879744,
     "Q4_K_M": 2104932800,
     "Q5_0": 2383591872,
     "Q5_K_M": 2438740416,
     "Q6_K": 2793411008,
     "Q8_0": 3616088512
    }
   },
   "eci": {
    "score": 108,
    "name": "Qwen2.5-Coder-3B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.01,
      "output": 0.03,
      "tps": 185,
      "ttftMs": 351,
      "context": 32768
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen2.5-Coder-3B-Instruct-GGUF",
     "kv": "match",
     "ours": 36864,
     "theirs": 36864
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2409.12186",
      "title": "Qwen2.5-Coder Technical Report",
      "date": "2024-09-18"
     },
     {
      "id": "2407.10671",
      "title": "Qwen2 Technical Report",
      "date": "2024-07-15"
     }
    ]
   }
  },
  "qwen3-235b-a22b": {
   "name": "Qwen3 235B-A22B",
   "repo": "Qwen/Qwen3-235B-A22B",
   "lab": "qwen",
   "params": 235.1,
   "released": "2025-04-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 1128,
    "downloads": 351183
   },
   "ollama": {
    "name": "qwen3",
    "tag": "235b",
    "pulls": 42279328,
    "sizes": [
     "0.6b",
     "1.7b",
     "4b",
     "8b",
     "14b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 142154073664,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3MoeForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "Qwen/Qwen3-235B-A22B-MLX-6bit"
   },
   "ggufFiles": {
    "repo": "Qwen/Qwen3-235B-A22B-GGUF",
    "files": {
     "Q4_K_M": 142154074176,
     "Q5_0": 161881426080,
     "Q5_K_M": 166814156992,
     "Q6_K": 193015494944,
     "Q8_0": 249940105792
    }
   },
   "eci": {
    "score": 139,
    "name": "Qwen3-235B-A22B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Nscale",
      "input": 0.2,
      "output": 0.6,
      "tps": 13,
      "ttftMs": 564,
      "context": 32000
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Qwen/Qwen3-235B-A22B-GGUF",
     "kv": "match",
     "ours": 192512,
     "theirs": 192512
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     }
    ],
    "training": {
     "name": "Qwen3-235B-A22B",
     "flop": 4.752e+24,
     "tokens": 36000000000000,
     "confidence": "Likely"
    }
   }
  },
  "qwen3.5-397b-a17b": {
   "name": "Qwen3.5 397B-A17B",
   "repo": "Qwen/Qwen3.5-397B-A17B",
   "lab": "qwen",
   "params": 403.4,
   "released": "2026-02-16",
   "license": "apache-2.0",
   "hf": {
    "likes": 1582,
    "downloads": 946819
   },
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3.5-397B-A17B",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto --extra-index-url https://wheels.vllm.ai/nightly",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3.5-397B-A17B-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3.5-397B-A17B-GGUF",
    "files": {
     "BF16": 792961318816,
     "MXFP4_MOE": 237353302496,
     "Q3_K_M": 177409522016,
     "Q3_K_S": 164323293504,
     "Q4_K_M": 244093630912,
     "Q4_K_S": 227987503520,
     "Q5_K_M": 293664979584,
     "Q5_K_S": 276552219168,
     "Q6_K": 326595345056,
     "Q8_0": 421507365824,
     "UD-IQ1_M": 106819877056,
     "UD-IQ2_M": 123053144288,
     "UD-IQ2_XXS": 114872940736,
     "UD-IQ3_S": 146373474496,
     "UD-IQ3_XXS": 140333676736,
     "UD-IQ4_NL": 193761982784,
     "UD-IQ4_XS": 189735450944,
     "UD-Q3_K_M": 177409522016,
     "UD-Q3_K_S": 164323293504,
     "UD-Q3_K_XL": 178739034432,
     "UD-Q4_K_M": 244093630912,
     "UD-Q4_K_S": 227987503520,
     "UD-Q4_K_XL": 245272148448,
     "UD-Q5_K_M": 293664979584,
     "UD-Q5_K_S": 276552219168,
     "UD-Q5_K_XL": 294865599104,
     "UD-Q6_K": 326595345056,
     "UD-Q6_K_XL": 362328980288,
     "UD-Q8_K_XL": 427726568384
    }
   },
   "eci": {
    "score": 147,
    "name": "Qwen3.5 397B-A17B"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.45,
      "output": 3,
      "tps": 50,
      "ttftMs": 219,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.6,
      "output": 3.6,
      "tps": 61,
      "ttftMs": 1289,
      "context": 262144
     },
     {
      "name": "OVHcloud",
      "input": 0.71,
      "output": 4.25,
      "tps": 81,
      "ttftMs": 810,
      "context": 262144
     }
    ]
   },
   "verified": {
    "inferencex": {
     "model": "Qwen-3.5-397B-A17B",
     "runs": [
      {
       "id": "441882",
       "day": "2026-09-13",
       "gpu": "h100",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.14",
       "weightsGiB": 46.94,
       "utilization": 0.8,
       "tps": 152.7,
       "ttft": 0.544,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/34776525730/attempts/1"
      },
      {
       "id": "432219",
       "day": "2026-07-04",
       "gpu": "h200",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.14",
       "weightsGiB": 46.94,
       "utilization": 0.8,
       "tps": 116.7,
       "ttft": 0.302,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28719990565/attempts/1"
      },
      {
       "id": "445446",
       "day": "2026-10-20",
       "gpu": "b200",
       "gpus": 2,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.21",
       "tps": 167.9,
       "ttft": 0.214,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/37713284788/attempts/1"
      },
      {
       "id": "442513",
       "day": "2026-09-18",
       "gpu": "b200",
       "gpus": 4,
       "engine": "sglang",
       "format": "fp8",
       "version": "nightly",
       "weightsGiB": 93.35,
       "tps": 198.9,
       "ttft": 0.184,
       "conc": 2,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/35317697106/attempts/1"
      },
      {
       "id": "445449",
       "day": "2026-10-20",
       "gpu": "b200",
       "gpus": 4,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.21",
       "tps": 203.4,
       "ttft": 0.159,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/37713284788/attempts/1"
      },
      {
       "id": "432495",
       "day": "2026-07-04",
       "gpu": "b200",
       "gpus": 8,
       "engine": "sglang",
       "format": "bf16",
       "version": "v0.5.14",
       "weightsGiB": 92.73,
       "utilization": 0.82,
       "tps": 168.4,
       "ttft": 0.248,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/28719974515/attempts/1"
      },
      {
       "id": "442518",
       "day": "2026-09-18",
       "gpu": "b200",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "nightly",
       "weightsGiB": 46.94,
       "tps": 226.1,
       "ttft": 0.126,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/35317697106/attempts/1"
      },
      {
       "id": "439347",
       "day": "2026-08-10",
       "gpu": "b300",
       "gpus": 2,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.14",
       "weightsGiB": 107.46,
       "utilization": 0.8,
       "tps": 154.3,
       "ttft": 0.237,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30506346629/attempts/1"
      },
      {
       "id": "445510",
       "day": "2026-10-20",
       "gpu": "b300",
       "gpus": 4,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.21",
       "tps": 171.2,
       "ttft": 0.193,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/38572671250/attempts/1"
      },
      {
       "id": "439362",
       "day": "2026-08-10",
       "gpu": "b300",
       "gpus": 4,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.14",
       "weightsGiB": 53.91,
       "utilization": 0.8,
       "tps": 183.5,
       "ttft": 0.215,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30506346629/attempts/1"
      },
      {
       "id": "412192",
       "day": "2026-05-18",
       "gpu": "b300",
       "gpus": 4,
       "engine": "sglang",
       "format": "bf16",
       "version": "v0.5.12",
       "weightsGiB": 185.06,
       "kvGiB": 26.7,
       "kvTokens": 1865728,
       "utilization": 0.82,
       "tps": 142.1,
       "ttft": 0.164,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26015573402/attempts/1"
      },
      {
       "id": "412212",
       "day": "2026-05-18",
       "gpu": "b300",
       "gpus": 8,
       "engine": "sglang",
       "format": "bf16",
       "version": "v0.5.12",
       "weightsGiB": 92.73,
       "kvGiB": 121.88,
       "kvTokens": 8520576,
       "utilization": 0.82,
       "tps": 170.9,
       "ttft": 0.149,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26015573402/attempts/1"
      },
      {
       "id": "410909",
       "day": "2026-05-18",
       "gpu": "mi300x",
       "gpus": 8,
       "engine": "sglang",
       "format": "bf16",
       "version": "v0.5.12",
       "weightsGiB": 92.78,
       "kvGiB": 22.56,
       "kvTokens": 1576910,
       "utilization": 0.75,
       "tps": 96.2,
       "ttft": 0.317,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26008642156/attempts/1"
      },
      {
       "id": "410219",
       "day": "2026-05-17",
       "gpu": "mi300x",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.12",
       "weightsGiB": 47.08,
       "kvGiB": 46.62,
       "kvTokens": 3258806,
       "utilization": 0.75,
       "tps": 71.8,
       "ttft": 0.458,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/25984517560/attempts/4"
      },
      {
       "id": "409964",
       "day": "2026-05-17",
       "gpu": "mi325x",
       "gpus": 8,
       "engine": "sglang",
       "format": "bf16",
       "version": "v0.5.12",
       "weightsGiB": 92.78,
       "kvGiB": 47.78,
       "kvTokens": 3340249,
       "utilization": 0.75,
       "tps": 99,
       "ttft": 0.241,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/25984518223/attempts/1"
      },
      {
       "id": "446001",
       "day": "2026-10-22",
       "gpu": "mi325x",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.22",
       "tps": 49.1,
       "ttft": 0.631,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/39261842343/attempts/1"
      },
      {
       "id": "443526",
       "day": "2026-09-29",
       "gpu": "mi355x",
       "gpus": 2,
       "engine": "sglang",
       "format": "mxfp4",
       "version": "v0.5.20",
       "tps": 126.8,
       "ttft": 0.278,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/36507377618/attempts/1"
      },
      {
       "id": "443533",
       "day": "2026-09-29",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "sglang",
       "format": "mxfp4",
       "version": "v0.5.20",
       "tps": 161.3,
       "ttft": 0.233,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/36507377618/attempts/1"
      },
      {
       "id": "443150",
       "day": "2026-09-25",
       "gpu": "mi355x",
       "gpus": 4,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.20",
       "tps": 114.3,
       "ttft": 0.373,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/36086631310/attempts/1"
      },
      {
       "id": "412827",
       "day": "2026-05-19",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "sglang",
       "format": "bf16",
       "version": "v0.5.12",
       "weightsGiB": 92.78,
       "kvGiB": 67.7,
       "kvTokens": 4732807,
       "utilization": 0.8,
       "tps": 102.7,
       "ttft": 0.236,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/26046398694/attempts/1"
      },
      {
       "id": "94937",
       "day": "2026-02-20",
       "gpu": "mi355x",
       "gpus": 8,
       "engine": "sglang",
       "format": "fp8",
       "version": "v0.5.8",
       "weightsGiB": 47.17,
       "kvGiB": 94.5,
       "kvTokens": 6606294,
       "utilization": 0.8,
       "tps": 44.4,
       "ttft": 0.151,
       "conc": 4,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/22208540106/attempts/2"
      },
      {
       "id": "438085",
       "day": "2026-07-30",
       "gpu": "rtx-pro-6000",
       "gpus": 4,
       "engine": "sglang",
       "format": "nvfp4",
       "version": "v0.5.16",
       "weightsGiB": 56.12,
       "utilization": 0.7,
       "tps": 78.3,
       "ttft": 0.804,
       "conc": 1,
       "url": "https://github.com/SemiAnalysisAI/InferenceX/actions/runs/30252251058/attempts/1"
      }
     ]
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "gemma-4-e4b": {
   "name": "Gemma 4 E4B",
   "repo": "google/gemma-4-E4B-it",
   "lab": "google",
   "params": 8,
   "released": "2026-03-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 1822,
    "downloads": 4128512
   },
   "ollama": {
    "name": "gemma4",
    "tag": "e4b",
    "pulls": 28427032,
    "sizes": [
     "e2b",
     "e4b",
     "12b",
     "26b",
     "31b"
    ],
    "bytes": 5493439296,
    "projector": 991552256,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Gemma4ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/gemma-4-E4B-it-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/gemma-4-E4B-it-GGUF",
    "files": {
     "BF16": 15053097856,
     "IQ4_NL": 4835839104,
     "IQ4_XS": 4715416704,
     "Q3_K_M": 4058137728,
     "Q3_K_S": 3862379648,
     "Q4_0": 4836002944,
     "Q4_1": 5074390144,
     "Q4_K_M": 4977171584,
     "Q4_K_S": 4844850304,
     "Q5_K_M": 5481798784,
     "Q5_K_S": 5404855424,
     "Q6_K": 7074929792,
     "Q8_0": 8192953472,
     "UD-IQ2_M": 3545083008,
     "UD-IQ3_XXS": 3717115008,
     "UD-Q2_K_XL": 3757419648,
     "UD-Q3_K_XL": 4588440704,
     "UD-Q4_K_XL": 5126306944,
     "UD-Q5_K_XL": 6656154752,
     "UD-Q6_K_XL": 7457762432,
     "UD-Q8_K_XL": 8711507072
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 64
    },
    "papers": [
     {
      "id": "2607.02770",
      "title": "Gemma 4 Technical Report",
      "date": "2026-07-02"
     }
    ],
    "training": {
     "name": "Gemma 4 E4B",
     "hardware": "Google TPU v6e Trillium",
     "chips": 6144,
     "confidence": "Confident"
    }
   }
  },
  "gemma-4-e2b": {
   "name": "Gemma 4 E2B",
   "repo": "google/gemma-4-E2B-it",
   "lab": "google",
   "params": 5.1,
   "released": "2026-03-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 1100,
    "downloads": 3277213
   },
   "ollama": {
    "name": "gemma4",
    "tag": "e2b",
    "pulls": 28427032,
    "sizes": [
     "e2b",
     "e4b",
     "12b",
     "26b",
     "31b"
    ],
    "bytes": 3502493472,
    "projector": 986833664,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Gemma4ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/gemma-4-E2B-it-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/gemma-4-E2B-it-GGUF",
    "files": {
     "BF16": 9311305568,
     "IQ4_NL": 3041083488,
     "IQ4_XS": 2983944288,
     "Q3_K_M": 2536786016,
     "Q3_K_S": 2445652064,
     "Q4_0": 3041378400,
     "Q4_1": 3154919520,
     "Q4_K_M": 3106738272,
     "Q4_K_S": 3043934304,
     "Q5_K_M": 3356037216,
     "Q5_K_S": 3321151584,
     "Q6_K": 4501721184,
     "Q8_0": 5048352864,
     "UD-IQ2_M": 2290860128,
     "UD-IQ3_XXS": 2372993120,
     "UD-Q2_K_XL": 2403614816,
     "UD-Q3_K_XL": 2923782240,
     "UD-Q4_K_XL": 3184496736,
     "UD-Q5_K_XL": 4294176864,
     "UD-Q6_K_XL": 4710088800,
     "UD-Q8_K_XL": 5282807904
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video",
     "audio"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 64
    },
    "papers": [
     {
      "id": "2607.02770",
      "title": "Gemma 4 Technical Report",
      "date": "2026-07-02"
     }
    ],
    "training": {
     "name": "Gemma 4 E2B",
     "hardware": "Google TPU v6e Trillium",
     "chips": 4096,
     "confidence": "Confident"
    }
   }
  },
  "nvidia-nemotron-3-nano-4b": {
   "name": "Nemotron 3 Nano 4B",
   "repo": "nvidia/NVIDIA-Nemotron-3-Nano-4B-BF16",
   "lab": "nvidia",
   "params": 4,
   "released": "2026-03-07",
   "license": "other",
   "licenseName": "nvidia-nemotron-open-model-license",
   "hf": {
    "likes": 142,
    "downloads": 1882534
   },
   "engines": {
    "arch": "NemotronHForCausalLM",
    "recipe": "https://recipes.vllm.ai/nvidia/NVIDIA-Nemotron-3-Nano-4B-BF16",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install -U \"vllm>=0.15.1\"",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/NVIDIA-Nemotron-3-Nano-4B-BF16"
   },
   "ggufFiles": {
    "repo": "mradermacher/NVIDIA-Nemotron-3-Nano-4B-BF16-GGUF",
    "files": {
     "IQ4_XS": 2445108640,
     "Q2_K": 2237198112,
     "Q3_K_L": 2479943328,
     "Q3_K_M": 2397755040,
     "Q3_K_S": 2288565792,
     "Q4_K_M": 2837077280,
     "Q4_K_S": 2768781472,
     "Q5_K_M": 3092416672,
     "Q5_K_S": 3043388448,
     "Q6_K": 3933673760,
     "Q8_0": 4233682336,
     "F16": 7957650976
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "mradermacher/NVIDIA-Nemotron-3-Nano-4B-BF16-GGUF",
     "kv": "match",
     "ours": 16384,
     "theirs": 16384
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2512.20856",
      "title": "NVIDIA Nemotron 3: Efficient and Open Intelligence",
      "date": "2025-12-24"
     },
     {
      "id": "2512.20848",
      "title": "Nemotron 3 Nano: Open, Efficient Mixture-of-Experts Hybrid Mamba-Transformer Model for Agentic Reasoning",
      "date": "2025-12-23"
     },
     {
      "id": "2511.16664",
      "title": "Nemotron Elastic: Towards Efficient Many-in-One Reasoning LLMs",
      "date": "2025-11-20"
     }
    ]
   }
  },
  "nvidia-nemotron-3.5-lightning-30b-a3b": {
   "name": "Nemotron 3.5 Lightning 30B-A3B",
   "repo": "nvidia/NVIDIA-Nemotron-3.5-Lightning-30B-A3B-BF16",
   "lab": "nvidia",
   "params": 32.9,
   "released": "2026-08-01",
   "license": "other",
   "licenseName": "openmdw-1.1",
   "hf": {
    "likes": 262,
    "downloads": 1149020
   },
   "engines": {
    "arch": "NemotronHForCausalLM",
    "recipe": "https://recipes.vllm.ai/nvidia/NVIDIA-Nemotron-3.5-Lightning-30B-A3B-BF16",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/NVIDIA-Nemotron-3.5-Lightning-30B-A3B-bf16"
   },
   "ggufFiles": {
    "repo": "mradermacher/NVIDIA-Nemotron-3.5-Lightning-30B-A3B-BF16-GGUF",
    "files": {
     "IQ4_XS": 18961218720,
     "Q2_K": 18655808160,
     "Q3_K_L": 21622290336,
     "Q3_K_M": 20680135584,
     "Q3_K_S": 18682994592,
     "Q4_K_M": 25430740128,
     "Q4_K_S": 22835895456,
     "Q5_K_M": 27040755360,
     "Q5_K_S": 24810683040,
     "Q6_K": 34921148832,
     "Q8_0": 35004643488
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "mradermacher/NVIDIA-Nemotron-3.5-Lightning-30B-A3B-BF16-GGUF",
     "kv": "match",
     "ours": 6144,
     "theirs": 6144
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "es",
     "fr",
     "de",
     "it",
     "ja"
    ]
   }
  },
  "minicpm-v-4.7-35b-a3b": {
   "name": "MiniCPM-V-4.7 35B-A3B",
   "repo": "openbmb/MiniCPM-V-4.7-35B-A3B",
   "lab": "openbmb",
   "params": 35.2,
   "released": "2026-10-07",
   "license": "apache-2.0",
   "hf": {
    "likes": 1108,
    "downloads": 458906
   },
   "modelscope": "OpenBMB/MiniCPM-V-4.7-35B-A3B",
   "engines": {
    "arch": "MiniCPMV4_7ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "pgmharikrishnan/MiniCPM-V-4.7-35B-A3B-MLX-Serve-4bit"
   },
   "ggufFiles": {
    "repo": "openbmb/MiniCPM-V-4.7-35B-A3B-gguf",
    "files": {
     "IQ3_M": 15440064448,
     "IQ3_XS": 14483689408,
     "IQ4_NL": 19778776256,
     "IQ4_XS": 18728286400,
     "Q4_0": 19714550688,
     "Q4_1": 21847643040,
     "Q4_K_M": 21166255008,
     "Q4_K_S": 19889400736,
     "Q5_0": 23980735392,
     "Q5_1": 26113827744,
     "Q5_K_M": 24728583072,
     "Q5_K_S": 23980735392,
     "Q6_K": 28513556640,
     "Q8_0": 36902368928
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "lfm2.5-24b-a2b": {
   "name": "LFM2.5 24B-A2B",
   "repo": "LiquidAI/LFM2.5-24B-A2B",
   "lab": "liquidai",
   "params": 24,
   "released": "2026-10-12",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 596,
    "downloads": 31123
   },
   "ollama": {
    "name": "lfm2.5",
    "tag": "24b",
    "pulls": 294561,
    "sizes": [
     "8b",
     "24b"
    ],
    "bytes": 14526258464,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Lfm2MoeForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "LiquidAI/LFM2.5-24B-A2B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "LiquidAI/LFM2.5-24B-A2B-GGUF",
    "files": {
     "BF16": 47962094880,
     "F16": 47962094880,
     "Q4_K_M": 14526258464,
     "Q5_K_M": 17029602592,
     "Q6_K": 19689405728,
     "Q8_0": 25493732640,
     "Q4_0": 13578190880
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "LiquidAI/LFM2.5-24B-A2B-GGUF",
     "kv": "match",
     "ours": 20480,
     "theirs": 20480
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.1,
     "topK": 50,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en",
     "ar",
     "zh",
     "fr",
     "de",
     "ja",
     "ko",
     "es",
     "pt",
     "it",
     "vi",
     "th",
     "id",
     "hi",
     "ru",
     "pl"
    ],
    "papers": [
     {
      "id": "2511.23404",
      "title": "LFM2 Technical Report",
      "date": "2025-11-28"
     }
    ]
   }
  },
  "glm-4.7": {
   "name": "GLM-4.7",
   "repo": "zai-org/GLM-4.7",
   "lab": "zai-org",
   "params": 358.3,
   "released": "2025-12-22",
   "license": "mit",
   "hf": {
    "likes": 2077,
    "downloads": 71310
   },
   "modelscope": "ZhipuAI/GLM-4.7",
   "engines": {
    "arch": "Glm4MoeForCausalLM",
    "recipe": "https://recipes.vllm.ai/zai-org/GLM-4.7",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/GLM-4.7-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/GLM-4.7-GGUF",
    "files": {
     "BF16": 716837146592,
     "UD-TQ1_0": 84494125664,
     "IQ4_NL": 202456345728,
     "IQ4_XS": 191562951712,
     "Q2_K": 131159649152,
     "Q2_K_L": 131341511552,
     "Q3_K_M": 171268787232,
     "Q3_K_S": 155021880320,
     "Q4_0": 203036339328,
     "Q4_1": 224605547648,
     "Q4_K_M": 216455572576,
     "Q4_K_S": 203679902848,
     "Q5_K_M": 254246825248,
     "Q5_K_S": 247003704448,
     "Q6_K": 294371691776,
     "Q8_0": 380966784544,
     "UD-IQ1_M": 107659012992,
     "UD-IQ1_S": 97175341856,
     "UD-IQ2_M": 122440207264,
     "UD-IQ2_XXS": 115912821664,
     "UD-IQ3_XXS": 145120517024,
     "UD-Q2_K_XL": 135199411136,
     "UD-Q3_K_XL": 158740536352,
     "UD-Q4_K_XL": 204564536480,
     "UD-Q5_K_XL": 253606497568,
     "UD-Q6_K_XL": 301101419936,
     "UD-Q8_K_XL": 394832563872
    }
   },
   "eci": {
    "score": 144,
    "name": "GLM-4.7"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.4,
      "output": 1.75,
      "tps": 70,
      "ttftMs": 422,
      "context": 202752
     },
     {
      "name": "Novita",
      "input": 0.6,
      "output": 2.2,
      "tps": 27,
      "ttftMs": 4150,
      "context": 204800
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/GLM-4.7-GGUF",
     "kv": "match",
     "ours": 376832,
     "theirs": 376832
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2508.06471",
      "title": "GLM-4.5: Agentic, Reasoning, and Coding (ARC) Foundation Models",
      "date": "2025-08-08"
     }
    ],
    "training": {
     "name": "GLM-4.7",
     "flop": 4.42e+24,
     "confidence": "Likely"
    }
   }
  },
  "qwen3-vl-8b": {
   "name": "Qwen3-VL 8B",
   "repo": "Qwen/Qwen3-VL-8B-Instruct",
   "lab": "qwen",
   "params": 8.8,
   "released": "2025-10-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 1236,
    "downloads": 6915010
   },
   "ollama": {
    "name": "qwen3-vl",
    "tag": "8b",
    "pulls": 6980607,
    "sizes": [
     "2b",
     "4b",
     "8b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 5028391424,
    "projector": 1162568672,
    "quant": "Q4_K_M"
   },
   "modelscope": "Qwen/Qwen3-VL-8B-Instruct",
   "engines": {
    "arch": "Qwen3VLForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3-VL-8B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3-VL-8B-Instruct-GGUF",
    "files": {
     "BF16": 16388045408,
     "IQ4_NL": 4793625440,
     "IQ4_XS": 4581288800,
     "Q2_K": 3281734496,
     "Q2_K_L": 3427593056,
     "Q3_K_M": 4124162912,
     "Q3_K_S": 3769613152,
     "Q4_0": 4787333984,
     "Q4_1": 5247757152,
     "Q4_K_M": 5027785568,
     "Q4_K_S": 4802014048,
     "Q5_K_M": 5851114336,
     "Q5_K_S": 5720763232,
     "Q6_K": 6725901152,
     "Q8_0": 8709520224,
     "UD-IQ1_M": 2401995616,
     "UD-IQ1_S": 2282064736,
     "UD-IQ2_M": 3116403552,
     "UD-IQ2_XXS": 2608761696,
     "UD-IQ3_XXS": 3410266976,
     "UD-Q2_K_XL": 3501976416,
     "UD-Q3_K_XL": 4313344864,
     "UD-Q4_K_XL": 5148699488,
     "UD-Q5_K_XL": 5884767072,
     "UD-Q6_K_XL": 7490550624,
     "UD-Q8_K_XL": 10824039264
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen3-VL-8B-Instruct-GGUF",
     "kv": "match",
     "ours": 147456,
     "theirs": 147456
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     },
     {
      "id": "2502.13923",
      "title": "Qwen2.5-VL Technical Report",
      "date": "2025-02-19"
     },
     {
      "id": "2409.12191",
      "title": "Qwen2-VL: Enhancing Vision-Language Model's Perception of the World at Any Resolution",
      "date": "2024-09-18"
     }
    ],
    "training": {
     "name": "Qwen3-VL-8B",
     "flop": 1.885190142295392e+24,
     "tokens": 2167000000000,
     "confidence": "Likely"
    }
   }
  },
  "qwen2.5-vl-7b": {
   "name": "Qwen2.5-VL 7B",
   "repo": "Qwen/Qwen2.5-VL-7B-Instruct",
   "lab": "qwen",
   "params": 8.3,
   "released": "2025-01-26",
   "license": "apache-2.0",
   "hf": {
    "likes": 1762,
    "downloads": 5886476
   },
   "ollama": {
    "name": "qwen2.5vl",
    "tag": "7b",
    "pulls": 5728832,
    "sizes": [
     "3b",
     "7b",
     "32b",
     "72b"
    ],
    "bytes": 5969233408,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2_5_VLForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen2.5-VL-7B-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Qwen2.5-VL-7B-Instruct-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen2.5-VL-7B-Instruct-GGUF",
    "files": {
     "BF16": 15237851776,
     "IQ4_NL": 4437812096,
     "IQ4_XS": 4235502464,
     "Q2_K": 3015938944,
     "Q2_K_L": 3143672704,
     "Q3_K_M": 3808390016,
     "Q3_K_S": 3492367232,
     "Q4_0": 4444119936,
     "Q4_1": 4873282432,
     "Q4_K_M": 4683072384,
     "Q4_K_S": 4457767808,
     "Q5_K_M": 5444830080,
     "Q5_K_S": 5315175296,
     "Q6_K": 6254197632,
     "Q8_0": 8098524032,
     "UD-IQ1_M": 2200535936,
     "UD-IQ1_S": 2073762688,
     "UD-IQ2_M": 2856250240,
     "UD-IQ2_XXS": 2398444416,
     "UD-IQ3_XXS": 3167198080,
     "UD-Q2_K_XL": 3242949504,
     "UD-Q3_K_XL": 4002671488,
     "UD-Q4_K_XL": 4785159040,
     "UD-Q5_K_XL": 5461545856,
     "UD-Q6_K_XL": 6959041408,
     "UD-Q8_K_XL": 10192153472
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen2.5-VL-7B-Instruct-GGUF",
     "kv": "match",
     "ours": 57344,
     "theirs": 57344
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.000001,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2409.12191",
      "title": "Qwen2-VL: Enhancing Vision-Language Model's Perception of the World at Any Resolution",
      "date": "2024-09-18"
     },
     {
      "id": "2308.12966",
      "title": "Qwen-VL: A Frontier Large Vision-Language Model with Versatile Abilities",
      "date": "2023-08-24"
     }
    ],
    "training": {
     "name": "Qwen2.5-VL-7B",
     "flop": 9.9408e+23,
     "confidence": "Confident"
    }
   }
  },
  "qwen3-vl-4b": {
   "name": "Qwen3-VL 4B",
   "repo": "Qwen/Qwen3-VL-4B-Instruct",
   "lab": "qwen",
   "params": 4.4,
   "released": "2025-10-11",
   "license": "apache-2.0",
   "hf": {
    "likes": 523,
    "downloads": 3936514
   },
   "ollama": {
    "name": "qwen3-vl",
    "tag": "4b",
    "pulls": 6980607,
    "sizes": [
     "2b",
     "4b",
     "8b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 2497281600,
    "projector": 839325984,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3VLForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3-VL-4B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3-VL-4B-Instruct-GGUF",
    "files": {
     "BF16": 8051286560,
     "IQ4_NL": 2381345056,
     "IQ4_XS": 2270753056,
     "Q2_K": 1669501216,
     "Q2_K_L": 1669501216,
     "Q3_K_M": 2075619616,
     "Q3_K_S": 1886998816,
     "Q4_0": 2375774496,
     "Q4_1": 2596630816,
     "Q4_K_M": 2497282336,
     "Q4_K_S": 2383311136,
     "Q5_K_M": 2889515296,
     "Q5_K_S": 2823713056,
     "Q6_K": 3306262816,
     "Q8_0": 4280406816,
     "UD-IQ1_M": 1143485216,
     "UD-IQ1_S": 1083151136,
     "UD-IQ2_M": 1530403616,
     "UD-IQ2_XXS": 1255346976,
     "UD-IQ3_XXS": 1674378016,
     "UD-Q2_K_XL": 1695725856,
     "UD-Q3_K_XL": 2128386336,
     "UD-Q4_K_XL": 2546342176,
     "UD-Q5_K_XL": 2899222816,
     "UD-Q6_K_XL": 3658224416,
     "UD-Q8_K_XL": 5056701216
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen3-VL-4B-Instruct-GGUF",
     "kv": "match",
     "ours": 147456,
     "theirs": 147456
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     },
     {
      "id": "2502.13923",
      "title": "Qwen2.5-VL Technical Report",
      "date": "2025-02-19"
     },
     {
      "id": "2409.12191",
      "title": "Qwen2-VL: Enhancing Vision-Language Model's Perception of the World at Any Resolution",
      "date": "2024-09-18"
     }
    ],
    "training": {
     "name": "Qwen3-VL-4B",
     "flop": 9.2170048e+23,
     "tokens": 2167000000000,
     "confidence": "Likely"
    }
   }
  },
  "qwen2.5-vl-3b": {
   "name": "Qwen2.5-VL 3B",
   "repo": "Qwen/Qwen2.5-VL-3B-Instruct",
   "lab": "qwen",
   "params": 3.8,
   "released": "2025-01-26",
   "licenseName": "qwen-research",
   "hf": {
    "likes": 742,
    "downloads": 1533770
   },
   "ollama": {
    "name": "qwen2.5vl",
    "tag": "3b",
    "pulls": 5728832,
    "sizes": [
     "3b",
     "7b",
     "32b",
     "72b"
    ],
    "bytes": 3200614720,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2_5_VLForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Qwen2.5-VL-3B-Instruct-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen2.5-VL-3B-Instruct-GGUF",
    "files": {
     "BF16": 6178315328,
     "IQ4_NL": 1825207648,
     "IQ4_XS": 1739093344,
     "Q2_K": 1274754400,
     "Q2_K_L": 1274754400,
     "Q3_K_M": 1590474080,
     "Q3_K_S": 1454355808,
     "Q4_0": 1828484448,
     "Q4_1": 1996256608,
     "Q4_K_M": 1929901408,
     "Q4_K_S": 1834382688,
     "Q5_K_M": 2224813408,
     "Q5_K_S": 2169664864,
     "Q6_K": 2538157408,
     "Q8_0": 3285474656,
     "UD-IQ1_M": 881638752,
     "UD-IQ1_S": 826334560,
     "UD-IQ2_M": 1165401440,
     "UD-IQ2_XXS": 970685792,
     "UD-IQ3_XXS": 1302654304,
     "UD-Q2_K_XL": 1310066016,
     "UD-Q3_K_XL": 1633838432,
     "UD-Q4_K_XL": 1958147424,
     "UD-Q5_K_XL": 2232943968,
     "UD-Q6_K_XL": 2768428384,
     "UD-Q8_K_XL": 3934035296
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen2.5-VL-3B-Instruct-GGUF",
     "kv": "match",
     "ours": 36864,
     "theirs": 36864
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.000001,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2409.12191",
      "title": "Qwen2-VL: Enhancing Vision-Language Model's Perception of the World at Any Resolution",
      "date": "2024-09-18"
     },
     {
      "id": "2308.12966",
      "title": "Qwen-VL: A Frontier Large Vision-Language Model with Versatile Abilities",
      "date": "2023-08-24"
     }
    ],
    "training": {
     "name": "Qwen2.5-VL-3B",
     "flop": 4.0752e+23,
     "confidence": "Confident"
    }
   }
  },
  "qwen2.5-vl-32b": {
   "name": "Qwen2.5-VL 32B",
   "repo": "Qwen/Qwen2.5-VL-32B-Instruct",
   "lab": "qwen",
   "params": 33.5,
   "released": "2025-03-21",
   "license": "apache-2.0",
   "hf": {
    "likes": 510,
    "downloads": 815757
   },
   "ollama": {
    "name": "qwen2.5vl",
    "tag": "32b",
    "pulls": 5728832,
    "sizes": [
     "3b",
     "7b",
     "32b",
     "72b"
    ],
    "bytes": 21159298208,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen2_5_VLForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "bartowski/Qwen_Qwen2.5-VL-32B-Instruct-GGUF",
    "files": {
     "IQ2_M": 11264439456,
     "IQ2_S": 10387567776,
     "IQ2_XS": 9957549216,
     "IQ2_XXS": 9028248736,
     "IQ3_M": 14810121376,
     "IQ3_XS": 13705512096,
     "IQ3_XXS": 12839269536,
     "IQ4_NL": 18682172576,
     "IQ4_XS": 17693152416,
     "Q2_K": 12313097376,
     "Q2_K_L": 13073417376,
     "Q3_K_L": 17247077536,
     "Q3_K_M": 15935046816,
     "Q3_K_S": 14392329376,
     "Q3_K_XL": 17928324256,
     "Q4_0": 18711008416,
     "Q4_1": 20639241376,
     "Q4_K_L": 20429178016,
     "Q4_K_M": 19851334816,
     "Q4_K_S": 18784408736,
     "Q5_K_L": 23742678176,
     "Q5_K_M": 23262155936,
     "Q5_K_S": 22638253216,
     "Q6_K": 26886153376,
     "Q6_K_L": 27263272096,
     "Q8_0": 34820883616,
     "BF16": 65535968320
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/Qwen_Qwen2.5-VL-32B-Instruct-GGUF",
     "kv": "match",
     "ours": 262144,
     "theirs": 262144
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.000001,
     "repetitionPenalty": 1.05
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2502.13923",
      "title": "Qwen2.5-VL Technical Report",
      "date": "2025-02-19"
     }
    ]
   }
  },
  "qwen2-vl-7b": {
   "name": "Qwen2-VL 7B",
   "repo": "Qwen/Qwen2-VL-7B-Instruct",
   "lab": "qwen",
   "params": 8.3,
   "released": "2024-08-28",
   "license": "apache-2.0",
   "hf": {
    "likes": 1297,
    "downloads": 612822
   },
   "engines": {
    "arch": "Qwen2VLForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "bartowski/Qwen2-VL-7B-Instruct-GGUF",
    "files": {
     "IQ2_M": 2780341408,
     "IQ3_M": 3574011040,
     "IQ3_XS": 3346255008,
     "IQ4_NL": 4437812384,
     "IQ4_XS": 4218471584,
     "Q2_K": 3015939232,
     "Q2_K_L": 3548163232,
     "Q3_K_L": 4088458400,
     "Q3_K_M": 3808390304,
     "Q3_K_S": 3492367520,
     "Q3_K_XL": 4565331104,
     "Q4_0": 4444120224,
     "Q4_K_L": 5087562912,
     "Q4_K_M": 4683072672,
     "Q4_K_S": 4457768096,
     "Q5_K_L": 5781195936,
     "Q5_K_M": 5444830368,
     "Q5_K_S": 5315175584,
     "Q6_K": 6254197920,
     "Q6_K_L": 6518181024,
     "Q8_0": 8098524320,
     "F16": 15237852064
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/Qwen2-VL-7B-Instruct-GGUF",
     "kv": "match",
     "ours": 57344,
     "theirs": 57344
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "sampling": {
     "source": "generation_config",
     "temperature": 0.01,
     "topP": 0.001,
     "topK": 1
    },
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2409.12191",
      "title": "Qwen2-VL: Enhancing Vision-Language Model's Perception of the World at Any Resolution",
      "date": "2024-09-18"
     },
     {
      "id": "2308.12966",
      "title": "Qwen-VL: A Frontier Large Vision-Language Model with Versatile Abilities",
      "date": "2023-08-24"
     }
    ],
    "training": {
     "name": "Qwen2-VL-7B",
     "flop": 6.72e+22,
     "confidence": "Confident"
    }
   }
  },
  "glm-4.5-air": {
   "name": "GLM-4.5-Air",
   "repo": "zai-org/GLM-4.5-Air",
   "lab": "zai-org",
   "params": 110.5,
   "released": "2025-07-20",
   "license": "mit",
   "hf": {
    "likes": 649,
    "downloads": 1295413
   },
   "engines": {
    "arch": "Glm4MoeForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/GLM-4.5-Air-MLX-8bit"
   },
   "ggufFiles": {
    "repo": "unsloth/GLM-4.5-Air-GGUF",
    "files": {
     "BF16": 220997406080,
     "Q2_K": 45322103872,
     "Q2_K_L": 45467593792,
     "UD-IQ1_M": 40061520960,
     "UD-IQ1_S": 38503140416,
     "UD-IQ2_M": 44389321792,
     "UD-IQ2_XXS": 42682240064,
     "UD-Q2_K_XL": 47444888640,
     "UD-TQ1_0": 38260919360,
     "IQ4_NL": 62710615296,
     "IQ4_XS": 60480900352,
     "Q3_K_M": 57203694848,
     "Q3_K_S": 52655381792,
     "Q4_0": 62781050112,
     "Q4_1": 69407886592,
     "Q4_K_M": 72975748384,
     "Q4_K_S": 67033386240,
     "Q5_K_M": 83519589632,
     "Q5_K_S": 78417661216,
     "Q6_K": 99007528192,
     "Q8_0": 117456506240,
     "UD-IQ3_XXS": 51445288224,
     "UD-Q3_K_XL": 54785805600,
     "UD-Q4_K_XL": 67721071872,
     "UD-Q5_K_XL": 82845023520,
     "UD-Q6_K_XL": 101557079424,
     "UD-Q8_K_XL": 127740333440
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.13,
      "output": 0.85,
      "tps": 91,
      "ttftMs": 734,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/GLM-4.5-Air-GGUF",
     "kv": "match",
     "ours": 188416,
     "theirs": 188416
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "openrouter",
     "temperature": 0.75
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2508.06471",
      "title": "GLM-4.5: Agentic, Reasoning, and Coding (ARC) Foundation Models",
      "date": "2025-08-08"
     }
    ],
    "cutoff": "2024-12-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "GLM-4.5-Air",
     "flop": 1.656e+24,
     "confidence": "Confident"
    }
   }
  },
  "glm-4.5": {
   "name": "GLM-4.5",
   "repo": "zai-org/GLM-4.5",
   "lab": "zai-org",
   "params": 358.3,
   "released": "2025-07-20",
   "license": "mit",
   "hf": {
    "likes": 1439,
    "downloads": 107191
   },
   "modelscope": "ZhipuAI/GLM-4.5",
   "engines": {
    "arch": "Glm4MoeForCausalLM",
    "recipe": "https://recipes.vllm.ai/zai-org/GLM-4.5",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/GLM-4.5-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/GLM-4.5-GGUF",
    "files": {
     "BF16": 716837146688,
     "UD-TQ1_0": 84336839360,
     "IQ4_NL": 202456345792,
     "IQ4_XS": 191562951808,
     "Q2_K": 131159649248,
     "Q2_K_L": 131341511648,
     "Q3_K_M": 171268787296,
     "Q3_K_S": 155021880416,
     "Q4_0": 203036339424,
     "Q4_1": 224605547712,
     "Q4_K_M": 216455572672,
     "Q4_K_S": 203679902912,
     "Q5_K_M": 254246825344,
     "Q5_K_S": 247003704544,
     "Q6_K": 294371691840,
     "Q8_0": 380966784608,
     "UD-IQ1_M": 107717995520,
     "UD-IQ1_S": 97047546752,
     "UD-IQ2_M": 122440207360,
     "UD-IQ2_XXS": 115912821760,
     "UD-IQ3_XXS": 145181404160,
     "UD-Q2_K_XL": 135199411168,
     "UD-Q3_K_XL": 158742441056,
     "UD-Q4_K_XL": 204407250176,
     "UD-Q5_K_XL": 253121858944,
     "UD-Q6_K_XL": 300232904128,
     "UD-Q8_K_XL": 391470567040
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/GLM-4.5-GGUF",
     "kv": "match",
     "ours": 376832,
     "theirs": 376832
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "openrouter",
     "temperature": 0.75
    },
    "languages": [
     "en",
     "zh"
    ],
    "papers": [
     {
      "id": "2508.06471",
      "title": "GLM-4.5: Agentic, Reasoning, and Coding (ARC) Foundation Models",
      "date": "2025-08-08"
     }
    ],
    "cutoff": "2024-12-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "GLM-4.5",
     "flop": 4.42e+24,
     "tokens": 23100000000000,
     "confidence": "Confident"
    }
   }
  },
  "phi-4": {
   "name": "phi-4",
   "repo": "microsoft/phi-4",
   "lab": "microsoft",
   "params": 14.7,
   "released": "2024-12-11",
   "license": "mit",
   "hf": {
    "likes": 2336,
    "downloads": 341778
   },
   "ollama": {
    "name": "phi4",
    "tag": "14b",
    "pulls": 7784078,
    "sizes": [
     "14b"
    ],
    "bytes": 9053114464,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Phi3ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/phi-4-4bit"
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/phi-4-GGUF",
    "files": {
     "Q2_K": 5547348064,
     "Q3_K_L": 7930155104,
     "Q3_K_M": 7363268704,
     "Q3_K_S": 6504747104,
     "Q4_K_M": 9053114464,
     "Q4_K_S": 8440762464,
     "Q5_K_M": 10604187744,
     "Q5_K_S": 10151579744,
     "Q6_K": 12030251104,
     "Q8_0": 15580500064
    }
   },
   "eci": {
    "score": 131,
    "name": "Phi-4"
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.07,
      "output": 0.14,
      "tps": 96,
      "ttftMs": 412,
      "context": 16384
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "languages": [
     "en"
    ],
    "papers": [
     {
      "id": "2412.08905",
      "title": "Phi-4 Technical Report",
      "date": "2024-12-12"
     }
    ],
    "cutoff": "2024-06",
    "cutoffFrom": "card",
    "training": {
     "name": "Phi-4",
     "flop": 9.3202015e+23,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "chips": 1920,
     "confidence": "Confident"
    }
   }
  },
  "phi-3.5-mini": {
   "name": "Phi-3.5-mini",
   "repo": "microsoft/Phi-3.5-mini-instruct",
   "lab": "microsoft",
   "params": 3.8,
   "released": "2024-08-16",
   "license": "mit",
   "hf": {
    "likes": 1293,
    "downloads": 398496
   },
   "engines": {
    "arch": "Phi3ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "plawanrath/phi-3.5-mini-instruct-q8-mlx-cba"
   },
   "ggufFiles": {
    "repo": "MaziyarPanahi/Phi-3.5-mini-instruct-GGUF",
    "files": {
     "IQ1_M": 917107424,
     "IQ1_S": 841609952,
     "IQ2_XS": 1153037024,
     "IQ3_XS": 1625175776,
     "IQ4_XS": 2059853024,
     "Q2_K": 1416204512,
     "Q3_K_L": 2087597792,
     "Q3_K_M": 1955477216,
     "Q3_K_S": 1681798880,
     "Q4_K_M": 2393232608,
     "Q4_K_S": 2188760288,
     "Q5_K_M": 2815276256,
     "Q5_K_S": 2641474784,
     "Q6_K": 3135853280,
     "Q8_0": 4061222624
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "papers": [
     {
      "id": "2407.13833",
      "title": "Phi-3 Safety Post-Training: Aligning Language Models with a \"Break-Fix\" Cycle",
      "date": "2024-07-18"
     },
     {
      "id": "2404.14219",
      "title": "Phi-3 Technical Report: A Highly Capable Language Model Locally on Your Phone",
      "date": "2024-04-22"
     }
    ],
    "cutoff": "2023-10",
    "cutoffFrom": "card",
    "training": {
     "name": "Phi-3.5-mini",
     "flop": 3.7101154e+22,
     "hardware": "NVIDIA H100 SXM5 80GB",
     "chips": 512,
     "confidence": "Confident"
    }
   }
  },
  "phi-4-mini": {
   "name": "Phi-4-mini",
   "repo": "microsoft/Phi-4-mini-instruct",
   "lab": "microsoft",
   "params": 3.8,
   "released": "2025-02-19",
   "license": "mit",
   "hf": {
    "likes": 878,
    "downloads": 347033
   },
   "ollama": {
    "name": "phi4-mini",
    "tag": "3.8b",
    "pulls": 1606464,
    "sizes": [
     "3.8b"
    ],
    "bytes": 2491874624,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Phi3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/microsoft/Phi-4-mini-instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Phi-4-mini-instruct-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Phi-4-mini-instruct-GGUF",
    "files": {
     "Q2_K": 1682635744,
     "Q2_K_L": 1682635744,
     "Q3_K_M": 2117532640,
     "Q4_K_M": 2491874272,
     "Q5_K_M": 2848127968,
     "Q6_K": 3155622880,
     "BF16": 7680694240,
     "Q8_0": 4084611040
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "languages": [
     "ar",
     "zh",
     "cs",
     "da",
     "nl",
     "en",
     "fi",
     "fr",
     "de",
     "he",
     "hu",
     "it",
     "ja",
     "ko",
     "no",
     "pl",
     "pt",
     "ru",
     "es",
     "sv",
     "th",
     "tr",
     "uk"
    ],
    "papers": [
     {
      "id": "2503.01743",
      "title": "Phi-4-Mini Technical Report: Compact yet Powerful Multimodal Language Models via Mixture-of-LoRAs",
      "date": "2025-03-03"
     }
    ],
    "cutoff": "2024-06",
    "cutoffFrom": "card",
    "training": {
     "name": "Phi-4 Mini",
     "flop": 9.9561596e+22,
     "tokens": 5000000000000,
     "hardware": "NVIDIA A100 SXM4 80 GB",
     "chips": 512,
     "confidence": "Confident"
    }
   }
  },
  "phi-3-mini-128k": {
   "name": "Phi-3-mini-128k",
   "repo": "microsoft/Phi-3-mini-128k-instruct",
   "lab": "microsoft",
   "params": 3.8,
   "released": "2024-04-22",
   "license": "mit",
   "hf": {
    "likes": 1713,
    "downloads": 234248
   },
   "engines": {
    "arch": "Phi3ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "bartowski/Phi-3.1-mini-128k-instruct-GGUF",
    "files": {
     "IQ2_M": 1316395264,
     "IQ2_S": 1215731456,
     "IQ2_XS": 1153036544,
     "IQ3_M": 1855600384,
     "IQ3_XS": 1625175808,
     "IQ3_XXS": 1513002752,
     "IQ4_XS": 2059853056,
     "Q2_K": 1416204544,
     "Q2_K_L": 1512396544,
     "Q3_K_L": 2087597824,
     "Q3_K_M": 1955477248,
     "Q3_K_S": 1681798912,
     "Q3_K_XL": 2173785856,
     "Q4_K_L": 2466338560,
     "Q4_K_M": 2393232640,
     "Q4_K_S": 2188760320,
     "Q5_K_L": 2876069632,
     "Q5_K_M": 2815276288,
     "Q5_K_S": 2641474816,
     "Q6_K": 3135853312,
     "Q6_K_L": 3183564544,
     "Q8_0": 4061222656,
     "F32": 15285056992
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "languages": [
     "en"
    ],
    "cutoff": "2023-10",
    "cutoffFrom": "card"
   }
  },
  "ling-3.1-flash": {
   "name": "Ling-3.1-flash",
   "repo": "inclusionAI/Ling-3.1-flash",
   "lab": "inclusionai",
   "params": 572.1,
   "released": "2026-10-13",
   "license": "mit",
   "hf": {
    "likes": 160,
    "downloads": 6260
   },
   "modelscope": "inclusionAI/Ling-3.1-flash",
   "engines": {
    "arch": "BailingMoeV3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/inclusionAI/Ling-3.1-flash",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "bartowski/Ling-3.1-flash-GGUF",
    "files": {
     "IQ1_M": 145087687008,
     "IQ1_S": 131007719744,
     "IQ2_M": 213027940928,
     "IQ2_S": 188466899360,
     "IQ2_XS": 177383770496,
     "IQ2_XXS": 170789808544,
     "IQ3_M": 297301011232,
     "IQ3_XS": 260391135936,
     "IQ3_XXS": 247367821984,
     "IQ4_NL": 358013561888,
     "IQ4_XS": 317077154752,
     "Q2_K": 219168205376,
     "Q3_K_L": 287996734272,
     "Q3_K_M": 275057306272,
     "Q3_K_S": 261572618944,
     "Q4_0": 326643772320,
     "Q4_1": 360124099616,
     "Q4_K_M": 357969521664,
     "Q4_K_S": 336629689216,
     "Q5_K_M": 436319120672,
     "Q5_K_S": 406057217152,
     "Q6_K": 501582491136,
     "Q6_K_S": 478828391840,
     "Q8_0": 608380104192
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "Novita",
      "input": 0.3,
      "output": 0.9,
      "tps": 88,
      "ttftMs": 922,
      "context": 1000000
     }
    ]
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking"
   }
  },
  "step-5-preview": {
   "name": "Step 5 Preview",
   "repo": "stepfun-ai/Step-5-Preview-BF16",
   "lab": "stepfun-ai",
   "params": 604.3,
   "released": "2026-09-20",
   "license": "other",
   "hf": {
    "likes": 55,
    "downloads": 1214
   },
   "engines": {
    "arch": "Step5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": false,
    "vllmCard": true,
    "sglang": false,
    "mlx": false
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "effort"
   }
  },
  "hy3": {
   "name": "Hy3",
   "repo": "tencent/Hy3",
   "lab": "tencent",
   "params": 298.8,
   "released": "2026-07-02",
   "license": "apache-2.0",
   "hf": {
    "likes": 990,
    "downloads": 1284710
   },
   "modelscope": "Tencent-Hunyuan/Hy3",
   "engines": {
    "arch": "HYV3ForCausalLM",
    "recipe": "https://recipes.vllm.ai/tencent/Hy3",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": false,
    "mlxRepo": "ox-ox/Hy3-295B-Instruct-w2q3exp-AProjQ8-SExpQ8-OutQ8-MTP-mlx"
   },
   "ggufFiles": {
    "repo": "bartowski/Hy3-GGUF",
    "files": {
     "IQ1_M": 71100724800,
     "IQ1_S": 64051148352,
     "IQ2_M": 102091323104,
     "IQ2_S": 92805134016,
     "IQ2_XS": 91060369120,
     "IQ2_XXS": 82113918656,
     "IQ3_M": 143668639584,
     "IQ3_XS": 137437050656,
     "IQ3_XXS": 126089361248,
     "IQ4_NL": 169803872192,
     "IQ4_XS": 160771307456,
     "Q2_K": 106691229376,
     "Q2_K_L": 107174557408,
     "Q3_K_L": 143077766976,
     "Q3_K_M": 137545479968,
     "Q3_K_S": 131274569536,
     "Q3_K_XL": 143510828864,
     "Q4_0": 170321082336,
     "Q4_1": 187795601344,
     "Q4_K_L": 182525556640,
     "Q4_K_M": 182158227360,
     "Q4_K_S": 175458318304,
     "Q5_K_M": 212837857344,
     "Q5_K_S": 206034401344,
     "Q6_K": 257246623936,
     "Q8_0": 317652367776
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.13,
      "output": 0.53,
      "tps": 51,
      "ttftMs": 556,
      "context": 262144
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "bartowski/Hy3-GGUF",
     "kv": "match",
     "ours": 327680,
     "theirs": 327680
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.9,
     "topP": 1
    }
   }
  },
  "ornith-1.5-122b": {
   "name": "Ornith-1.5 122B",
   "repo": "ornith-ai/Ornith-1.5-122B",
   "lab": "ornith-ai",
   "params": 125.1,
   "released": "2026-10-20",
   "license": "mit",
   "hf": {
    "likes": 208,
    "downloads": 162752
   },
   "ollama": {
    "name": "ornith-1.5",
    "tag": "122b",
    "pulls": 447698,
    "sizes": [
     "9b",
     "35b",
     "122b",
     "397b"
    ],
    "bytes": 75843911648,
    "projector": 912263200,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "OsaurusAI/Ornith-1.5-122B-JANGH2"
   },
   "ggufFiles": {
    "repo": "ornith-ai/Ornith-1.5-122B-GGUF",
    "files": {
     "BF16": 249362980832,
     "Q4_K_M": 75843911648,
     "Q5_K_M": 88710135776,
     "Q6_K": 102380498912,
     "Q8_0": 132555710048
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 0.6,
     "topP": 0.95,
     "topK": 20
    }
   }
  },
  "spark-x2.6-4b": {
   "name": "Spark-X2.6 4B",
   "repo": "XHToken/Spark-X2.6-4B",
   "lab": "xhtoken",
   "params": 4.1,
   "released": "2026-10-19",
   "license": "apache-2.0",
   "hf": {
    "likes": 977,
    "downloads": 18866
   },
   "modelscope": "XHToken/Spark-X2.6-4B",
   "engines": {
    "arch": "Spark2_5ForCausalLM",
    "vllm": false,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "abenzerps/Spark-X2.6-4B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "bartowski/Spark-X2.6-4B-GGUF",
    "files": {
     "IQ2_M": 1565852288,
     "IQ3_M": 2233950848,
     "IQ3_XS": 1912128128,
     "IQ3_XXS": 1802396288,
     "IQ4_NL": 2621104768,
     "IQ4_XS": 2338275968,
     "Q2_K": 1610457728,
     "Q3_K_L": 2093662848,
     "Q3_K_M": 1992532608,
     "Q3_K_S": 1903731328,
     "Q4_0": 2412137088,
     "Q4_1": 2641605248,
     "Q4_K_L": 2811732608,
     "Q4_K_M": 2621104768,
     "Q4_K_S": 2461975168,
     "Q5_K_M": 3164766848,
     "Q5_K_S": 2954396288,
     "Q6_K": 3611148928,
     "Q6_K_L": 3780027008,
     "Q6_K_S": 3454968448,
     "Q8_0": 4375022208,
     "BF16": 8229921120
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "effort",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95
    },
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "sage-a1.5": {
   "name": "Sage-A1.5",
   "repo": "InternScience/Sage-A1.5",
   "lab": "internscience",
   "params": 36,
   "released": "2026-10-15",
   "license": "apache-2.0",
   "hf": {
    "likes": 385,
    "downloads": 14049
   },
   "modelscope": "InternScience/Sage-A1.5",
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/Sage-A1.5-OptiQ-4bit"
   },
   "ggufFiles": {
    "repo": "InternScience/Sage-A1.5-Q4_K_M-GGUF",
    "files": {
     "Q4_K_M": 21713463520
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "papers": [
     {
      "id": "2610.28578",
      "title": "Sage-A1.5: From Long-Horizon Execution to Scientific Exploration with Capability Composition",
      "date": "2026-10-20"
     }
    ]
   }
  },
  "mlexpert": {
   "name": "MLExpert",
   "repo": "InternScience/MLExpert",
   "lab": "internscience",
   "params": 34.7,
   "released": "2026-10-01",
   "license": "apache-2.0",
   "hf": {
    "likes": 17,
    "downloads": 3408
   },
   "engines": {
    "arch": "Qwen3_5MoeForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto",
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "bartowski/InternScience_MLExpert-GGUF",
    "files": {
     "IQ2_M": 13233805856,
     "IQ2_S": 11979545120,
     "IQ2_XS": 11265260064,
     "IQ2_XXS": 10793196064,
     "IQ3_M": 18958219808,
     "IQ3_XS": 16318691872,
     "IQ3_XXS": 15581674016,
     "IQ4_NL": 22318512672,
     "IQ4_XS": 19886930464,
     "Q2_K": 13839333920,
     "Q3_K_L": 18267077152,
     "Q3_K_M": 17344330272,
     "Q3_K_S": 16318691872,
     "Q4_0": 19942611488,
     "Q4_1": 21973768736,
     "Q4_K_L": 24113674784,
     "Q4_K_M": 22318512672,
     "Q4_K_S": 20946975264,
     "Q5_K_M": 26984675872,
     "Q5_K_S": 25137084960,
     "Q6_K": 30738577952,
     "Q6_K_L": 32298859040,
     "Q6_K_S": 29373332000,
     "Q8_0": 36914690592,
     "BF16": 69376637344
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "sampling": {
     "source": "generation_config",
     "temperature": 1,
     "topP": 0.95,
     "topK": 20,
     "minP": 0
    },
    "papers": [
     {
      "id": "2610.22344",
      "title": "MLExpert: Towards a Generalist Agentic Model for Autonomous Machine Learning Engineering",
      "date": "2026-10-15"
     }
    ]
   }
  },
  "agents-a1-4b": {
   "name": "Agents-A1 4B",
   "repo": "InternScience/Agents-A1-4B",
   "lab": "internscience",
   "params": 4.5,
   "released": "2026-07-13",
   "license": "apache-2.0",
   "hf": {
    "likes": 110,
    "downloads": 3772
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "uv pip install vllm --torch-backend=auto",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "wcamon/Agents-A1-4B-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "InternScience/Agents-A1-4B-Q8_0-GGUF",
    "files": {
     "Q8_0": 4482404032
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "papers": [
     {
      "id": "2606.30616",
      "title": "Scaling the Horizon, Not the Parameters: Reaching Trillion-Parameter Performance with a 35B Agent",
      "date": "2026-06-29"
     }
    ]
   }
  },
  "ling-3.0-flash-sante": {
   "name": "Ling-3.0-flash-Sante",
   "repo": "inclusionAI/Ling-3.0-flash-Sante",
   "lab": "inclusionai",
   "params": 127.5,
   "released": "2026-10-22",
   "license": "mit",
   "hf": {
    "likes": 83,
    "downloads": 1739
   },
   "modelscope": "inclusionAI/Ling-3.0-flash-Sante",
   "engines": {
    "arch": "BailingMoeV3ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "vllmCard": true,
    "vllmSetup": "pip install uv",
    "sglang": true,
    "mlx": true,
    "mlxRepo": "dicksondickson/Ling-3.0-flash-Sante-oQ4e-mtp-bf16-MLX"
   },
   "ggufFiles": {
    "repo": "bartowski/Ling-3.0-flash-Sante-GGUF",
    "files": {
     "IQ1_M": 33033335104,
     "IQ1_S": 29797756224,
     "IQ2_M": 47052937792,
     "IQ2_S": 42739481152,
     "IQ2_XS": 40337259072,
     "IQ2_XXS": 38425164352,
     "IQ3_M": 69345336096,
     "IQ3_XS": 58563353344,
     "IQ3_XXS": 55669283616,
     "IQ4_NL": 80410434432,
     "IQ4_XS": 71106943744,
     "Q2_K": 49537866304,
     "Q3_K_L": 65077762816,
     "Q3_K_M": 61499497216,
     "Q3_K_S": 58566105856,
     "Q4_0": 72841125632,
     "Q4_1": 80204409728,
     "Q4_K_L": 86614858624,
     "Q4_K_M": 80394181504,
     "Q4_K_S": 75710323456,
     "Q5_K_M": 97617042304,
     "Q5_K_S": 90688576384,
     "Q6_K": 111426788224,
     "Q6_K_S": 106307115904,
     "Q8_0": 135633372864,
     "BF16": 255091083328
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking"
   }
  },
  "minicpm-ocr-1.0": {
   "name": "MiniCPM-OCR-1.0",
   "repo": "openbmb/MiniCPM-OCR-1.0",
   "lab": "openbmb",
   "params": 1.3,
   "released": "2026-10-28",
   "license": "apache-2.0",
   "hf": {
    "likes": 411,
    "downloads": 10393
   },
   "modelscope": "OpenBMB/MiniCPM-OCR-1.0",
   "engines": {
    "arch": "MiniCPMOcrForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": false,
    "mlx": false
   },
   "ggufFiles": {
    "repo": "openbmb/MiniCPM-OCR-1.0-gguf",
    "files": {
     "F16": 1516288352,
     "Q4_0": 501262208,
     "Q4_1": 532363136,
     "Q4_K_M": 529106816,
     "Q4_K_S": 505063296,
     "Q5_0": 563464064,
     "Q5_1": 594564992,
     "Q5_K_M": 577808256,
     "Q5_K_S": 563464064,
     "Q6_K": 629553536,
     "Q8_0": 811598432
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "languages": [
     "en",
     "zh"
    ]
   }
  },
  "wevisone-vl-4b": {
   "name": "WeVisOne-VL 4B",
   "repo": "tencent/WeVisOne-VL-4B",
   "lab": "tencent",
   "params": 4.8,
   "released": "2026-10-22",
   "license": "apache-2.0",
   "hf": {
    "likes": 91,
    "downloads": 8924
   },
   "engines": {
    "arch": "Qwen3VLForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "mradermacher/WeVisOne-VL-4B-GGUF",
    "files": {
     "IQ4_XS": 2495536288,
     "Q2_K": 1799326048,
     "Q3_K_L": 2409308928,
     "Q3_K_M": 2245141248,
     "Q3_K_S": 2056520448,
     "Q4_K_M": 2718715168,
     "Q4_K_S": 2604743968,
     "Q5_K_M": 3159805728,
     "Q5_K_S": 3094003488,
     "Q6_K": 3628464448,
     "Q8_0": 4697731328,
     "F16": 8836828928
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "mradermacher/WeVisOne-VL-4B-GGUF",
     "kv": "match",
     "ours": 147456,
     "theirs": 147456
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20
    },
    "papers": [
     {
      "id": "2610.31329",
      "title": "WeVisOne-VL: Unified Visual Perception from Objects to Pixels",
      "date": "2026-10-22"
     }
    ]
   }
  },
  "granite-4.1-3b": {
   "name": "Granite 4.1 3B",
   "repo": "ibm-granite/granite-4.1-3b",
   "lab": "ibm-granite",
   "params": 3.4,
   "released": "2026-04-06",
   "license": "apache-2.0",
   "hf": {
    "likes": 119,
    "downloads": 549939
   },
   "ollama": {
    "name": "granite4.1",
    "tag": "3b",
    "pulls": 602477,
    "sizes": [
     "3b",
     "8b",
     "30b"
    ],
    "bytes": 2099501664,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "GraniteForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "mlx-community/granite-4.1-3b-4bit"
   },
   "ggufFiles": {
    "repo": "ibm-granite/granite-4.1-3b-GGUF",
    "files": {
     "Q2_K": 1371437664,
     "Q3_K_L": 1864186464,
     "Q3_K_M": 1725577824,
     "Q3_K_S": 1566816864,
     "Q4_0": 1984608864,
     "Q4_1": 2181216864,
     "Q4_K_M": 2099501664,
     "Q4_K_S": 1998371424,
     "Q5_0": 2377824864,
     "Q5_1": 2574432864,
     "Q5_K_M": 2437012064,
     "Q5_K_S": 2377824864,
     "Q6_K": 2795616864,
     "Q8_0": 3619691104,
     "BF16": 6809655904
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "ibm-granite/granite-4.1-3b-GGUF",
     "kv": "match",
     "ours": 81920,
     "theirs": 81920
    }
   },
   "about": {
    "inputs": [
     "text"
    ],
    "tools": true
   }
  },
  "qwen3-vl-30b-a3b": {
   "name": "Qwen3-VL 30B-A3B",
   "repo": "Qwen/Qwen3-VL-30B-A3B-Instruct",
   "lab": "qwen",
   "params": 31.1,
   "released": "2025-09-30",
   "license": "apache-2.0",
   "hf": {
    "likes": 627,
    "downloads": 441260
   },
   "ollama": {
    "name": "qwen3-vl",
    "tag": "30b",
    "pulls": 6980607,
    "sizes": [
     "2b",
     "4b",
     "8b",
     "30b",
     "32b",
     "235b"
    ],
    "bytes": 19595386752,
    "quant": "Q4_K_M"
   },
   "engines": {
    "arch": "Qwen3VLMoeForConditionalGeneration",
    "recipe": "https://recipes.vllm.ai/Qwen/Qwen3-VL-30B-A3B-Instruct",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true,
    "mlxRepo": "lmstudio-community/Qwen3-VL-30B-A3B-Instruct-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "unsloth/Qwen3-VL-30B-A3B-Instruct-GGUF",
    "files": {
     "BF16": 61095804576,
     "IQ4_NL": 17310783200,
     "IQ4_XS": 16378074848,
     "Q2_K": 11258611424,
     "Q2_K_L": 11331540704,
     "Q3_K_M": 14711848672,
     "Q3_K_S": 13292469984,
     "Q4_0": 17379989216,
     "Q4_1": 19192501984,
     "Q4_K_M": 18556688096,
     "Q4_K_S": 17456010976,
     "Q5_K_M": 21725583072,
     "Q5_K_S": 21080512224,
     "Q6_K": 25092533984,
     "Q8_0": 32483933920,
     "UD-IQ1_M": 9666860768,
     "UD-IQ1_S": 9088194272,
     "UD-IQ2_M": 10845132512,
     "UD-IQ2_XXS": 10341816032,
     "UD-IQ3_XXS": 12888086240,
     "UD-Q2_K_XL": 11787540192,
     "UD-Q3_K_XL": 13833049824,
     "UD-Q4_K_XL": 17715664608,
     "UD-Q5_K_XL": 21740304096,
     "UD-Q6_K_XL": 26340327136,
     "UD-Q8_K_XL": 35989946080,
     "UD-TQ1_0": 8161777376
    }
   },
   "apis": {
    "checked": "2026-11-03",
    "providers": [
     {
      "name": "DeepInfra",
      "input": 0.15,
      "output": 0.6,
      "tps": 40,
      "ttftMs": 492,
      "context": 262144
     },
     {
      "name": "Novita",
      "input": 0.2,
      "output": 0.7,
      "tps": 39,
      "ttftMs": 761,
      "context": 131072
     }
    ]
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "unsloth/Qwen3-VL-30B-A3B-Instruct-GGUF",
     "kv": "match",
     "ours": 98304,
     "theirs": 98304
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "sampling": {
     "source": "generation_config",
     "temperature": 0.7,
     "topP": 0.8,
     "topK": 20
    },
    "papers": [
     {
      "id": "2505.09388",
      "title": "Qwen3 Technical Report",
      "date": "2025-05-14"
     },
     {
      "id": "2502.13923",
      "title": "Qwen2.5-VL Technical Report",
      "date": "2025-02-19"
     },
     {
      "id": "2409.12191",
      "title": "Qwen2-VL: Enhancing Vision-Language Model's Perception of the World at Any Resolution",
      "date": "2024-09-18"
     }
    ],
    "cutoff": "2025-03-31",
    "cutoffFrom": "openrouter",
    "training": {
     "name": "Qwen3-VL-30B-A3B",
     "flop": 6.87006e+23,
     "tokens": 2167000000000,
     "confidence": "Likely"
    }
   }
  },
  "mage-vl-cowork": {
   "name": "Mage-VL-Cowork",
   "repo": "microsoft/Mage-VL-Cowork",
   "lab": "microsoft",
   "params": 4.7,
   "released": "2026-10-30",
   "license": "apache-2.0",
   "hf": {
    "likes": 149,
    "downloads": 1541
   },
   "engines": {
    "mlx": false,
    "mlxRepo": "pratikgx/Mage-VL-Cowork-MLX-4bit"
   },
   "ggufFiles": {
    "repo": "Hansda/Mage-VL-Cowork-GGUF",
    "files": {
     "Q2_K": 1797135456,
     "Q3_K_M": 2242757216,
     "Q4_K_M": 2716078176,
     "Q6_K": 3625336416,
     "Q8_0": 4693680736
    }
   },
   "verified": {
    "gguf": {
     "day": "2026-11-03",
     "repo": "Hansda/Mage-VL-Cowork-GGUF",
     "kv": "match",
     "ours": 147456,
     "theirs": 147456
    }
   },
   "about": {
    "inputs": [
     "text",
     "image",
     "video"
    ],
    "tools": true,
    "thinking": "toggle",
    "switch": "enable_thinking",
    "languages": [
     "en"
    ]
   }
  },
  "spark-x2.6-1.7b": {
   "name": "Spark-X2.6 1.7B",
   "repo": "XHToken/Spark-X2.6-1.7B",
   "lab": "xhtoken",
   "params": 1.7,
   "released": "2026-10-27",
   "license": "apache-2.0",
   "hf": {
    "likes": 72,
    "downloads": 2687
   },
   "modelscope": "XHToken/Spark-X2.6-1.7B",
   "engines": {
    "arch": "Spark2_5ForCausalLM",
    "vllm": false,
    "llamacpp": true,
    "vllmCard": true,
    "sglang": true,
    "mlxRepo": "hermitdave/Spark-X2.6-1.7B-MLX-slq-4.5bpw"
   },
   "ggufFiles": {
    "repo": "mradermacher/Spark-X2.6-1.7B-i1-GGUF",
    "files": {
     "IQ1_M": 574821664,
     "IQ1_S": 548932384,
     "IQ2_M": 711346976,
     "IQ2_S": 676827936,
     "IQ2_XS": 656159520,
     "IQ2_XXS": 617970464,
     "IQ3_M": 888844064,
     "IQ3_S": 867815200,
     "IQ3_XS": 840978208,
     "IQ3_XXS": 778468128,
     "IQ4_NL": 1057570080,
     "IQ4_XS": 1018103072,
     "Q2_K": 790239520,
     "Q2_K_S": 749132064,
     "Q3_K_L": 1018515232,
     "Q3_K_M": 937381664,
     "Q3_K_S": 844418848,
     "Q4_0": 1038105888,
     "Q4_1": 1125494048,
     "Q4_K_M": 1107459360,
     "Q4_K_S": 1043807520,
     "Q5_K_M": 1252482336,
     "Q5_K_S": 1215438112,
     "Q6_K": 1406569248
    }
   }
  },
  "deepseek-ai/DeepSeek-V4.1-Flash-1017": {
   "name": "DeepSeek V4.1 Flash",
   "repo": "deepseek-ai/DeepSeek-V4.1-Flash-1017",
   "lab": "deepseek-ai",
   "params": 763.2,
   "released": "2026-10-17",
   "license": "mit",
   "hf": {
    "likes": 4793,
    "downloads": 187260
   },
   "modelscope": "deepseek-ai/DeepSeek-V4.1-Flash-1017",
   "engines": {
    "arch": "DeepseekV41ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": false,
    "mlx": true
   }
  },
  "sensenova/SenseNova-Loop-9B-Preview": {
   "name": "Loop 9B-Preview",
   "repo": "sensenova/SenseNova-Loop-9B-Preview",
   "lab": "sensenova",
   "params": 9.7,
   "released": "2026-10-28",
   "license": "apache-2.0",
   "hf": {
    "likes": 197,
    "downloads": 2221
   },
   "engines": {
    "arch": "SenseNovaLoopForConditionalGeneration",
    "vllm": false,
    "llamacpp": false,
    "gguf": {
     "repo": "notfakerv/SenseNova-Loop-9B-Preview-GGUF",
     "arch": "sensenova_loop",
     "llamacpp": false
    },
    "sglang": false,
    "mlx": false
   },
   "ggufFiles": {
    "repo": "guideboardlabs/SenseNova-Loop-9B-Preview-GGUF",
    "files": {
     "Q3_K_M": 4642406560,
     "Q4_0": 5325947040,
     "Q4_K_M": 5628723360
    }
   }
  },
  "xiaomi-research/Xiaomi-OCR-0": {
   "name": "Xiaomi-OCR-0",
   "repo": "xiaomi-research/Xiaomi-OCR-0",
   "lab": "xiaomi-research",
   "params": 0.9,
   "released": "2026-09-29",
   "license": "apache-2.0",
   "parent": "Qwen/Qwen3.5-0.8B-Base",
   "hf": {
    "likes": 253,
    "downloads": 20802
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "prithivMLmods/Xiaomi-OCR-0-GGUF",
    "files": {
     "BF16": 1516744960,
     "Q3_K_L": 491323136,
     "Q3_K_M": 466222848,
     "Q4_K_M": 529297664,
     "Q4_K_S": 505254144,
     "Q5_K_M": 577999104,
     "Q5_K_S": 563654912,
     "Q6_K": 629744384
    }
   }
  },
  "divagr1925/Qwen3.5-4B-Qwenputer": {
   "name": "Qwen3.5 4B-Qwenputer",
   "repo": "divagr1925/Qwen3.5-4B-Qwenputer",
   "lab": "divagr1925",
   "params": 9.4,
   "released": "2026-10-19",
   "license": "apache-2.0",
   "parent": "Qwen/Qwen3.5-4B",
   "hf": {
    "likes": 144,
    "downloads": 1229
   },
   "engines": {
    "arch": "Qwen3_5ForCausalLM",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": false
   }
  },
  "LiquidAI/LFM3-1.7B-Base": {
   "name": "LFM3 1.7B-Base",
   "repo": "LiquidAI/LFM3-1.7B-Base",
   "lab": "liquidai",
   "params": 1.7,
   "released": "2026-10-26",
   "license": "other",
   "licenseName": "lfm1.0",
   "hf": {
    "likes": 139,
    "downloads": 5266
   },
   "engines": {
    "arch": "Lfm3ForCausalLM",
    "vllm": false,
    "llamacpp": true,
    "sglang": false,
    "mlx": false,
    "mlxRepo": "alexwengg/LFM3-1.7B-Base-MLX-mixed-5-6-8"
   },
   "ggufFiles": {
    "repo": "Harsha001/LFM3-1.7B-Base-ROCmFPX",
    "files": {
     "Q4_K_M": 1099627744,
     "Q6_K_ROCMFPX": 1429957728,
     "Q8_0": 1846238432
    }
   }
  },
  "sensenova/SenseNova-6.8-Code2Video": {
   "name": "6.8-Code2Video",
   "repo": "sensenova/SenseNova-6.8-Code2Video",
   "lab": "sensenova",
   "params": 27.4,
   "released": "2026-10-24",
   "license": "apache-2.0",
   "hf": {
    "likes": 89,
    "downloads": 770
   },
   "engines": {
    "arch": "Qwen3_5ForConditionalGeneration",
    "vllm": true,
    "llamacpp": true,
    "sglang": true,
    "mlx": true
   },
   "ggufFiles": {
    "repo": "bartowski/sensenova_SenseNova-6.8-Code2Video-GGUF",
    "files": {
     "IQ2_M": 10283265248,
     "IQ2_S": 9445059808,
     "IQ2_XS": 8849542368,
     "IQ2_XXS": 8642284768,
     "IQ3_M": 14621646048,
     "IQ3_XS": 12560620768,
     "IQ3_XXS": 12081183968,
     "IQ4_NL": 17203416288,
     "IQ4_XS": 15236967648,
     "Q2_K": 10582559968,
     "Q3_K_L": 13883833568,
     "Q3_K_M": 13165067488,
     "Q3_K_S": 12500901088,
     "Q4_0": 16109784288,
     "Q4_1": 17586474208,
     "Q4_K_L": 18581720288,
     "Q4_K_M": 17203416288,
     "Q4_K_S": 16124529888,
     "Q5_K_M": 20684893408,
     "Q5_K_S": 19327929568,
     "Q6_K": 23621582048,
     "Q6_K_L": 24719924448,
     "Q6_K_S": 22618471648,
     "Q8_0": 28665068768,
     "BF16": 53808282720
    }
   }
  },
  "ollama:mistral": {
   "name": "mistral",
   "lab": "mistralai",
   "ollama": {
    "name": "mistral",
    "pulls": 34088035,
    "sizes": [
     "7b"
    ]
   }
  },
  "ollama:phi3": {
   "name": "phi3",
   "lab": "microsoft",
   "ollama": {
    "name": "phi3",
    "pulls": 18326160,
    "sizes": [
     "3.8b",
     "14b"
    ]
   }
  },
  "ollama:llava": {
   "name": "llava",
   "ollama": {
    "name": "llava",
    "pulls": 15294288,
    "sizes": [
     "7b",
     "13b",
     "34b"
    ]
   }
  }
 },
 "rankings": {
  "huggingface": [
   "lfm3-1.7b",
   "deepseek-ai/DeepSeek-V4.1-Flash-1017",
   "unlimited-ocr-2",
   "qwen3.8-27b",
   "nanbeige4.3-33b",
   "clover-35b-a3b-preview",
   "lfm3-vl-2b",
   "sensenova/SenseNova-Loop-9B-Preview",
   "flint",
   "xiaomi-research/Xiaomi-OCR-0",
   "d1-2b",
   "spark-x2.6-4b",
   "divagr1925/Qwen3.5-4B-Qwenputer",
   "mage-vl-cowork",
   "LiquidAI/LFM3-1.7B-Base",
   "qwen3.8-flash-next",
   "minicpm-ocr-1.0",
   "sensenova/SenseNova-6.8-Code2Video",
   "minimax-m3.1-flash",
   "spark-x2.6-1.7b"
  ],
  "ollama": [
   "llama-3.1-8b",
   "deepseek-r1",
   "llama-3.2-3b",
   "qwen2.5-7b",
   "qwen3-32b",
   "gemma-3-4b",
   "gemma-2-9b",
   "ollama:mistral",
   "gemma-4-12b",
   "llama-3-8b",
   "qwen3.5-4b",
   "qwen2.5-coder-7b",
   "ollama:phi3",
   "ollama:llava",
   "gpt-oss-20b"
  ]
 },
 "sources": {
  "hf-trending": "2026-11-03T13:04:05.817Z",
  "modelscope": "2026-11-03T13:04:05.817Z",
  "epoch": "2026-11-03T00:08:16.164Z",
  "hf-models-old": "2026-10-07T20:20:22.358Z",
  "ollama": "2026-11-03T00:08:16.164Z",
  "vllm": "2026-11-03T00:08:16.164Z",
  "llamacpp-old": "2026-10-07T19:21:58.697Z",
  "recipes": "2026-11-03T00:08:16.164Z",
  "openrouter": "2026-11-03T13:04:05.817Z",
  "llamacpp": "2026-11-03T00:08:16.164Z",
  "llamacpp-gguf": "2026-11-03T00:08:16.164Z",
  "hf-models": "2026-11-03T00:08:16.164Z",
  "sglang": "2026-11-03T00:08:16.164Z",
  "mlx": "2026-11-03T00:08:16.164Z",
  "popular": "2026-11-03T00:08:16.164Z",
  "epoch-eci": "2026-11-03T00:08:16.164Z",
  "strata": "2026-11-03T00:08:16.164Z",
  "inferencex": "2026-11-03T00:08:16.164Z",
  "ollama-builds": "2026-11-03T00:08:16.164Z",
  "hf-router": "2026-11-03T00:08:16.164Z",
  "epoch-hardware": "2026-10-28T04:04:40.765Z",
  "llamacpp-boards": "2026-10-14T07:23:43.662Z",
  "epoch-training": "2026-11-03T00:08:16.164Z"
 },
 "accuracy": {
  "checked": "2026-11-03",
  "runs": 141,
  "weightsPct": 1.3,
  "kvPct": 1.9,
  "speedPct": 13.9
 }
}
